import React, { useState, useEffect, useCallback, createContext, useContext,useRef } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { Typography,RadioGroup, Radio,Switch, FormHelperText } from "@mui/material";
import MonitoraggioDPP from './MonitoraggioDPP';
import ProvenienzaRisorse from './ProvenienzaRisorse';
import ProvenienzaRisorse2026 from './ProvenienzaRisorse2026';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FormLabel from '@mui/material/FormLabel';
import InventoryIcon from '@mui/icons-material/Inventory';
import ListAltIcon from '@mui/icons-material/ListAlt';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WidgetsIcon from '@mui/icons-material/Widgets';
import SummarizeIcon from '@mui/icons-material/Summarize';
import {properties} from "../../utils/properties";
import cultura from '../../assets/cultura.png';
import persone from '../../assets/persone.png';
import { useNavigate } from "react-router-dom";
import pianeta from '../../assets/pianeta.png';
import altro from '../../assets/altro.png';
import sacco from '../../assets/sacco.png';
import direzioni from '../../assets/direzioni.png';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { useParams } from "react-router-dom";
import {ThreeDots} from 'react-loader-spinner';
import { encode } from 'js-base64';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import InputLabel from '@mui/material/InputLabel';
import {MenuItem as MenuItemMUI} from '@mui/material';
import {Menu as MenuMUI} from '@mui/material';
import {FormControl,Box} from '@mui/material';
import Select from '@mui/material/Select';
import LockIcon from '@mui/icons-material/Lock';
import WarningIcon from '@mui/icons-material/Warning';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EngineeringIcon from '@mui/icons-material/Engineering';
import LockClockIcon from '@mui/icons-material/LockClock';
import VpnLockIcon from '@mui/icons-material/VpnLock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol';
import PrintIcon from '@mui/icons-material/Print';
import VpnKeyOffIcon from '@mui/icons-material/VpnKeyOff';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import Filter2Icon from '@mui/icons-material/Filter2';
import Filter3Icon from '@mui/icons-material/Filter3';
import FilterIcon from '@mui/icons-material/Filter';
import AbcIcon from '@mui/icons-material/Abc';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import LocalParkingIcon from '@mui/icons-material/LocalParking';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import Grow from '@mui/material/Grow';


import {
    SimpleTreeItemWrapper,
    SortableTree,
    //FolderTreeItemWrapper,    
  } from 'dnd-kit-sortable-tree';
import { IndexProvider } from "../../context/IndexContext";

import SweetAlert from "react-bootstrap-sweetalert";
import './bootstrap-custom.css';
import { ConstructionOutlined } from "@mui/icons-material";
import ConstructionIcon from '@mui/icons-material/Construction';

//find . -type f -name "*.json" -exec sed -i "s/4\. Priorit\\\\u00e0 Tematiche prevalenti/4. Priorit\\\\u00e0 Tematica prevalente/g" {} +
//find . -type f -exec sed -i 's/4. Priorità Tematiche/4. Priorità Tematiche prevalenti/g' {} +
//idem da fare per 7.Tipo/Attributi di progetto     

const SortableContext = createContext();

export default function IndiceGSF() {
    let { idSeduta } = useParams();   
    const dataSeduta = idSeduta ;
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);            
    const [secondLevelButtons, setSecondLevelButtons]= useState(false);      
    const [forthLevelButtons, setForthLevelButtons]= useState(false);      
    const [showButtons, setShowButtons]= useState(true);                      
    const [dialogPratica, setDialogPratica] = useState(false);      
    const [dialogMovePratica, setDialogMovePratica] = useState(false);        
    const [dialogAmbito, setDialogAmbito] = useState(false);        
    const [dialogMoveAmbito, setDialogMoveAmbito] = useState(false);        
    const [dialogDocumento, setDialogDocumento] = useState(false);        
    const [dialogMoveDocumento, setDialogMoveDocumento] = useState(false);        
    const [item, setItem] = useState([]);    
    const [itemChanged, setItemChanged] = useState(false);             
    const [menuLocked, setMenuLocked] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);             
    const [menuItemSelected, setMenuItemSelected] = useState(-1);             
    const [colorItemSelected, setColorItemSelected] = useState("#E42568");             
    const [printable, setPrintable] = useState("Cultura");          
    const [mingrantAvailable, setMingrantAvailable] = useState(false);             
    const [sector, setSector] = useState("cultura");             
    const [totaleObiettivi, setTotaleObiettivi] = useState(["€ 0.00","€ 0.00","€ 0.00"]);                 
    const [movedSector, setMovedSector] = useState('');
    const [alert1, setAlert1] = useState(null);
    const [checkboxState, setCheckboxState] = useState([true,false,false,false,false,false,false,false,false]);
    const [dynamicFields, setDynamicFields] = useState([[],[],[],[],[],[],[],[],[]]);

    const [enabledAdditionalRadioButton, setEnabledAdditionalRadioButton] = useState(false);
    const [disabledFattoriChiave, setDisabledFattoriChiave] = useState(false);
        
    //PER MENU
    const [anchorEl, setAnchorEl] = React.useState(null);
    const openMenu = Boolean(anchorEl);
    const handleClickOpenMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };

    //const [rischioLevel, setRischioLevel] = useState({});

    //let optionsMissioni =[];
    //DA ABILITARE PER AVERNE UNO SOLO DEI DUE vedi 20250500 come condizione
    /*
    const optionsMissioniPre = [
      "Cultura","Attrattività","Competenze","Custodia","Partecipazione","Persone","Abitare","Lavoro","Educazione",
      "Comunità","Inclusione","Pianeta","Ricerca","Innovazione","Benessere","Internazionalizzazione","Ambiente",
      "Direzione pianificazione, studi e valutazione","Direzione innovazione di impatto"]; 
    const optionsMissioniPost = [
        "Cultura","Attrattività","Competenze","Custodia","Partecipazione","Persone","Abitare","Lavoro","Educazione",
        "Comunità","Inclusione","Pianeta","Ricerca","Innovazione","Benessere","Sviluppo Territorio","Ambiente",
        "Direzione pianificazione, studi e valutazione","Direzione innovazione di impatto"]; 
      */
    const optionsMissioniBoth = [
        "Cultura","Attrattività","Competenze","Custodia","Partecipazione","Persone","Abitare","Lavoro","Educazione",
        "Comunità","Inclusione","Pianeta","Ricerca","Innovazione","Benessere","Internazionalizzazione","Sviluppo Territorio","Ambiente",
        "Direzione pianificazione, studi e valutazione","Direzione innovazione di impatto"]; 

    const optionsMissioniBoth2026 = [
        "Attrattività","Competenze","Custodia","Partecipazione","Abitare","Lavoro","Educazione",
        "Comunità","Inclusione","Ricerca","Innovazione","Benessere","Sviluppo Territorio","Ambiente",
        "Direzione Learning","PAAS"];     

    //const optionsMissioni = [
    //"Cultura","Attrattività","Competenze","Custodia","Partecipazione","Persone","Abitare","Lavoro","Educazione",
    //"Comunità","Inclusione","Pianeta","Ricerca","Innovazione","Benessere","Internazionalizzazione","Ambiente",
    //"Direzione pianificazione, studi e valutazione","Direzione innovazione di impatto"];


    //const optionsTesoretto = ["Bando per lo Sviluppo Organizzativo", "Bando Next Generation We", "Altre Iniziative", "Recupero 2021-2022-2023 Obiettivo Cultura","Recupero 2021-2022-2023 Obiettivo Persone","Recupero 2021-2022-2023 Obiettivo Pianeta", "Recuperi 2023 DPSV" ];
    //const optionsTesoretto = ["Bando per lo Sviluppo Organizzativo", "Bando Next Generation We", "fondi in attesa di destinazione", "riassorbimenti Obiettivo Cultura","riassorbimenti Obiettivo Persone","riassorbimenti Obiettivo Pianeta" ];
    const optionsTesoretto = [ "fondi in attesa di destinazione", "riassorbimenti Obiettivo Cultura","riassorbimenti Obiettivo Persone","riassorbimenti Obiettivo Pianeta" ];
    const optionsTesoretto2026 = [ "Fondi in attesa di destinazione", "Riassorbimenti", "Sperimentazione e attuazione del Piano Strategico" ];
    const optionsLasciti = ["Lascito Cornaglia", "Lascito Noelli Ziviani", "Lascito Manerba", "Lascito Manera", "Lascito Molo", "Lascito Chiaberge", "Lascito Ferraioli", "Lascito Baldovino", "Lascito Talea", "Fondo Persone", "Lascito Silvia Ranno","Fondo Pozzi Selvaggio"];
    
    //const hiddenFileUpload = React.useRef(null);
    const hiddenFileUploads = React.useRef({});

    const handleOpenClick= (event, props) => {        
      console.log("ID",localStorage.getItem("IndiceId"))
      //var url=properties.productionUrl+"/fileManager/files/premesse/"+idDossier+"/"+name;        
      console.log(props);
      var url=properties.productionUrl+"/fileManager/files/premesse/"+localStorage.getItem("IndiceId")+"/"+props.item.filePath;        
      console.log("URL",url);
      window.open(url+"?dt="+(new Date()).getTime());        
  }
    const onFileChange2= (e, props ) => {   
      const idSeduta= getIdSedutaGSF();
      console.log("ew2",e, props.item.Descrizione,props.item.id);
      if (!loading) { setLoading(true);} 
      e.stopPropagation();                     
      let endpoint = properties.productionUrl+properties.productionUrlSuffix +"/core/rest/caricaPremessa.php";   
      let file=e.target.files[0];
      var bodyFormData=new FormData();
      //if( properties.verboseLog==1)
      //    console.log("cire",file);
      bodyFormData.append('UploadedFile', file);
      bodyFormData.append('fileName', file.name);      
      bodyFormData.append('data', idSeduta);
      
      
      axios({
          method: 'post',
          url: endpoint,
          data: bodyFormData, 
          withCredentials: true, 
          headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(function (response) {                    
          setLoading(false);                              
          let item2= props.item;            
          //item2.filePath=idSeduta+"/"+response.data.fileName;                    
          item2.filePath=response.data.fileName;                    
          console.log("EEEEEEEEEEEEHHHHHH",response, file.name, file,item2);
          doPostUpdateMinimal(item2);                             
      })
      .catch(function (response) {            
          console.log("ERRORE1",response);
      });
      
  };

  
    const handleUploadPremessaGSFClick = (event, props) => {                    
      console.log("passing2",event,props);    
      //hiddenFileUpload.current.files=null;

      hiddenFileUploads.current[props.item.id].files=null;
      hiddenFileUploads.current[props.item.id].click();
      //hiddenFileUpload.current.click();
  };

    const handleRischioRadioChange = (label, value) => {
      console.log("RR", value,label); //RR 2 2. Concetti chiave
      setScelteDPP(prev => ({
        ...prev,
        [label]: {
          ...prev[label],
          "Rischio": value
        }
      }));
      setItemChanged(true);
      /*setRischioLevel((prev) => ({
        ...prev,
        [label]: value
      }));*/
      console.log("DE1",scelteDPP);
    };

    const handleImpattoSelectChange = (label, value) => {
      console.log("HH1", value, value.label);
      console.log("HH2", label);
      //console.log("DE1",scelteDPP);
      /*setScelteDPP(prev => ({
        ...prev,
        ["100. Progetti a impatto"]: {
          ...(prev["100. Progetti a impatto"] || {}),
          ["Nessuno"]: value.label
        }
      }));*/
      setScelteDPP(prev => ({
        ...prev,
        ["100. Progetti a impatto"]:  value.label        
      }));


      setItemChanged(true);
      console.log("DE3",scelteDPP);
    };
    
/*
    const handleImpattoSelectChange = (label, value) => {
      console.log("HH1", value, value.label);
      console.log("HH2", label);
      //console.log("DE1",scelteDPP);
      setScelteDPP(prev => ({
        ...prev,
        [label]: {
          ...prev[label],
          "Progetti a impatto": value.value
        }
      }));
      setItemChanged(true);
      console.log("DE2",scelteDPP);
    };
*/
    const handleCheckboxChange = (pos, event) => {
      //const { name, checked } = event.target;
      const checked =event.target.checked;
      //if( properties.verboseLog==1)
        console.log("CC",pos, checked,dynamicFields,checkboxState);
        
      setCheckboxState((prev) => ({ ...prev, [pos]: checked }));
      console.log("CC1");
      setItemChanged(true);
      console.log("CC2");
      if (!checked) {
        setDynamicFields((prev) => ({ ...prev, [pos]: [] })); 
      }
      console.log("CC3");
    };

    function getVirtualNote(dynamicFieldsT, ipotesiInterventoT) {
      if( properties.verboseLog==1){
      console.log("1",dynamicFieldsT);
      console.log("2",ipotesiInterventoT);
      }
      let a=calculateVirtualNote(dynamicFieldsT);
      let b="€ "+Euro.format(ipotesiInterventoT);
      if( properties.verboseLog==1){
      console.log("3",a);
      console.log("4",b);
      }
      let answer="";
      if (Object.keys(a).length !== 0) {              
        if( properties.verboseLog==1)
          console.log("ECCO",b,a);
        //let answer="di cui";
        
        let allIn=false;
        if( properties.verboseLog==1)
          console.log("TTRE",Object.keys(a).length, a);
        if(Object.keys(a).length==9){
            if(a[0].startsWith(b)|| a[1].startsWith(b)|| a[2].startsWith(b)|| a[3].startsWith(b)|| a[4].startsWith(b)||a[5].startsWith(b)||a[6].startsWith(b)||a[7].startsWith(b)||a[8].startsWith(b)){            
                //tutto in un elemento solo non serve il di cui
                if( properties.verboseLog==1)
                  console.log("TUTTO IN 9");
                allIn=true;
                answer="";
            }
            if(a[0]=='' && a[1]==''&& a[2]==''&& a[3]==''&& a[4]==''&& a[5]==''&& a[6]==''&& a[7]==''&& a[8]==''){            
                //non c'è split -> non serve di cui
                if( properties.verboseLog==1)
                  console.log("NO SPLIT 9");
                answer="";
            }
          }
        else if(Object.keys(a).length==8){
          if(a[0].startsWith(b)|| a[1].startsWith(b)|| a[2].startsWith(b)|| a[3].startsWith(b)|| a[4].startsWith(b)||a[5].startsWith(b)||a[6].startsWith(b)||a[7].startsWith(b)){            
              //tutto in un elemento solo non serve il di cui
              if( properties.verboseLog==1)
                console.log("TUTTO IN 8");
              allIn=true;
              answer="";
          }
          if(a[0]=='' && a[1]==''&& a[2]==''&& a[3]==''&& a[4]==''&& a[5]==''&& a[6]==''&& a[7]==''){            
              //non c'è split -> non serve di cui
              if( properties.verboseLog==1)
                console.log("NO SPLIT 8");
              answer="";
          }
        }
        else if(Object.keys(a).length==6){
          if(a[0].startsWith(b)|| a[1].startsWith(b)|| a[2].startsWith(b)|| a[3].startsWith(b)|| a[4].startsWith(b)||a[5].startsWith(b)){          
            //tutto in un elemento solo non serve il di cui
            //if( properties.verboseLog==1)
              console.log("TUTTO IN");
            allIn=true;
            answer="";
          }
          if(a[0]=='' && a[1]==''&& a[2]==''&& a[3]==''&& a[4]==''&& a[5]==''){            
            //non c'è split -> non serve di cui
            if( properties.verboseLog==1)
              console.log("NO SPLIT");
            answer="";
          }
        }
        else{
          if(a[0].startsWith(b)|| a[1].startsWith(b)|| a[2].startsWith(b)|| a[3].startsWith(b)|| a[4].startsWith(b)){
            //tutto in un elemento solo non serve il di cui
            if( properties.verboseLog==1)
              console.log("TUTTO IN");
            allIn=true;
            answer="";
          }
          if(a[0]=='' && a[1]==''&& a[2]==''&& a[3]==''&& a[4]==''){
            //non c'è split -> non serve di cui
            if( properties.verboseLog==1)
              console.log("NO SPLIT");
            answer="";
          }
        }
       
        let counterNotEmpty=0;      
        //for(var i=0; i<6; i++){
          //console.log("TREDI",a.length);
        for(var i=0;i<Object.keys(a).length;i++){
          //console.log(a[i]);
          if(a[i]!='')
            counterNotEmpty=counterNotEmpty+1;
        }
        //console.log("COUNTER",counterNotEmpty);
        if(allIn){
          //for(var i=0;i<6;i++){
            for(var i=0;i<Object.keys(a).length;i++){
              if( properties.verboseLog==1)
                console.log("I",a[i],i);
              if(a[i]!=''){
                //if(i==0) // Risorse anno
                  //answer= "Risorse"+a[i].substring(a[i].indexOf(" provenienti"));
                  //answer= "Risorse"+a[i].substring(a[i].indexOf(" a valere"));                
                //if(i==0 || i==1 ||i==2||i==3) {// Altro
                if(i==0 || i==1 ||i==2||i==3||i==6||i==7) {// Altro
                  //answer= "Risorse"+a[i].substring(a[i].indexOf(" a valere"));                
                  answer= a[i].substring(a[i].indexOf(" a valere"));                
                  //console.log("AISUMA",answer)
                }
                if(i==4 ||i==5 ||i==8) // credito d'imposta o lasciti e donazioni o piano strategico
                  answer= "Fondi"+a[i].substring(a[i].indexOf(" derivanti"));
            }
          }
        }
        else{              
          //for(var i=0;i<6;i++){
          for(var i=0;i<Object.keys(a).length;i++){
            if(a[i]!=''){
              answer=answer+ " "+a[i];
              counterNotEmpty-=1;
              if(counterNotEmpty!=0)
                answer=answer+",";
            }
          }
        }
        //console.log("Final Note",answer);
      }
      return answer
    }

    function calculateVirtualNote(obj) {
      if( properties.verboseLog==1)
        console.log("CALCULATE VIRTUAL NOTE", obj)
      const year=data.Seduta.split("/")[2];      
      //let virtualNote="";          
      //console.log("CVN",obj);
      const sumsByIndex = {};
      if(obj!=undefined){      
        Object.keys(obj).forEach((key) => {          
          let partialNote = "";              
          const itemList = obj[key];
          //console.log("CVN2",itemList,key);

          //if(itemList)
          /*if (Object.keys(itemList).length !== 0) 
            console.log("DIVERSO");
          else
            console.log("UGUALE");*/
          itemList.forEach((item) => {        
            if(item.origineValue!=null){
              if(key==0){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  //partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " provenienti da fondi dell'anno "+ item.origineValue;
                  if(item.origineValue.startsWith("Direzione")||item.origineValue.startsWith("direzione"))
                    partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere sul budget "+year+ " "+ item.origineValue;
                  else
                    partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere sul budget "+year+ " Missione "+ item.origineValue;
                }
              }
              if(key==1){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere su fondi accantonati nel CdG del "+ item.dataSedutaValue +" ("+item.numeroPraticaValue+" )";
                }
              }
              if(key==2){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";      
                  
                  var valTBU = item.origineValue.replaceAll("riassorbimenti#","riassorbimenti Obiettivo ");        
                  valTBU = valTBU.replaceAll("fondi in attesa di destinazione#","fondi in attesa di destinazione Missione ");                  
                  valTBU = valTBU.replaceAll("Riassorbimenti#","Riassorbimenti Obiettivo ");        
                  valTBU = valTBU.replaceAll("Fondi in attesa di destinazione#","Fondi in attesa di destinazione Missione ");
                  valTBU = valTBU.replaceAll("Missione Direzione","Direzione");
                  //valTBU = valTBU.replaceAll("Missione Direzione","Direzione");

                  //partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere su "+ item.origineValue;
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere su "+ valTBU;
                }
              }
              if(key==3){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere sui fondi per le erogazioni ex art. 1 comma 44 della Legge 178/2020";
                }            
              }
              if(key==4){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " derivanti da credito d'imposta dell'anno";
                }            
              }
              if(key==5){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " derivanti da Lasciti e Donazioni - "+ item.origineValue;
                }            
              }
              if(key==6 || key==7){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere sui fondi in attesa di destinazione prenotati nella seduta del CdG del "+item.dataSedutaValue+ " - Missione "+ item.origineValue;
                }            
              }
              if(key==8){
                if (item.importoValue) {
                  //console.log("B",item.importoValue);
                  if(partialNote!="")
                    partialNote=partialNote+", ";              
                  partialNote =partialNote+ "€ "+Euro.format(parseFloat(item.importoValue.replace(/\./g, "").replace(",", ".")))+ " a valere sui fondi Sperimentazione e attuazione del Piano Strategico";
                }            
              }     
            }       
          });     
                 
          sumsByIndex[key] = partialNote;    
          if( properties.verboseLog==1)  
            console.log("ERP",key, sumsByIndex[key])      ;
          //console.log(`[${key}] sum = ${partialNote}`);
        });   
      }   
      return sumsByIndex;
    }
    
    function sumDynamicFields(obj) {
      let totale = 0;
      //console.log("called with",obj,Array.isArray(obj),typeof(obj));
      const parseAmount = (value) => {        
        return parseFloat(value.replace(/\./g, "").replace(",", "."));
      };
    
      const explore = (data) => {
        if (Array.isArray(data)) {          
          data.forEach(explore);
        } else if (typeof data === "object" && data !== null) {          
          Object.values(data).forEach(explore);
        } else if (typeof data === "string" && data.match(/^\d/)) {          
          totale += parseAmount(data) || 0;
        }
      };
          
      Object.values(obj).forEach(itemList => {
        itemList.forEach(item => {     
          if (item.importoValue) {
            totale += parseAmount(item.importoValue) || 0;
          }
        });
      });
      //console.log("return",totale);
      return totale;
    }

    const handleAddRow = (optionName) => {
      setItemChanged(true);
      setDynamicFields((prev) => ({
        ...prev,
        [optionName]: [
          ...prev[optionName],
          { origineValue: '', importoValue: '',numeroPraticaValue: '',dataSedutaValue: '' },
        ],
      }));
    };
  
    const handleRemoveRow = (optionName, index) => {
      setItemChanged(true);
      setDynamicFields((prev) => ({
        ...prev,
        [optionName]: prev[optionName].filter((_, i) => i !== index),
      }));
    };
  
    const handleAutocompleteChange = (optionName, index, value) => {
      setItemChanged(true);
      setDynamicFields((prev) => {
        const updatedRows = [...prev[optionName]];
        updatedRows[index].origineValue = value;
        return { ...prev, [optionName]: updatedRows };
      });
    };

    const handleAutocompleteChange2 = (optionName, index, value) => {
      //SOLO PER "IN ATTESA DI DESTINAZIONE" a partire da una certa data
      setItemChanged(true);
      console.log("BIS",dynamicFields[optionName][index].origineValue);
      setDynamicFields((prev) => {
        const updatedRows = [...prev[optionName]];
        console.log("TRIS",updatedRows,optionName, index, value );
        //updatedRows[index].origineValue = value;
        if(!updatedRows[index].origineValue.includes("#"))
          updatedRows[index].origineValue = updatedRows[index].origineValue+ "#"+value;
        else{
          updatedRows[index].origineValue=updatedRows[index].origineValue.substr(updatedRows[index].origineValue.indexOf("#"))+"#"+value; 
        }
        console.log(updatedRows[index].origineValue)
        console.log("POKER",updatedRows,optionName, index, value );
        return { ...prev, [optionName]: updatedRows };
      });
    };

  
    const handleTextFieldChange = (optionName, index, value) => {
      value= value.replace(/[^0-9,]/g, "");
      setItemChanged(true);
      setDynamicFields((prev) => {
        const updatedRows = [...prev[optionName]];
        //updatedRows[index].importoValue = value;
        updatedRows[index].importoValue = value.replace(/\€/g, "");
        return { ...prev, [optionName]: updatedRows };
      });
    };

    const handleTextFieldChange2 = (optionName, index, value) => {
      setItemChanged(true);
      setDynamicFields((prev) => {
        const updatedRows = [...prev[optionName]];
        updatedRows[index].numeroPraticaValue = value;
        return { ...prev, [optionName]: updatedRows };
      });
    };

    const handleTextFieldChange3 = (optionName, index, value) => {
      setItemChanged(true);
      setDynamicFields((prev) => {
        const updatedRows = [...prev[optionName]];
        updatedRows[index].dataSedutaValue = value;
        return { ...prev, [optionName]: updatedRows };
      });
    };

    const canBeSeen = function(indiceObiettivo) {   
      if( properties.verboseLog==1)
        console.log("CBS", indiceObiettivo);
      const a=localStorage.getItem("indice");
      if( properties.verboseLog==1)
        console.log("CBS", indiceObiettivo, a);
      if(a.includes(indiceObiettivo))
        return true;
      else
        return false;
    }

    const getFase = function() {   
      let phase=0;
      if(data.Fase != undefined)
        phase=data.Fase;
      return phase;  
    }

    const getIdSedutaGSF = function() {   
      let idSedutaGSF=801;
      if(data.IdSeduta != undefined)
      idSedutaGSF=data.IdSeduta;
      return idSedutaGSF;  
    }


    const getDataSeduta = function() {         
      return dataSeduta;  
    }

    const checkItem = function(item) {   
      let phase=0;
      if(data.Fase != undefined)
        phase=data.Fase;
        
      if(item.Tipo=="Documento"){
        if( properties.verboseLog==1)
          console.log("CHECK ITEM","Documento",item);
        if (item.Descrizione=="Nuovo Documento"||item.Descrizione.trim()==""){
			    return false;			    
		    }
        /*if(!item.ScelteDPP)
          return false;			    
        if (!validateFormNoSetErrori(item.ScelteDPP)){        
            //console.log("CHECK ITEM","SCELTEDPP FAILED",item);
          return false;			    
        }*/
      }
      if(item.Tipo=="Ambito"){
        if( properties.verboseLog==1)
          console.log("CHECK ITEM","AMBITO",item);
        if (item.Descrizione=="Nuovo Ambito"||item.Descrizione.trim()==""){
			    return false;			    
		    }
      }
      if(item.Tipo=="Pratica" &&phase!=0){
        if( properties.verboseLog==1)
          console.log("CHECK ITEM","PRATICA",item);
        if (item.Ente=="Ente"||item.Ente.trim()==""){
          if( properties.verboseLog==1)
            console.log("CHECK ITEM","ENTE FAILED",item);
			    return false;
		    }
        if (item.IdRichiesta=="ID Pratica"||item.IdRichiesta.trim()==""){
          if( properties.verboseLog==1)
            console.log("CHECK ITEM","ID FAILED",item);
          return false;
		    }
        if (item.Localizzazione=="Localizzazione"||item.Localizzazione.trim()==""){
          if( properties.verboseLog==1)
            console.log("CHECK ITEM","LOC FAILED",item);
			    return false;
		    }
        if (item.Descrizione=="Descrizione"||item.Descrizione.trim()==""){
          if( properties.verboseLog==1)
            console.log("CHECK ITEM","DESC FAILED",item);
			    return false;			    
		    }
        //console.log("WWWWWWWW",item.ScelteDPP);
        if(!item.ScelteDPP)
          return false;			    
        if (!validateFormNoSetErrori(item.ScelteDPP)){
          //if( properties.verboseLog==1)
            //console.log("CHECK ITEM","SCELTEDPP FAILED",item);
			    return false;			    
		    }
      }
      return true;
    }

    const checkAttributo= function( tipo, attributo, valore) {
      if( properties.verboseLog==1)
        console.log("CHECK ATTRIBUTO",tipo, attributo, valore);
      let phase=0;
      if(data.Fase != undefined)
        phase=data.Fase;
            
      if(tipo=="Documento"){        
        if (attributo=="Descrizione"){
          if(valore=="Nuovo Documento"||valore.trim()==""){
			      return false;			    
		      }
        }
      }
      if(tipo=="Ambito"){ 
        if (attributo=="Descrizione"){
          if(valore=="Nuovo Ambito"||valore.trim()==""){
			      return false;			    
		      }
        }
      }
      if(tipo=="Pratica" &&phase!=0){        
        if (attributo=="Ente"){
          if (valore=="Ente"||valore.trim()==""){          
			      return false;
		      }
        }
        if (attributo=="IdRichiesta"||attributo=="idRichiesta"){
          if (valore=="ID Pratica"||valore.trim()==""){     
            return false;
		      }
        }
        if (attributo=="Localizzazione"){
          if (valore=="Localizzazione"||valore.trim()==""){          
			      return false;
		      }
        }
        if (attributo=="Descrizione"){
          if (valore=="Descrizione"||valore.trim()==""){          
			      return false;			    
		      }
        }
      }
      return true;
    }

    const isItemCoerente = function(item) {   
      if( properties.verboseLog==1)
        console.log("IICOERENTE",item,sector,data.Fase);
                        
      if(sector=='cultura'){
        if(menuLocked[0]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='attrattivita'){
        if(menuLocked[1]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='competenze'){
        if(menuLocked[2]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='custodia'){        
        if(menuLocked[3]==3)
          return !checkItem(item);
        else
          return false;
      }

      if(sector=='partecipazione'){
        if(menuLocked[4]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='persone'){
        if(menuLocked[5]==3)
          return !checkItem(item);
        else
          return false;
      }

      if(sector=='abitare'){
        if(menuLocked[6]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='lavoro'){
        if(menuLocked[7]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='educazione'){
        if(menuLocked[8]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='comunita'){
        if(menuLocked[9]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='inclusione'){
        if(menuLocked[10]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='pianeta'){
        if(menuLocked[11]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='ricerca'){
        if(menuLocked[12]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='innovazione'){
        if(menuLocked[13]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='benessere'){
        if(menuLocked[14]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='internazionalizzazione'){
        if(menuLocked[15]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='ambiente'){
        if(menuLocked[16]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='direzione_pianificazione'){
        if(menuLocked[17]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='direzione_innovazione_impatto'){
        if(menuLocked[18]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='convenzioni_progetti_speciali'){
        if(menuLocked[19]==3)
          return !checkItem(item);
        else
          return false;
      }
      if(sector=='sviluppoTerritorio'){
        if(menuLocked[21]==3)
          return !checkItem(item);
        else
          return false;
      }                        
    }

    const isFuoriSacco = function() {    
      if(sector=='fuori_sacco')
        return true;        
      else
        return false;
    }


    const isInEvidenza = function() {    
      if(sector=='in_evidenza')
        return true;        
      else
        return false;
    }


    const isBloccataMissione = function() {    
      
      if( properties.verboseLog==1)
        console.log("IBM",localStorage.getItem("indice"),localStorage.getItem("indice").includes("1"))
      if(sector=='cultura'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }
        if(menuLocked[0]==2 || menuLocked[0]==4 )
          return true;
        else
          return false;
      }

      if(sector=='attrattivita'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }
        if(menuLocked[1]==2 || menuLocked[1]==4)
          return true;
        else
          return false;
      }
      if(sector=='competenze'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }
        if(menuLocked[2]==2 || menuLocked[2]==4)
          return true;
        else
          return false;
      }
      if(sector=='custodia'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }
        if(menuLocked[3]==2 || menuLocked[3]==4)
          return true;
        else
          return false;
      }

      if(sector=='partecipazione'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }
        if(menuLocked[4]==2 || menuLocked[4]==4)
          return true;
        else
          return false;
      }
      if(sector=='persone'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[5]==2 || menuLocked[5]==4)
          return true;
        else
          return false;
      }

      if(sector=='abitare'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[6]==2 || menuLocked[6]==4)
          return true;
        else
          return false;
      }
      if(sector=='lavoro'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[7]==2 || menuLocked[7]==4)
          return true;
        else
          return false;
      }
      if(sector=='educazione'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[8]==2 || menuLocked[8]==4)
          return true;
        else
          return false;
      }
      if(sector=='comunita'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[9]==2 || menuLocked[9]==4)
          return true;
        else
          return false;
      }
      if(sector=='inclusione'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }
        if(menuLocked[10]==2 || menuLocked[10]==4)
          return true;
        else
          return false;
      }
      if(sector=='pianeta'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[11]==2 || menuLocked[11]==4)
          return true;
        else
          return false;
      }
      if(sector=='ricerca'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[12]==2 || menuLocked[12]==4)
          return true;
        else
          return false;
      }
      if(sector=='innovazione'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[13]==2 || menuLocked[13]==4)
          return true;
        else
          return false;
      }
      if(sector=='benessere'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[14]==2 || menuLocked[14]==4)
          return true;
        else
          return false;
      }
      if(sector=='internazionalizzazione'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[15]==2 || menuLocked[15]==4)
          return true;
        else
          return false;
      }
      if(sector=='ambiente'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[16]==2 || menuLocked[16]==4)
          return true;
        else
          return false;
      }
    /* 
      if(sector=='direzione_pianificazione'){
        if(!localStorage.getItem("indice").includes("4")){          
          return true;
        }
        if(menuLocked[17]==2 || menuLocked[17]==4)
          return true;
        else
          return false;
      }
      */
      if(sector=='direzione_innovazione_impatto'){
        if(!localStorage.getItem("indice").includes("5")){          
          return true;
        }
        if(menuLocked[18]==2 || menuLocked[18]==4)
          return true;
        else
          return false;
      }
      if(sector=='convenzioni_progetti_speciali'){
        if(!localStorage.getItem("indice").includes("6")){          
          return true;
        }
        if(menuLocked[19]==2 || menuLocked[19]==4)
          return true;
        else
          return false;
      }   
      if(sector=='fuori_sacco'){
        if(!localStorage.getItem("indice").includes("7")){          
          return true;
        }
        //if(menuLocked[20]==2 || menuLocked[20]==4)
        //  return true;
        //else
          return false;
      }
      if(sector=='sviluppoTerritorio'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }
        if(menuLocked[21]==2 || menuLocked[21]==4)
          return true;
        else
          return false;
      }
      if(sector=='in_evidenza'){        
        if(!localStorage.getItem("indice").includes("6")){          
          return true;
        }  
        if(menuLocked[22]==2 || menuLocked[22]==4)
          return true;
        else
          return false;
      }                               
      return false;
    };

    const isInteragibileMissione = function() {    
      
      if( properties.verboseLog==1)
        console.log("IBM2",localStorage.getItem("indice"),localStorage.getItem("indice").includes("1"))
      if(sector=='cultura'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }        
      }

      if(sector=='attrattivita'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }        
      }
      if(sector=='competenze'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }        
      }
      if(sector=='custodia'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }        
      }

      if(sector=='partecipazione'){
        if(!localStorage.getItem("indice").includes("1")){          
          return true;
        }        
      }
      if(sector=='persone'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }

      if(sector=='abitare'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }
      if(sector=='lavoro'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }
      if(sector=='educazione'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }
      if(sector=='comunita'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }
      if(sector=='inclusione'){
        if(!localStorage.getItem("indice").includes("2")){          
          return true;
        }        
      }
      if(sector=='pianeta'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='ricerca'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='innovazione'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='benessere'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='internazionalizzazione'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='ambiente'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }
      if(sector=='direzione_pianificazione'){
        if(!localStorage.getItem("indice").includes("4")){          
          return true;
        }        
      }
      if(sector=='direzione_innovazione_impatto'){
        if(!localStorage.getItem("indice").includes("5")){          
          return true;
        }        
      }
      if(sector=='convenzioni_progetti_speciali'){
        if(!localStorage.getItem("indice").includes("6")){          
          return true;
        }        
      }   
      if(sector=='fuori_sacco'){
        if(!localStorage.getItem("indice").includes("7")){          
          return true;
        }                
      }
      if(sector=='sviluppoTerritorio'){
        if(!localStorage.getItem("indice").includes("3")){          
          return true;
        }        
      }  
      if(sector=='in_evidenza'){        
        if(!localStorage.getItem("indice").includes("6")){          
          return true;
        }  
      }               
      return false;
    };

    const isBloccatoObiettivo = function(obiettivo) {                       
      //if( properties.verboseLog==1)
        console.log("CALLED IS BLOCCATOOBIETTIVO");
      if(obiettivo=='cultura'){        
        if((menuLocked[0]==2 || menuLocked[0]==4) && (menuLocked[1]==2 || menuLocked[1]==4)&&(menuLocked[2]==2 || menuLocked[2]==4) && (menuLocked[3]==2 || menuLocked[3]==4) &&(menuLocked[4]==2 || menuLocked[4]==4))
          return true;
        else
          return false;
      }      
      if(obiettivo=='persone'){
        if( properties.verboseLog==1)
          console.log("persone", menuLocked)
        if((menuLocked[5]==2 || menuLocked[5]==4)&&(menuLocked[6]==2 || menuLocked[6]==4)&&(menuLocked[7]==2 || menuLocked[7]==4)&&(menuLocked[8]==2 || menuLocked[8]==4)&&(menuLocked[9]==2 || menuLocked[9]==4)&&(menuLocked[10]==2 || menuLocked[10]==4))
          return true;
        else
          return false;
      }

      if(obiettivo=='pianeta'){
        console.log("pianeta", menuLocked)
        if((menuLocked[11]==2 || menuLocked[11]==4)&&(menuLocked[12]==2 || menuLocked[12]==4)&&(menuLocked[13]==2 || menuLocked[13]==4)&&(menuLocked[14]==2 || menuLocked[14]==4)&&(menuLocked[15]==2 || menuLocked[15]==4)&&(menuLocked[16]==2 || menuLocked[16]==4)&&(menuLocked[21]==2 || menuLocked[21]==4))
          return true;
        else
          return false;
      }
      
      if(obiettivo=='direzione_pianificazione'){
        if(menuLocked[17]==2 || menuLocked[17]==4)
          return true;
        else
          return false;
      }
      if(obiettivo=='direzione_innovazione_impatto'){
        if(menuLocked[18]==2 || menuLocked[18]==4)
          return true;
        else
          return false;
      }
      if(obiettivo=='convenzioni_progetti_speciali'){
        if(menuLocked[19]==2 || menuLocked[19]==4)
          return true;
        else
          return false;
      }                
      return false;
    };

    const deleteItem = function(id) {              
      if( properties.verboseLog==1)
        console.log("DELETE",id,item);
      setLoading(true);
      doPostDelete(id);      
    }

    const closeDialogPratica = function() {          
      //let a2=getVirtualNote(dynamicFields,item.IpotesiIntervento);     
      //console.log("Final Note-----",a2);  
      console.log("DPP scelte",scelteDPP)    
        if( properties.verboseLog==1){
          console.log("TEST",item,dynamicFields);          
          console.log("PRATICA",item);
          console.log("SUM",sumDynamicFields(dynamicFields));
        }
        console.log("IS CHANGED:",itemChanged);
        if(itemChanged){      
            setAlert1(
              <SweetAlert
              warning
              closeOnClickOutside ={true}
              showCancel ={true}
              showConfirm={true}
              style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
              
              title={"Tutti i dati della pratica non salvati in precedenza andranno persi. Procedere lo stesso?"}
              onConfirm={() => {             
                resetDynamicFieldsState();
                resetCheckboxState(); 
                setDialogPratica(false);
                setDialogMovePratica(false);
                setAlert1(null);   
                setLoading(true);        
                doPostSedute(sector);
                //31012025 
                setItemChanged(false);
                doPostStatiMissioniETotaliObiettivi();
              }}           
              onCancel={() => {
                  setAlert1(null);                
                  doPostStatiMissioniETotaliObiettivi();
              }}
              confirmBtnText={"Si"}    
              focusCancelBtn= {true}                    
              cancelBtnText={"No"}                       
              confirmBtnCssClass="custom-btn custom-btn-success" 
              cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
            >
            </SweetAlert>
            );    
        }
        else{
                resetDynamicFieldsState();
                resetCheckboxState(); 
                setDialogPratica(false);
                setDialogMovePratica(false);
                setAlert1(null);   
                setLoading(true);        
                doPostSedute(sector);
                //31012025 
                setItemChanged(false);
                doPostStatiMissioniETotaliObiettivi();
        }
    }

    const closeDialogAmbito = function() {              
      if( properties.verboseLog==1)
        console.log("AMBITO",item);
      if(itemChanged){     
        setAlert1(
          <SweetAlert
          warning
          closeOnClickOutside ={true}
          showCancel ={true}
          showConfirm={true}
          style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
          
          title={"Tutti i dati dell'ambito non salvati in precedenza andranno persi. Procedere lo stesso?"}
          onConfirm={() => {             
            setDialogAmbito(false);
            setDialogMoveAmbito(false);      
            setAlert1(null);   
            setLoading(true);    
            doPostSedute(sector);            
            //31012025 
            setItemChanged(false);
          }}           
          onCancel={() => {
              setAlert1(null);                
          }}
          confirmBtnText={"Si"}    
          focusCancelBtn= {true}                    
          cancelBtnText={"No"}                       
          confirmBtnCssClass="custom-btn custom-btn-success" 
          cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
        >
        </SweetAlert>
        );    
      }
      else{
        setDialogAmbito(false);
        setDialogMoveAmbito(false);      
        //31012025 
        setItemChanged(false);
      }

  
    }

    const closeDialogDocumento = function() {              
      if( properties.verboseLog==1)
        console.log("DOCUMENTO",item);
      //setDialogDocumento(false);
      //setDialogMoveDocumento(false);
      
      if(itemChanged){     
        setAlert1(
          <SweetAlert
          warning
          closeOnClickOutside ={true}
          showCancel ={true}
          showConfirm={true}
          style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
          
          title={"Tutti i dati del documento non salvati in precedenza andranno persi. Procedere lo stesso?"}
          onConfirm={() => {             
            setDialogDocumento(false);
            setDialogMoveDocumento(false);  
            setAlert1(null);   
            setLoading(true);    
            doPostSedute(sector);            
            
            setItemChanged(false);
          }}           
          onCancel={() => {
              setAlert1(null);                
          }}
          confirmBtnText={"Si"}    
          focusCancelBtn= {true}                    
          cancelBtnText={"No"}                       
          confirmBtnCssClass="custom-btn custom-btn-success" 
          cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
        >
        </SweetAlert>
        );    
      }
      else{
        setDialogDocumento(false);
        setDialogMoveDocumento(false);
        //31012025 
        setItemChanged(false);
      }
    }

    const handleChange = (event) => {
      setItemChanged(true);      
      
      setMovedSector(event.target.value);
      if( properties.verboseLog==1)
        console.log("HC",event, event.target.value);
    };

    const saveDialogItem = function() {    
      //if( properties.verboseLog==1)
        console.log("TEST2",dynamicFields,checkboxState);
      //TODO: provare a verificare che somma degli split coincida con ipotesi d'intervento
      //TODO: se split non valorizzato -> forzare ipotesi intervento = missione di riferimento
      //TODO: visualizzazione del formato di importo coerente con quello di ipotesi di intervento
      
      /*let summ = sumDynamicFields(dynamicFields);
      
      console.log("PD",summ, dynamicFields, item.IpotesiIntervento, );
      if(parseFloat(summ)!= parseFloat(item.IpotesiIntervento))
        console.log("3-DIVERSO SPLIT DA IPOTESI INTERVENTO");
      else
        console.log("3-OK SPLIT di IPOTESI INTERVENTO");  
      */
      if(itemChanged){

        //if( properties.verboseLog==1)
        //  console.log("something changed in the item",item.IpotesiIntervento);
        if(validateForm() && validateBozza(item)){  
          console.log("AFTER VALIDATE",item);
        if(item.IpotesiIntervento=="" ||item.IpotesiIntervento=="0.00"|| item.IpotesiIntervento=="0.00€"||item.IpotesiIntervento=="0.00 €"||item.IpotesiIntervento=="€0.00"
          ||item.IpotesiIntervento=="€ 0.00"||item.IpotesiIntervento=="€ 0.00 " ||item.IpotesiIntervento=="0" ||item.IpotesiIntervento=="€0"||item.IpotesiIntervento=="€ 0" ){
            if( properties.verboseLog==1)
              console.log("IPOTESI A ZERO",item);
          item.IpotesiIntervento="0.00";          
          setAlert1(
            <SweetAlert
            warning
            closeOnClickOutside ={true}
            showCancel ={true}
            showConfirm={true}
            style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
            
            title={"La pratica prevede un'Ipotesi d'Intervento priva di importo, procedere lo stesso?"}
            onConfirm={() => {            
                item.CheckboxState=checkboxState;
                item.DynamicFields=dynamicFields;                           
                item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);                   
                item.ScelteDPP=scelteDPP;
                resetDynamicFieldsState();
                resetCheckboxState(); 
                if( properties.verboseLog==1)
                  console.log("SAVING", checkboxState, item);
                setAlert1(null);
                setLoading(true);
                console.log("before doing post minimal 1");
                doPostUpdateMinimal(item);
                doPostStatiMissioniETotaliObiettivi();
                setItemChanged(false);
                setDialogPratica(false);
                setDialogAmbito(false);
                setDialogDocumento(false);
                
            }}           
            onCancel={() => {
                setAlert1(null);     
                doPostStatiMissioniETotaliObiettivi();           
            }}
            confirmBtnText={"Si"}    
            focusCancelBtn= {true}                    
            cancelBtnText={"No"}                       
            confirmBtnCssClass="custom-btn custom-btn-success" 
            cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
          >
          </SweetAlert>
          );
        } else {
          // ESISTE UN IPOTESI DI INTERVENTO
          const sum= sumDynamicFields(dynamicFields);
          if( properties.verboseLog==1)
            console.log("DDD", parseFloat(sum),item.IpotesiIntervento);          
          let ipInt= item.IpotesiIntervento;
          if (ipInt.includes("€"))
            ipInt= ipInt.replace(/\€/g, "");   
          if (ipInt.includes(".") &&ipInt.includes(","))
            ipInt= parseFloat(ipInt.replace(/\./g, "").replace(",", "."));   
          if( properties.verboseLog==1)
            console.log("UNO",ipInt);
          
          if(parseFloat(sum)!= ipInt){
            console.log("DIVERSO SPLIT DA IPOTESI INTERVENTO");
            if(parseFloat(sum)!=0){
            //DA QUI
            setAlert1(
              <SweetAlert
              warning
              closeOnClickOutside ={true}
              showCancel ={true}
              showConfirm={true}
              style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
              
              title={"Il totale dei fondi è diverso dall'Ipotesi d'Intervento, procedere lo stesso?"}
              onConfirm={() => {   
                  
                  item.CheckboxState=checkboxState;
                  item.DynamicFields=dynamicFields;                           
                  item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);
                  item.ScelteDPP=scelteDPP;
                  console.log("RRS3",item);                         
                  if( properties.verboseLog==1)
                    console.log("WWW",item);                             
                  resetDynamicFieldsState();
                  resetCheckboxState(); 
                  //console.log("SAVING", checkboxState, item);
                  setAlert1(null);
                  setLoading(true);
                  console.log("before doing post minimal 2");
                  doPostUpdateMinimal(item);
                  doPostStatiMissioniETotaliObiettivi();
                  setItemChanged(false);
                  setDialogPratica(false);
                  setDialogAmbito(false);
                  setDialogDocumento(false);
                  
              }}           
              onCancel={() => {
                  setAlert1(null);             
                  doPostStatiMissioniETotaliObiettivi();   
              }}
              confirmBtnText={"Si"}    
              focusCancelBtn= {true}                    
              cancelBtnText={"No"}                       
              confirmBtnCssClass="custom-btn custom-btn-success" 
              cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
            >
            </SweetAlert>
            );
            //A QUI
            }
            else{ //non è stato inserito lo split
              
              //if( properties.verboseLog==1){
                console.log("else già");
                console.log("RRS2",item);          
              //}
              item.CheckboxState=checkboxState;
              item.DynamicFields=dynamicFields;                                      
              item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);
              item.ScelteDPP=scelteDPP;
              //if( properties.verboseLog==1)
                console.log("WWW1",item);                             
              resetDynamicFieldsState();
              resetCheckboxState(); 
              //console.log("SAVING", checkboxState, item);
              setAlert1(null);
              setLoading(true);
              console.log("before doing post minimal 3");
              doPostUpdateMinimal(item);
              doPostStatiMissioniETotaliObiettivi();
              setItemChanged(false);
              setDialogPratica(false);
              setDialogAmbito(false);
              setDialogDocumento(false);
             
            }
          }
          else{
          //  console.log("OK SPLIT di IPOTESI INTERVENTO");  
            
            item.CheckboxState=checkboxState;
            item.DynamicFields=dynamicFields;
            item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);
            item.ScelteDPP=scelteDPP;
            console.log("RRS1",item);          
            if( properties.verboseLog==1)
              console.log("WWW2",item);                             
            resetDynamicFieldsState();
            resetCheckboxState(); 
            setLoading(true);
            console.log("before doing post minimal 4");
            doPostUpdateMinimal(item);
            console.log("after doing post minimal 4");
            doPostStatiMissioniETotaliObiettivi();
            console.log("after doing stati missioni e totali obiettivi");
            setItemChanged(false);
            setDialogPratica(false);
            setDialogAmbito(false);
            setDialogDocumento(false);
            
          }
        }
      }// IF VALIDATE FINE  
      //28/04/2025
      else{
        item.CheckboxState=checkboxState;
        item.DynamicFields=dynamicFields;                           
        item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);                   
        item.ScelteDPP=scelteDPP;            
        console.log("before doing post minimal 5");            
        doPostUpdateMinimal(item);
        doPostStatiMissioniETotaliObiettivi();
      }           
      //28/04/2025      
      }
      else{
        if(validateForm() && validateBozza(item)){
           if(item.IpotesiIntervento=="" ||item.IpotesiIntervento=="0.00"|| item.IpotesiIntervento=="0.00€"||item.IpotesiIntervento=="0.00 €"||item.IpotesiIntervento=="€0.00"||item.IpotesiIntervento=="€ 0.00"||item.IpotesiIntervento=="€ 0.00 " ||item.IpotesiIntervento=="0" ||item.IpotesiIntervento=="€0"||item.IpotesiIntervento=="€ 0" ){
          if( properties.verboseLog==1)
            console.log("IPOTESI A ZERO",item);          
          setAlert1(
            <SweetAlert
            warning
            closeOnClickOutside ={true}
            showCancel ={true}
            showConfirm={true}
            style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
            
            title={"La pratica prevede un'Ipotesi d'Intervento priva di importo, procedere lo stesso?"}
            onConfirm={() => {
                item.ScelteDPP=scelteDPP;
                setAlert1(null);   
                setItemChanged(false);
                setDialogPratica(false);
                setDialogAmbito(false);
                setDialogDocumento(false);                
            }}           
            onCancel={() => {
                setAlert1(null);                
            }}
            confirmBtnText={"Si"}    
            focusCancelBtn= {true}                    
            cancelBtnText={"No"}                       
            confirmBtnCssClass="custom-btn custom-btn-success" 
            cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
          >
          </SweetAlert>
          );
           }
        }
        //28/04/2025
        else{
          item.CheckboxState=checkboxState;
          item.DynamicFields=dynamicFields;                           
          item.VirtualNote=getVirtualNote(item.DynamicFields,item.IpotesiIntervento);                   
          item.ScelteDPP=scelteDPP;          
          console.log("before doing post minimal 6");              
          doPostUpdateMinimal(item);
          doPostStatiMissioniETotaliObiettivi();
        }           
      //28/04/2025 
      }      
      if( properties.verboseLog==1)
        console.log(" SAVE ITEM",item);      
    }

    const saveDialogItemNoPratica = function() {
      console.log("SDNI", item);
      if(itemChanged){
        //if( properties.verboseLog==1)
          console.log("something changed in the item",item,scelteDPP);
          /*if(item.Tipo=="Documento" &&scelteDPP!={}){
            console.log("into");
            if(validateForm()){ 
              console.log("validated");
              item.ScelteDPP=scelteDPP;
              setLoading(true);
              doPostUpdateMinimal(item);
              setItemChanged(false);
              if( properties.verboseLog==1)
                console.log(" SAVE ITEM",item);
              setDialogPratica(false);
              setDialogAmbito(false);
              setDialogDocumento(false);
              doPostStatiMissioniETotaliObiettivi();
            }
          }
          else{ */
            setLoading(true);
            console.log("before doing post minimal 7");            
            doPostUpdateMinimal(item);
            doPostStatiMissioniETotaliObiettivi();
            setItemChanged(false);
            if( properties.verboseLog==1)
              console.log(" SAVE ITEM",item);
            setDialogPratica(false);
            setDialogAmbito(false);
            setDialogDocumento(false);
            
          //}
      }
      else{
        doPostStatiMissioniETotaliObiettivi();
      }
      
    }

    const saveDialogMoveItem = function() {
      if( properties.verboseLog==1)
        console.log(" SAVE MOVE ITEM",item, movedSector,itemChanged);
      if(itemChanged){
        if( properties.verboseLog==1)
          console.log("something changed in the item",item);        
        doPostMove(item.id,movedSector);
        setItemChanged(false);
      }            
      setDialogMovePratica(false);
      setDialogMoveAmbito(false);
      setDialogMoveDocumento(false);
      doPostStatiMissioniETotaliObiettivi();
    }

    const resetCheckboxState = () => {
      setCheckboxState([true, false, false, false, false,false,false,false,false]); 
    };

    const resetDynamicFieldsState = () => {
      setDynamicFields([[], [], [], [], [],[],[],[],[]]); 
    };
     
    const openDialog = function(item) {   
      //01/04/2025 START
      console.log("OPENING",data.Fase,data);  
      console.log("OPENING",item);  
    
      //console.log("OPENING++",item.ScelteDPP);  
      
      //01/04/2025 END
      if( properties.verboseLog==1)
        console.log("OPEN DIALOG");
      const tipo=item.Tipo;
      if( properties.verboseLog==1)
        console.log("OPEN DIALOG", tipo);
      if(tipo=='Pratica'){
            //if( properties.verboseLog==1)
            
            console.log("PRATICA",item);      

            if(item.ScelteDPP){             
              if (
                item.ScelteDPP &&
                item.ScelteDPP["2. Concetti chiave"] &&
                item.ScelteDPP["2. Concetti chiave"].hasOwnProperty("Rischio")
              ) {
                //console.log("Dentro");
                item.ScelteDPP = {
                  ...item.ScelteDPP,
                  "2. Concetti chiave": {
                    ...item.ScelteDPP["2. Concetti chiave"],
                    "Rischio": normalizzaRischio(item.ScelteDPP["2. Concetti chiave"]["Rischio"])
                  }
                };
              }
              /*
              console.log("Dentro12");
              if(item.ScelteDPP){     
                console.log("Dentro22");        
                if (
                  item.ScelteDPP &&
                  item.ScelteDPP["6. Velocità d'intervento"] &&
                  item.ScelteDPP["6. Velocità d'intervento"].hasOwnProperty("Progetti a impatto")
                ) {
                  console.log("Dentro23");
                  item.ScelteDPP = {
                    ...item.ScelteDPP,
                    "6. Velocità d'intervento": {
                      ...item.ScelteDPP["6. Velocità d'intervento"],
                      "Progetti a impatto": inizializzaImpatto(item.ScelteDPP["6. Velocità d'intervento"]["Progetti a impatto"])
                    }
                  };
                }
              }
              */
              //31/08/25
              /*console.log("ANT43",item.ScelteDPP["1. Allineamenti"]);
              if(item.ScelteDPP["1. Allineamenti"]=="Nessuna delle precedenti"){
                console.log("TEST43",item.scelteDPP);
              }
              */
              //31/08/25


              //console.log("PDPM-2",item.ScelteDPP, item.ScelteDPP["2. Concetti chiave"]["Rischio"]);
              //TEST 09/07/2025
              //console.log("W",item.ScelteDPP["4. Priorità Tematiche"]);
              //if(item.ScelteDPP["4. Priorità Tematiche prevalenti"]=="Nessuna"){
                if(item.ScelteDPP["4. Priorità Tematica prevalente"]=="Nessuna"){
                setDisabledFattoriChiave(true);
                //item.ScelteDPP["5. Fattori Chiave"]=["Nessuno"];
                console.log("-1",item.ScelteDPP);
                item.ScelteDPP["5. Fattori Chiave"]={ "Nessuno": true };
                console.log("+1",item.ScelteDPP);
              }
              else
                setDisabledFattoriChiave(false);
              
              //item.sceltaDPP.getItem("4. Priorità Tematiche");
              setScelteDPP(item.ScelteDPP);       
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2(item.ScelteDPP);
            }
            else{              
              setScelteDPP({});      
              console.log("YTYT",scelteDPP,data);
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2({});
            }        
            if(item.CheckboxState != undefined){
              if( properties.verboseLog==1)
                console.log("ANF",item.CheckboxState.length);
              if(item.CheckboxState.length==5)
                item.CheckboxState.push(false);

              if(item.CheckboxState.length==6){
                item.CheckboxState.push(false);
                item.CheckboxState.push(false);
                if( properties.verboseLog==1)
                  console.log("pushooo");
              }
              if(item.CheckboxState.length==8){                
                item.CheckboxState.push(false);                  
              }
              setCheckboxState(item.CheckboxState); 
              if( properties.verboseLog==1)
                console.log("RR", item, item.CheckboxState);
            }
            else  
              resetCheckboxState();

            if(item.DynamicFields != undefined){
                if(item.DynamicFields.length==5){
                  var arr=[];
                  item.DynamicFields.push(arr);
                }
                if(item.DynamicFields.length==6){
                  var arr=[];
                  item.DynamicFields.push(arr);
                  item.DynamicFields.push(arr);
                }
                if(item.DynamicFields.length==8){
                  var arr=[];
                  item.DynamicFields.push(arr);                  
                }
                setDynamicFields(item.DynamicFields)   
                if( properties.verboseLog==1)             
                  console.log("RR2", item, item.DynamicFields);
              }
              else  
              resetDynamicFieldsState();
              

          /*if(item.CheckboxState != []){
            setCheckboxState(item.CheckboxState);            
            console.log("RR", item, item.CheckboxState);
          }
          else  
            resetCheckboxState();
          */
          setDialogPratica(true);
          setDialogAmbito(false);
          setDialogDocumento(false);
      }
      if(tipo=='Ambito'){
          if( properties.verboseLog==1)
            console.log("AMBITO",item);
          setDialogAmbito(true);
          setDialogPratica(false);
          setDialogDocumento(false);
      }
      if(tipo=='Documento'){
          if( properties.verboseLog==1)
            console.log("DOCUMENTO",item);
            /*if(item.ScelteDPP){
              setScelteDPP(item.ScelteDPP);       
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2(item.ScelteDPP);
            }
            else{
              setScelteDPP({});      
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2({});
            }*/
            /*
            if(item.ScelteDPP){             
              if (
                item.ScelteDPP &&
                item.ScelteDPP["2. Concetti chiave"] &&
                item.ScelteDPP["2. Concetti chiave"].hasOwnProperty("Rischio")
              ) {
                //console.log("Dentro");
                item.ScelteDPP = {
                  ...item.ScelteDPP,
                  "2. Concetti chiave": {
                    ...item.ScelteDPP["2. Concetti chiave"],
                    "Rischio": normalizzaRischio(item.ScelteDPP["2. Concetti chiave"]["Rischio"])
                  }
                };
              }
            

              if(item.ScelteDPP["4. Priorità Tematiche prevalenti"]=="Nessuna"){
                setDisabledFattoriChiave(true);
                //item.ScelteDPP["5. Fattori Chiave"]=["Nessuno"];
                console.log("-1",item.ScelteDPP);
                item.ScelteDPP["5. Fattori Chiave"]={ "Nessuno": true };
                console.log("+1",item.ScelteDPP);
              }
              else
                setDisabledFattoriChiave(false);
              
              //item.sceltaDPP.getItem("4. Priorità Tematiche");
              setScelteDPP(item.ScelteDPP);       
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2(item.ScelteDPP);
            }
            else{              
              setScelteDPP({});      
              console.log("YTYT",scelteDPP,data);
              if(data.Fase !=0 && data.Fase !='0')                   
                validateForm2({});
            } 
            */
          setDialogDocumento(true);
          setDialogPratica(false);
          setDialogAmbito(false);
      }
    }

    const openMoveDialog = function(tipo) {
      if(tipo=='Pratica'){
          if( properties.verboseLog==1)
            console.log("M PRATICA",item, item.Settore);          
          setDialogMovePratica(true);
          setDialogMoveAmbito(false);
          setDialogMoveDocumento(false);
      }
      if(tipo=='Ambito'){
          if( properties.verboseLog==1)
            console.log("M AMBITO",item);
          setDialogMoveAmbito(true);
          setDialogMovePratica(false);
          setDialogMoveDocumento(false);
      }
      if(tipo=='Documento'){
          if( properties.verboseLog==1)
            console.log("M DOCUMENTO",item);
          setDialogMoveDocumento(true);
          setDialogMovePratica(false);
          setDialogMoveAmbito(false);
      }
    }

    let Euro = new Intl.NumberFormat('it-IT',{
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const updateUI = function(jsonData) {  
      //if( properties.verboseLog==1)    
        console.log("UPDATEUI-CV",jsonData);
      setData(jsonData);    
      if( properties.verboseLog==1)
        console.log("UPDATE UI",jsonData)  ;
      setCards(jsonData.Indice);
      setMingrantAvailable(jsonData.Minigrant);
      if( properties.verboseLog==1)
        console.log("OUI",jsonData,jsonData.Indice);            
      setLoading(false);
    }

   

    const doPostChangeSwitch = function(item) {  
      setLoading(true);
      if(item?.DaInserireInFascicolo != undefined){
          item.DaInserireInFascicolo=!item.DaInserireInFascicolo;
      }
      else{
        item.DaInserireInFascicolo=false;
      }
      doPostUpdateMinimal(item);
    }


    const doPostRetrieveIdCard = function(item,dataSeduta, faseSeduta) {  
      var idScheda=item.IdRichiesta;
      setLoading(true);   
      var xhr = new XMLHttpRequest();        
      
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/retrieveIdPratica.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                             
                    //console.log("OK92",xhr);
                    var responseText = xhr.responseText;                    
                    console.log("OK92",responseText);                    
                    var obj=JSON.parse(responseText);
                    console.log("id1",obj.idScheda);                                        
                    setLoading(false);     
                    if(obj.idScheda!=""){
                      item.IdToBeUsed=obj.idScheda;
                      if(item.IdToBeUsed|= undefined)
                        //doPostUpdateMinimalNoUpdate(item);
                        doPostUpdateMinimal(item);
                      navigate("/schede2/"+dataSeduta+"/"+faseSeduta+"/"+obj.idScheda);              
                    }
                    else{
                      setAlert1(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"Il numero di pratica inserito non è presente in Eroweb. Verificare il numero di pratica inserito e riprovare"}
                        onConfirm={() => {
                            setAlert1(null);                            
                        }}           
                        onCancel={() => {
                            setAlert1(null);                          
                        }}
                      >
                      </SweetAlert>
                      );  
                    }
                }
                else {                                
                    //alert("Errore recuperando i dati dell'indice");
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Si è verificato un errore generando la scheda per il Fascicolo di Comitato. Controllare il numero di pratica inserito e riprovare"}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                    setLoading(false);  
                    //navigate("/indice/init",{ replace: true });                                    
                }
            }
        };

        xhr.onerror = function (e) {
            console.error("Error 2", xhr.statusText);
        };
                      
        let urlEncodedData = "idScheda="+idScheda;        
        console.log("WERE",urlEncodedData);
        xhr.send(urlEncodedData);  
    }



    const doPostDelete = function(idtoBeRemoved) {
      if( properties.verboseLog==1){
          console.log("sector",localStorage.getItem("Settore"));
          console.log("indice version",localStorage.getItem("IndiceVersion"));
          console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);          
      }
      var xhr = new XMLHttpRequest();        
      
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {         
                    if( properties.verboseLog==1)                     
                      console.log("OK92",xhr);
                    var responseText = xhr.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                      console.log("OK193",obj,responseText);                      
                    if (obj.status === "207") {  
                      console.log("Errore 207");  
                      //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                      setAlert1(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                        onConfirm={() => {
                            setAlert1(null);                            
                        }}           
                        onCancel={() => {
                            setAlert1(null);                          
                        }}
                      >
                      </SweetAlert>
                      );  
                    }               
              doPostSedute2();              
              doPostStatiMissioniETotaliObiettivi();
              }
                else {                                
                    //alert("Errore recuperando i dati dell'indice");
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Errore recuperando i dati dell'indice."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                    setLoading(false);
                    navigate("/indice/init",{ replace: true });                  
                }
            }
        };

        xhr.onerror = function (e) {
            console.error("Error 2", xhr.statusText);
        };

        var stringato= idtoBeRemoved;
        var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
        tmp=tmp.replaceAll("/","");
        let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&item="+stringato+"&action=deleteFromIndice";
        if( properties.verboseLog==1)
          console.log("WERE",urlEncodedData);
        xhr.send(urlEncodedData);  
    }

    const doPostMove = function(idtoBeRemoved,destination) {                
      var xhr = new XMLHttpRequest();              
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
      xhr.onload = function (e) {      
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {  
                  if( properties.verboseLog==1)                            
                    console.log("OK392",xhr);
                  var responseText = xhr.responseText;                    
                  var obj=JSON.parse(responseText);
                  if( properties.verboseLog==1)
                    console.log("OK393",obj,responseText);                      
                  if (obj.status === "207") {  
                    console.log("207");  
                    //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                  }               
                  doPostSedute2();
                  doPostStatiMissioniETotaliObiettivi();
            }
              else {                               
                  //alert("Errore recuperando i dati dell'indice");
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Errore recuperando i dati dell'indice."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );  
                  setLoading(false);
                  navigate("/indice/init",{ replace: true });                
              }
          }
      };
    
      xhr.onerror = function (e) {
          console.error("Error 2", xhr.statusText);
      };
    
    var stringato= idtoBeRemoved;
    var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
    tmp=tmp.replaceAll("/","");    
    let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&item="+stringato+"&destination="+destination+"&action=moveInsideIndice";
    if( properties.verboseLog==1)
      console.log("WERE",urlEncodedData);
    xhr.send(urlEncodedData);
      
    }

    const doPostUpdate = function(dateToBeAdded) {

      //if( properties.verboseLog==1){
        console.log("sector",localStorage.getItem("Settore"));
        console.log("indice version",localStorage.getItem("IndiceVersion"));
        console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);
        console.log("CheckValues",dateToBeAdded);
      //}
        
      var xhr = new XMLHttpRequest();        
    
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {                              
                //console.log("OK92",xhr);
                var responseText = xhr.responseText;                    
                var obj=JSON.parse(responseText);
                if( properties.verboseLog==1)
                  console.log("OK493",obj,responseText);                      
                if (obj.status === "207") {  
                  console.log("207");  
                  //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );  
                }
                else{    
                console.log("PDPM",dateToBeAdded,item, dateToBeAdded.scelteDPP, item.scelteDPP);           
                //setItem(dateToBeAdded);
                }
           doPostSedute2();
           doPostStatiMissioniETotaliObiettivi();
          }
            else {                             
                //alert("Errore recuperando i dati dell'indice");
                setAlert1(
                  <SweetAlert
                  warning
                  closeOnClickOutside ={true}
                  showCancel ={false}
                  showConfirm={false}
                  style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                  title={"Errore recuperando i dati dell'indice."}
                  onConfirm={() => {
                      setAlert1(null);                            
                  }}           
                  onCancel={() => {
                      setAlert1(null);                          
                  }}
                >
                </SweetAlert>
                );  
                setLoading(false);
                navigate("/indice/init",{ replace: true });              
            }
        }
    };

    xhr.onerror = function (e) {
        console.error("Error 2", xhr.statusText);
    };


  //var stringato=JSON.stringify(dateToBeAdded);  
  //stringato=encode(stringato);
  var stringato=JSON.stringify(dateToBeAdded);  
  stringato=encode(stringato);
  if(dateToBeAdded.Descrizione != undefined){
    var stringato2=dateToBeAdded.Descrizione.replaceAll('“', '\"');  
    stringato2=stringato2.replaceAll('”', '\"');  
    //console.log("ORCA-1", stringato2);
    dateToBeAdded.Descrizione=stringato2;
    stringato2=JSON.stringify(dateToBeAdded);
    stringato=encode(stringato2);
    //console.log("ORCA-3", stringato2);
  }
  

  var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
  tmp=tmp.replaceAll("/","");  
  let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&data="+stringato+"&action=updateIndiceValues";
  if( properties.verboseLog==1)
    console.log("WERE",urlEncodedData);
  xhr.send(urlEncodedData);
    
  }

    const doPostAdd = function(dateToBeAdded) {
      if( properties.verboseLog==1){
        console.log("sector",localStorage.getItem("Settore"));
        console.log("indice version",localStorage.getItem("IndiceVersion"));
        console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);
        console.log("CheckValues",dateToBeAdded);
      }
      var xhr = new XMLHttpRequest();        
  
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {   
              if( properties.verboseLog==1)                      
                console.log("OK92",xhr);
              var responseText = xhr.responseText;                    
              var obj=JSON.parse(responseText);
              if( properties.verboseLog==1)
                console.log("OK593",obj,responseText);                      
              if (obj.status === "207") {  
                console.log("207");  
                //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                setAlert1(
                  <SweetAlert
                  warning
                  closeOnClickOutside ={true}
                  showCancel ={false}
                  showConfirm={false}
                  style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                  title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                  onConfirm={() => {
                      setAlert1(null);                            
                  }}           
                  onCancel={() => {
                      setAlert1(null);                          
                  }}
                >
                </SweetAlert>
                );  
              }                  
         doPostSedute2();         
        }
          else {                           
              //alert("Errore recuperando i dati dell'indice");
              setAlert1(
                <SweetAlert
                warning
                closeOnClickOutside ={true}
                showCancel ={false}
                showConfirm={false}
                style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                title={"Errore recuperando i dati dell'indice."}
                onConfirm={() => {
                    setAlert1(null);                            
                }}           
                onCancel={() => {
                    setAlert1(null);                          
                }}
              >
              </SweetAlert>
              );  
              setLoading(false);
              navigate("/indice/init",{ replace: true });            
          }
      }
  };

  xhr.onerror = function (e) {
      console.error("Error 2", xhr.statusText);
  };


var stringato=dateToBeAdded;
var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
tmp=tmp.replaceAll("/","");
let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&data="+stringato+"&action=addToIndice";
if( properties.verboseLog==1)
  console.log("WERE",urlEncodedData);
xhr.send(urlEncodedData);
  
    }

    const doPostSwitchMinigrant = function() {
      if( properties.verboseLog==1){
          console.log("sector",localStorage.getItem("Settore"));
          console.log("indice version",localStorage.getItem("IndiceVersion"));
          console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);          
          }
          
      var xhr = new XMLHttpRequest();              
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
      xhr.onload = function (e) {      
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr);
                  var responseText = xhr.responseText;                    
                  var obj=JSON.parse(responseText);
                  if( properties.verboseLog==1)
                    console.log("OK693",obj,responseText);                      
                  if (obj.status === "207") {  
                    console.log("207");  
                    //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                  }               
                  doPostSedute2();
              }
              else {                               
                  //alert("Errore recuperando i dati dell'indice");
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Errore recuperando i dati dell'indice."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );  
                  setLoading(false);
                  navigate("/indice/init",{ replace: true });                
              }
          }
      };
    
      xhr.onerror = function (e) {
          console.error("Error 2", xhr.statusText);
      };              
      var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
      tmp=tmp.replaceAll("/","");      
      let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&data=Minigrant"+"&action=switchMinigrant";
      if( properties.verboseLog==1)
        console.log("WERE",urlEncodedData);
      xhr.send(urlEncodedData);      
    }

    const doPostSwitchPresentazioneMissione = function() {
      if( properties.verboseLog==1){
          console.log("sector",localStorage.getItem("Settore"));
          console.log("indice version",localStorage.getItem("IndiceVersion"));
          console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);          
          }
          
      var xhr = new XMLHttpRequest();              
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    
      xhr.onload = function (e) {      
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr);
                  var responseText = xhr.responseText;                    
                  var obj=JSON.parse(responseText);
                  if( properties.verboseLog==1)
                    console.log("OK693",obj,responseText);                      
                  if (obj.status === "207") {  
                    console.log("207");  
                    //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                  }               
                  doPostSedute2();
              }
              else {                               
                  //alert("Errore recuperando i dati dell'indice");
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Errore recuperando i dati dell'indice."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );  
                  setLoading(false);
                  navigate("/indice/init",{ replace: true });                
              }
          }
      };
    
      xhr.onerror = function (e) {
          console.error("Error 2", xhr.statusText);
      };              
      var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
      tmp=tmp.replaceAll("/","");      
      let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&data=PresentazioneMissione"+"&action=switchPresentazioneMissione";
      if( properties.verboseLog==1)
        console.log("WERE",urlEncodedData);
      xhr.send(urlEncodedData);      
    }

    const doPostGeneraFascicolo = function() {
      if( properties.verboseLog==1){
        console.log("sector",localStorage.getItem("Settore"));
        console.log("indice version",localStorage.getItem("IndiceVersion"));
        console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);          
      }
      setLoading(true);
      var xhr = new XMLHttpRequest();                
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {     
                  //setLoading(false);                         
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr);
                  var responseText = xhr.responseText;
                  var obj=JSON.parse(responseText);
                  //if( properties.verboseLog==1)
                    console.log("OK1193",obj,responseText);
                    console.log("2323",obj.dataSeduta);
                  setAlert1(
                    <SweetAlert
                    success
                    closeOnClickOutside ={true}
                    showCancel ={true}
                    showConfirm={true}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Il fascicolo è stato generato correttamente"}
                    confirmBtnText={"Vai al Fascicolo"}    
                    cancelBtnText={"Chiudi"}     
                    focusCancelBtn= {true}     
                    confirmBtnCssClass="custom-btn custom-btn-success" 
                    cancelBtnCssClass="custom-btn custom-btn-cancel"   
                    onConfirm={() => {                        
                      setAlert1(null);                            
                      navigate("/fascicoli/"+obj.idFascicolo,{ replace: false });   
                        
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );  
                  doPostSedute2();
                  doPostStatiMissioniETotaliObiettivi();
                  //setLoading(false);
            }
              else {       
                if (xhr.status === 409) {
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Una o più missioni/direzioni non sono state bloccate e, pertanto, non è possibile generare il fascicolo."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );
                  doPostStatiMissioniETotaliObiettivi();
                  setLoading(false);
                }
                else if (xhr.status === 406) {
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Non è possibile generare il fascicolo in fase INDICE o POST-CONSOLIDAMENTO."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );
                  doPostStatiMissioniETotaliObiettivi();
                  setLoading(false);
                }                
                else if (xhr.status === 412) {
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Il fascicolo è bloccato. E' necessario sbloccarlo prima di poterlo generare di nuovo."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );
                  doPostStatiMissioniETotaliObiettivi();
                  setLoading(false);
                }                
                else{
                  //alert("Errore effettuando la richiesta");
                  setAlert1(
                    <SweetAlert
                    warning
                    closeOnClickOutside ={true}
                    showCancel ={false}
                    showConfirm={false}
                    style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                    title={"Errore effettuando la richiesta."}
                    onConfirm={() => {
                        setAlert1(null);                            
                    }}           
                    onCancel={() => {
                        setAlert1(null);                          
                    }}
                  >
                  </SweetAlert>
                  );                      
                  setLoading(false);                    
                }
              }
          }
      };

      xhr.onerror = function (e) {
          console.error("Error 2", xhr.statusText);
      };
   
      var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
      tmp=tmp.replaceAll("/","");
      let urlEncodedData = "index=" + tmp+"&action=generaFascicolo";
      //if( properties.verboseLog==1)
        console.log("REQ",urlEncodedData);
      xhr.send(urlEncodedData);  
  }


    const doPostCambiaFaseIndice = function() {
        if( properties.verboseLog==1){
          console.log("sector",localStorage.getItem("Settore"));
          console.log("indice version",localStorage.getItem("IndiceVersion"));
          console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);          
        }
      
        var xhr = new XMLHttpRequest();                
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {      
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {                              
                    if( properties.verboseLog==1)
                      console.log("OK92",xhr);
                    var responseText = xhr.responseText;
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                      console.log("OK1193",obj,responseText);
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"L'indice è stato correttamente portato alla fase successiva."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                    doPostSedute2();
                    doPostStatiMissioniETotaliObiettivi();
              }
                else {       
                  if (xhr.status === 406) {
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Una o più missioni/direzioni non sono state bloccate correttamente e, pertanto, non è possibile cambiare fase. Controllate le anomalie e riprovate"}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );
                    doPostStatiMissioniETotaliObiettivi();
                    setLoading(false);
                  }
                  else{
                    //alert("Errore effettuando la richiesta");
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Errore effettuando la richiesta."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );                      
                    setLoading(false);                    
                  }
                }
            }
        };

        xhr.onerror = function (e) {
            console.error("Error 2", xhr.statusText);
        };
     
        var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
        tmp=tmp.replaceAll("/","");
        let urlEncodedData = "index=" + tmp+"&action=cambiaFaseIndiceSeduta";
        if( properties.verboseLog==1)
          console.log("REQ",urlEncodedData);
        xhr.send(urlEncodedData);  
    }

    const doPostUpdateMinimalNoUpdate = function(dateToBeAdded) {
      //if( properties.verboseLog==1){
        console.log("sector",localStorage.getItem("Settore"));
        console.log("indice version",localStorage.getItem("IndiceVersion"));
        console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);
        console.log("CheckValues M",dateToBeAdded);
      //}
      var xhr = new XMLHttpRequest();        
      
      xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr.withCredentials = true;
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.onload = function (e) {      
          if (xhr.readyState === 4) {
              if (xhr.status === 200) {      
                  if( properties.verboseLog==1)                        
                    console.log("OK92",xhr);
                  var responseText = xhr.responseText;                    
                  var obj=JSON.parse(responseText);
                  if(properties.verboseLog==1)
                    console.log("OK893",obj,responseText);                                    
                  if (obj.status === "207") {  
                    console.log("207");  
                    //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                  }                                  
            }             
          }
      };

      xhr.onerror = function (e) {
          console.error("Error 2", xhr.statusText);
      };

      //var stringato=JSON.stringify(dateToBeAdded);
      //stringato=encode(stringato);
      /*var stringato2=dateToBeAdded.Descrizione.replaceAll('“', '\"');  
      stringato2=stringato2.replaceAll('”', '\"');  
      //console.log("ORCA-1", stringato2);
      dateToBeAdded.Descrizione=stringato2;
      stringato2=JSON.stringify(dateToBeAdded);
      //console.log("ORCA-3", stringato2);
      var stringato=encode(stringato2);*/
      var stringato=JSON.stringify(dateToBeAdded);  
      stringato=encode(stringato);
      if(dateToBeAdded.Descrizione != undefined){
        var stringato2=dateToBeAdded.Descrizione.replaceAll('“', '\"');  
        stringato2=stringato2.replaceAll('”', '\"');  
        //console.log("ORCA-1", stringato2);
        dateToBeAdded.Descrizione=stringato2;
        stringato2=JSON.stringify(dateToBeAdded);
        stringato=encode(stringato2);
        //console.log("ORCA-3", stringato2);
      }

      var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
      tmp=tmp.replaceAll("/","");
      let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&item="+stringato+"&action=changeIndiceValues";;
      if( properties.verboseLog==1)
        console.log("DOPOST UPDATE MINIMAL", urlEncodedData);
      xhr.send(urlEncodedData);  
  }


    const doPostUpdateMinimal = function(dateToBeAdded) {
        //if( properties.verboseLog==1){
          console.log("sector",localStorage.getItem("Settore"));
          console.log("indice version",localStorage.getItem("IndiceVersion"));
          console.log("seduta", JSON.parse(localStorage.getItem("Indice")).Seduta);
          console.log("CheckValues M",dateToBeAdded);
        //}
        var xhr = new XMLHttpRequest();        
        
        xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
        xhr.withCredentials = true;
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        xhr.onload = function (e) {      
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {      
                    if( properties.verboseLog==1)                        
                      console.log("OK92",xhr);
                    var responseText = xhr.responseText;                    
                    var obj=JSON.parse(responseText);
                    if(properties.verboseLog==1)
                      console.log("OK893",obj,responseText);                                    
                    if (obj.status === "207") {  
                      console.log("207");  
                      //alert("La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione...");      
                      setAlert1(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"La pagina verrà ricaricata perchè un altro utente sta apportando modifiche alla stessa sezione..."}
                        onConfirm={() => {
                            setAlert1(null);                            
                        }}           
                        onCancel={() => {
                            setAlert1(null);                          
                        }}
                      >
                      </SweetAlert>
                      );  
                    }               
              doPostSedute2();              
              }
                else {                           
                    //alert("Errore recuperando i dati dell'indice");
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Errore recuperando i dati dell'indice."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                    setLoading(false);
                    navigate("/indice/init",{ replace: true });            
                }
            }
        };

        xhr.onerror = function (e) {
            console.error("Error 2", xhr.statusText);
        };

        //var stringato=JSON.stringify(dateToBeAdded);
        //stringato=encode(stringato);
        /*var stringato2=dateToBeAdded.Descrizione.replaceAll('“', '\"');  
        stringato2=stringato2.replaceAll('”', '\"');          
        dateToBeAdded.Descrizione=stringato2;
        stringato2=JSON.stringify(dateToBeAdded);        
        var stringato=encode(stringato2);*/
        var stringato=JSON.stringify(dateToBeAdded);  
        stringato=encode(stringato);
        if(dateToBeAdded.Descrizione != undefined){
          var stringato2=dateToBeAdded.Descrizione.replaceAll('“', '\"');  
          stringato2=stringato2.replaceAll('”', '\"');  
          //console.log("ORCA-1", stringato2);
          dateToBeAdded.Descrizione=stringato2;
          stringato2=JSON.stringify(dateToBeAdded);
          stringato=encode(stringato2);
          //console.log("ORCA-3", stringato2);
        }

        var tmp=JSON.parse(localStorage.getItem("Indice")).Seduta;
        tmp=tmp.replaceAll("/","");
        let urlEncodedData = "index=" + tmp+ "&indexVersion="+localStorage.getItem("IndiceVersion")+"&sector="+sector+"&item="+stringato+"&action=changeIndiceValues";;
        if( properties.verboseLog==1)
          console.log("DOPOST UPDATE MINIMAL", urlEncodedData);
        xhr.send(urlEncodedData);  
    }
   
    const doPostPrintToExcel = function() {
      if( properties.verboseLog==1)
        console.log("doing POST PRINT TO EXCEL");
      var xhr2 = new XMLHttpRequest();                
      var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);      
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.responseType = 'blob';
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {     
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr2);
                  const blob = new Blob([xhr2.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });                              
                  const downloadUrl = window.URL.createObjectURL(blob);                            
                  const a = document.createElement('a');
                  a.href = downloadUrl;
                  a.download = "indice_"+tmp+".xlsx";
                  document.body.appendChild(a);
                  a.click();                            
                  a.remove();                            
                  window.URL.revokeObjectURL(downloadUrl);                
                  setLoading(false);                                  
              } 
              else {                    
                  console.log("Errore 2671 stampando su excel");                      
              }
          }
      };

      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };            
      let urlEncodedData = "index="+tmp+"&action=printToExcel";
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
      xhr2.send(urlEncodedData);            
    }

    const doPostPrintToExcelWithDetails = function() {
      if( properties.verboseLog==1)
        console.log("doing POST PRINT TO EXCEL WITH DETAILS");
      var xhr2 = new XMLHttpRequest();                
      var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);      
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.responseType = 'blob';
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {     
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr2);
                  const blob = new Blob([xhr2.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });                              
                  const downloadUrl = window.URL.createObjectURL(blob);                            
                  const a = document.createElement('a');
                  a.href = downloadUrl;
                  a.download = "indice_"+tmp+"_with_details.xlsx";
                  document.body.appendChild(a);
                  a.click();                            
                  a.remove();                            
                  window.URL.revokeObjectURL(downloadUrl);                
                  setLoading(false);                                  
              } 
              else {                    
                  console.log("Errore 2671 stampando su excel");                      
              }
          }
      };

      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };            
      let urlEncodedData = "index="+tmp+"&action=printToExcelWithDetails";
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
      xhr2.send(urlEncodedData);            
    }

    const doPostPrintToExcelConsiglieri = function() {
      if( properties.verboseLog==1)
        console.log("doing POST PRINT TO EXCEL CONSIGLIERI");
      var xhr2 = new XMLHttpRequest();                
      var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);      
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.responseType = 'blob';
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {     
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr2);
                  const blob = new Blob([xhr2.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });                              
                  const downloadUrl = window.URL.createObjectURL(blob);                            
                  const a = document.createElement('a');
                  a.href = downloadUrl;
                  a.download = "indice_"+tmp+"_clean.xlsx";
                  document.body.appendChild(a);
                  a.click();                            
                  a.remove();                            
                  window.URL.revokeObjectURL(downloadUrl);                
                  setLoading(false);                                  
              } 
              else {                    
                  console.log("Errore 2671 stampando su excel");                      
              }
          }
      };

      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };            
      let urlEncodedData = "index="+tmp+"&action=printToExcelConsiglieri";
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
      xhr2.send(urlEncodedData);            
    }

    const doPostPrintToZip = function() {
      if( properties.verboseLog==1)
        console.log("doing POST PRINT TO ZIP");
      var xhr2 = new XMLHttpRequest();                
      var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);      
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.responseType = 'blob';
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {  
                  const contentType = xhr2.getResponseHeader("Content-Type");
                  console.log("Content-Type:", contentType);   
                  if( properties.verboseLog==1)
                    console.log("OK92",xhr2);
                  const blob = new Blob([xhr2.response], { type: 'application/zip' });                              
                  const downloadUrl = window.URL.createObjectURL(blob);       
                  console.log("DU",downloadUrl);
                  const a = document.createElement('a');
                  a.href = downloadUrl;
                  a.download = "archivio_"+tmp+".zip";
                  document.body.appendChild(a);
                  a.click();                            
                  //a.remove();               
                  console.log("A",a)             ;
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(downloadUrl);                
                  setLoading(false);                                  
              } 
              else {                    
                  console.log("Errore 2675 stampando su zip");                      
              }
          }
      };

      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };            
      let urlEncodedData = "index="+tmp+"&action=printToZip";
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
      xhr2.send(urlEncodedData);            
    }

    const doPostStatiMissioniETotaliObiettivi = function() {
        if( properties.verboseLog==1)
          console.log("doing POST TOTALE OBIETTIVI E STATO MISSIONI");
        var xhr2 = new XMLHttpRequest();                
        var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);
        setLoading(true);        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {   
                    if( properties.verboseLog==1)                           
                      console.log("OK92",xhr2);                  
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                      console.log("OK1493",obj);     
                    var tre1= JSON.parse(obj.amounts);                  
                    if( properties.verboseLog==1)
                      console.log("TRE1",tre1);     
                    const up11=[];
                    up11.push(Euro.format(tre1[0]));
                    up11.push(Euro.format(tre1[1]));
                    up11.push(Euro.format(tre1[2]));
                    setTotaleObiettivi(up11);      
                    
                    var tre= JSON.parse(obj.status);
                    //if( properties.verboseLog==1)
                      console.log("TRE2",tre);
                    const values = [];
                    values.push(tre['cultura']);
                    values.push(tre['attrattivita']);
                    values.push(tre['competenze']);
                    values.push(tre['custodia']);
                    values.push(tre['partecipazione']);
                    values.push(tre['persone']);
                    values.push(tre['abitare']);
                    values.push(tre['lavoro']);
                    values.push(tre['educazione']);
                    values.push(tre['comunita']);
                    values.push(tre['inclusione']);
                    values.push(tre['pianeta']);
                    values.push(tre['ricerca']);
                    values.push(tre['innovazione']);
                    values.push(tre['benessere']);
                    values.push(tre['internazionalizzazione']);
                    values.push(tre['ambiente']);
                    values.push(tre['direzione_pianificazione']);
                    values.push(tre['direzione_innovazione_impatto']);
                    values.push(tre['convenzioni_progetti_speciali']);
                    values.push(tre['fuori_sacco']);
                    values.push(tre['sviluppoTerritorio']);
                    values.push(tre['in_evidenza']);
                    setMenuLocked(values);                                   
                    setLoading(false);                                  
                } 
                else {                    
                    console.log("Errore 2671: Recuperando dati in getInfoStatoTotali");                      
                }
            }
        };
    
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };            
        let urlEncodedData = "index="+tmp+"&action=getInfoStatoTotali";
        if( properties.verboseLog==1)
          console.log("DATA",urlEncodedData);
        xhr2.send(urlEncodedData);              
    }
    
    const doPostLockObiettivo = function(obiettivo) {
        if( properties.verboseLog==1)
          console.log("doing POST LOCK OBIETTIVO"+obiettivo);
        var xhr2 = new XMLHttpRequest();                
        var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {                              
                    if( properties.verboseLog==1)
                      console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                      console.log("OK2493",obj);                         
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"L'Obiettivo o la Direzione è stata bloccata con successo."}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );  
                  doPostSedute2();
                  setLoading(false);             
                  doPostStatiMissioniETotaliObiettivi();                      
                } 
                else {                    
                    console.log("Errore 677: Recuperando indice in doPostSedute2");    
                    setLoading(false);                                                    
                    setAlert1(
                      <SweetAlert
                      warning
                      closeOnClickOutside ={true}
                      showCancel ={false}
                      showConfirm={false}
                      style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                      title={"Una o più pratiche non sono complete e, pertanto, non possono essere bloccate. Controllate le anomalie e riprovate"}
                      onConfirm={() => {
                          setAlert1(null);                            
                      }}           
                      onCancel={() => {
                          setAlert1(null);                          
                      }}
                    >
                    </SweetAlert>
                    );
                    doPostSedute2();
                    doPostStatiMissioniETotaliObiettivi();                          
                }
            }
        };
    
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };            
        let urlEncodedData = "index="+tmp+"&obiettivo="+obiettivo+"&action=lockObiettivo";          
        if( properties.verboseLog==1)  
          console.log("EE",urlEncodedData);        
        if( properties.verboseLog==1)
          console.log("DATA",urlEncodedData);
        xhr2.send(urlEncodedData);              
    }  

    const doPostUnlockObiettivo = function(obiettivo) {
          if( properties.verboseLog==1)
            console.log("doing POST UNLOCK OBIETTIVO"+obiettivo);
          var xhr2 = new XMLHttpRequest();                
          var tmp=idSeduta.substring(8)+ idSeduta.substring(5,7)+idSeduta.substring(0,4);              
          xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
          xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
          xhr2.withCredentials = true;
          xhr2.onload = function (e) {      
              if (xhr2.readyState === 4) {
                  if (xhr2.status === 200) {                              
                      if( properties.verboseLog==1)
                        console.log("OK92",xhr2);
                      var responseText = xhr2.responseText;                    
                      var obj=JSON.parse(responseText);
                      if( properties.verboseLog==1)
                        console.log("OK4493",obj);                           
                      setAlert1(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"L'Obiettivo o la Direzione è stato sbloccata correttamente."}
                        onConfirm={() => {
                            setAlert1(null);                            
                        }}           
                        onCancel={() => {
                          setAlert1(null);                          
                        }}
                      >
                      </SweetAlert>
                    );  
                    setLoading(false);             
                    doPostStatiMissioniETotaliObiettivi();                           
                  } 
                  else {                    
                      console.log("Errore 477: Recuperando indice in doPostSedute2");    
                      setLoading(false);                                                    
                      setAlert1(
                        <SweetAlert
                        warning
                        closeOnClickOutside ={true}
                        showCancel ={false}
                        showConfirm={false}
                        style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
                        title={"Una o più pratiche non sono complete e, pertanto, non possono essere bloccate. Controllate le anomalie e riprovate"}
                        onConfirm={() => {
                            setAlert1(null);                            
                        }}           
                        onCancel={() => {
                            setAlert1(null);                          
                        }}
                      >
                      </SweetAlert>
                      );                      
                      doPostStatiMissioniETotaliObiettivi();                                              
                  }
              }
          };
      
          xhr2.onerror = function (e) {
              console.error("Error 22", xhr2.statusText);
          };            
          let urlEncodedData = "index="+tmp+"&obiettivo="+obiettivo+"&action=unlockObiettivo";                    
          if( properties.verboseLog==1)
            console.log("DATA",urlEncodedData);
          xhr2.send(urlEncodedData);              
    }      

    function formatDateToDDMMYYYY(data) {
        const [year, month, day] = data.split("-"); 
        return `${day}${month}${year}`; 
    }

    const doPostSedute = function(settore) {
      if( properties.verboseLog==1)
        console.log("doing sedute post CV");
      var xhr2 = new XMLHttpRequest();                      
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {    
                  if( properties.verboseLog==1)                          
                    console.log("OK92",xhr2);
                  var responseText = xhr2.responseText;                    
                  var obj=JSON.parse(responseText);
                  if( properties.verboseLog==1)
                    console.log("OK9893",obj, obj.status);          
                  if(obj.status==="204" ){                                                   
                      console.log("OK INDICE 204",xhr2);                        
                      const jsonListIndici = JSON.parse(localStorage.getItem("Indice"));
                      updateUI(jsonListIndici);    
                      setLoading(false);                
                  }              
                  else{
                      //status 201
                      console.log("OK INDICE 201",xhr2);                        
                      const jsonListIndici = JSON.parse(obj.content);    
                      const idN = jsonListIndici["IdSeduta"] ?? 801;                      
                      try{                      
                          localStorage.setItem("Indice", obj.content);
                          localStorage.setItem("IndiceVersion", obj.date);
                          localStorage.setItem("IndiceId", idN);                                      
                      }
                      catch(error) {
                          console.log("LOCALSTORAGE ISSUE 22", error);
                      }    
                      updateUI(jsonListIndici);   
                      setLoading(false);                     
                  }
              } 
              else {                    
                  console.log("Errore 9371: Recuperando indice in doPostSedute2");                      
              }
          }
      };
  
      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };
      
      let urlEncodedData = null;      
      if( properties.verboseLog==1)
        console.log( "QUINDI00");
      const currentData=localStorage.getItem("IndiceVersion");    
      if( properties.verboseLog==1)
        console.log("CURRENTDATA",currentData);          
      urlEncodedData = "indexVersion=" + currentData+"&sector="+settore+"&index="+formatDateToDDMMYYYY(dataSeduta)+"&action=checkIndiceSeduta";          
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
         
      if( properties.verboseLog==1)
        console.log("CALVIEW",urlEncodedData);
      xhr2.send(urlEncodedData);
    }

    const doPostSedute7 = function() {
        //chiamata solo dallo use effect
        var xhr2 = new XMLHttpRequest();                
        
        xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
        xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
        xhr2.withCredentials = true;
        xhr2.onload = function (e) {      
            if (xhr2.readyState === 4) {
                if (xhr2.status === 200) {        
                    if( properties.verboseLog==1)                      
                      console.log("OK92",xhr2);
                    var responseText = xhr2.responseText;                    
                    var obj=JSON.parse(responseText);
                    if( properties.verboseLog==1)
                      console.log("OK8693",obj, obj.status);                          
                    if(obj.status==="204" ){                             

                        console.log("OK INDICE7 204",xhr2);                        
                        const jsonListIndici = JSON.parse(localStorage.getItem("Indice"));
                        updateUI(jsonListIndici);                            
                        doPostStatiMissioniETotaliObiettivi();
                        setLoading(false);                
                    }              
                    else{
                        //status 201
                        console.log("OK INDICE7 201",xhr2);                        
                        const jsonListIndici = JSON.parse(obj.content);    
                        const idN = jsonListIndici["IdSeduta"] ?? 801;                      
                        try{                      
                            localStorage.setItem("Indice", obj.content);
                            localStorage.setItem("IndiceVersion", obj.date);
                            localStorage.setItem("IndiceId", idN);                                      
                        }
                        catch(error) {
                            console.log("LOCALSTORAGE ISSUE", error);
                        }    
                        updateUI(jsonListIndici);   
                        setLoading(false);                     
                    }
                } 
                else {                    
                    console.log("Errore 3871: Recuperando indice in doPostSedute2");                      
                }
            }
        };
    
        xhr2.onerror = function (e) {
            console.error("Error 22", xhr2.statusText);
        };
        
        let urlEncodedData = null;
        var sectoring="cultura";
        if (localStorage.indice!=='' &&localStorage.indice!==undefined){
          if( properties.verboseLog==1)
            console.log("WWWERE",localStorage.indice);
          if(canBeSeen("1")){
            sectoring="cultura";
            setMenuItemSelected(74);
            setColorItemSelected("#E42568");
            setPrintable("Cultura");
          }
          else if(canBeSeen("2")){
            sectoring="persone";
            setMenuItemSelected(67);
            setColorItemSelected("#F8B902");            
            setPrintable("Persone");
          }
          else if(canBeSeen("3")){
            sectoring="pianeta";
            setMenuItemSelected(85);
            setColorItemSelected("#338FD2");
            setPrintable("Pianeta");
          }
          else if(canBeSeen("4")){
            sectoring="direzione_pianificazione";
            setMenuItemSelected(90);
            setColorItemSelected("#FAD480");
            setPrintable("DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE");
          }
          else if(canBeSeen("5")){
            sectoring="direzione_innovazione_impatto";
            setMenuItemSelected(95);
            setColorItemSelected("#FAD480");
            setPrintable("DIREZIONE INNOVAZIONE DI IMPATTO");
          }
          else {
            sectoring="cultura";
            setMenuItemSelected(74);
            setColorItemSelected("#E42568");
            setPrintable("Cultura");
          }
        }
        if( properties.verboseLog==1)
          console.log("WWWWWWWWW",sectoring);
        setSector(sectoring);
        
        if( properties.verboseLog==1)
          console.log( "QUINDI00");
        const currentData=localStorage.getItem("IndiceVersion");            
                    
        urlEncodedData = "indexVersion=" + currentData+"&sector="+sectoring+"&index="+formatDateToDDMMYYYY(dataSeduta)+"&action=checkIndiceSeduta";
        if( properties.verboseLog==1)
          console.log("DATA",urlEncodedData);
    
        if( properties.verboseLog==1)
          console.log("CALVIEW2",urlEncodedData);
        xhr2.send(urlEncodedData);
    }

    const doPostSedute2 = function() {
      //if( properties.verboseLog==1)
        console.log("doing sedute post CV");
      var xhr2 = new XMLHttpRequest();                
    
      xhr2.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/gestioneIndice.php',true);
      xhr2.setRequestHeader("Content-type", "application/x-www-form-urlencoded");    
      xhr2.withCredentials = true;
      xhr2.onload = function (e) {      
          if (xhr2.readyState === 4) {
              if (xhr2.status === 200) {    
                  if( properties.verboseLog==1)                          
                    console.log("OK92",xhr2);
                  var responseText = xhr2.responseText;                    
                  var obj=JSON.parse(responseText);
                  if( properties.verboseLog==1)
                    console.log("OK8693",obj, obj.status);                          
                  if(obj.status==="204" ){                             
                      console.log("OK INDICE2 204",xhr2);                        
                      const jsonListIndici = JSON.parse(localStorage.getItem("Indice"));
                      updateUI(jsonListIndici);                          
                      doPostStatiMissioniETotaliObiettivi();
                      setLoading(false);                
                  }              
                  else{
                      //status 201
                      console.log("OK INDICE2 201",xhr2);  
                      //console.log("TRTRTRTRTRTR",obj.content);  
                      const jsonListIndici = JSON.parse(obj.content);    
                      const idN = jsonListIndici["IdSeduta"] ?? 801;                      
                      try{                      
                          localStorage.setItem("Indice", obj.content);
                          localStorage.setItem("IndiceVersion", obj.date);
                          localStorage.setItem("IndiceId", idN);                                      
                      }
                      catch(error) {
                          console.log("LOCALSTORAGE ISSUE", error);
                      }                          
                      
                      //console.log("RRRRRRRRR1",jsonListIndici["IdSeduta"])              ;
                      //console.log("RRRRRRRRR2",jsonListIndici.IdSeduta)              ;
                      updateUI(jsonListIndici);   
                      doPostStatiMissioniETotaliObiettivi();
                      setLoading(false);                     
                  }
              } 
              else {                    
                  console.log("Errore 3871: Recuperando indice in doPostSedute2");                      
              }
          }
      };

      xhr2.onerror = function (e) {
          console.error("Error 22", xhr2.statusText);
      };
      
      let urlEncodedData = null;
            
      if( properties.verboseLog==1)
        console.log( "QUINDI00");
      const currentData=localStorage.getItem("IndiceVersion");          
      urlEncodedData = "indexVersion=" + currentData+"&sector="+sector+"&index="+formatDateToDDMMYYYY(dataSeduta)+"&action=checkIndiceSeduta";
      if( properties.verboseLog==1)
        console.log("DATA",urlEncodedData);
      
      if( properties.verboseLog==1)
        console.log("CALVIEW3",urlEncodedData);
      xhr2.send(urlEncodedData);
    }

    const conversionFase= function( index){
        if(index=="0")          
          return "PROVVISORIO -";
        if(index=="1")          
          return "BOZZA -";
        if(index=="2")          
          return "CHIUSURA -";
        if(index=="3")          
          return "POST-CONSOLIDAMENTO -";
    }

    const isPossibleNextFase= function( index){
        if(index=="0")
          return true;
        if(index=="1")
          return true;
        if(index=="2")
          return true;
        if(index=="3")
          return false;
    }

    const conversionSector= function( sector){
      if(sector=="Cultura")
        return "cultura";
      if(sector=="Attrattività")  
        return "attrattivita";
      if(sector=="Competenze")  
        return "competenze";
      if(sector=="Custodia")  
        return "custodia";
      if(sector=="Partecipazione")  
        return "partecipazione";
      if(sector=="Persone")  
        return "persone";
      if(sector=="Abitare")  
        return "abitare";
      if(sector=="Lavoro")  
        return "lavoro";
      if(sector=="Educazione")  
        return "educazione";
      if(sector=="Comunità")  
        return "comunita";
      if(sector=="Inclusione")  
        return "inclusione";
      if(sector=="Pianeta")  
        return "pianeta";
      if(sector=="Ricerca")  
        return "ricerca";
      if(sector=="Innovazione")  
        return "innovazione";     
      if(sector=="Benessere")  
        return "benessere";
      if(sector=="Internazionalizzazione")  
        return "internazionalizzazione";
      if(sector=="Ambiente")  
        return "ambiente";
      if(sector=="DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE")  
        return "direzione_pianificazione";   
      if(sector=="DIREZIONE INNOVAZIONE DI IMPATTO")  
        return "direzione_innovazione_impatto";     
      if(sector=="CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI")  
        return "convenzioni_progetti_speciali";  
      if(sector=="Sviluppo Territorio")  
        return "sviluppoTerritorio";
      if(sector=="INDICE E SITUAZIONE FONDI")  
        return "in_evidenza";
      return "unknown";                 
    }

    const onChanged = function( treeData) {
      
        //chiamata quando viene spostato un oggetto all'interno dell'albero -> non impatta calcolo totali
        //if( properties.verboseLog==1)
          console.log("ON CHANGED",treeData);
        setLoading(true);
        doPostUpdate(treeData);
    }

    const onFabClick= (id, e ) => {                   
        if( properties.verboseLog==1)
          console.log("OFC",e, id,data.IndiceAttrattivita);  
        if(id=='fascicolo'){                        
            console.log("GENERAZIONE FASCICOLO...")
            setLoading(true);
            doPostGeneraFascicolo();
          }  
        if(id=='excel'){            
          setLoading(true);
          doPostPrintToExcel();
        }  
        if(id=='excel_consiglieri'){            
          setLoading(true);
          doPostPrintToExcelConsiglieri();
        }  
        if(id=='excel_with_details'){            
          setLoading(true);
          doPostPrintToExcelWithDetails();
        }
        if(id=='zip'){            
          setLoading(true);
          doPostPrintToZip();
        }
        if(id=='cultura'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("cultura")){
            if( properties.verboseLog==1)
              console.log("DEVO SSBLOCCARE");            
            doPostUnlockObiettivo("cultura");
          } else{
            if( properties.verboseLog==1)
              console.log("DEVO BLOCCARE");
            doPostLockObiettivo("cultura");
          }
        }    
        if(id=='persone'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("persone"))
            doPostUnlockObiettivo("persone");
          else
            doPostLockObiettivo("persone");          
        }                          
        if(id=='pianeta'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("pianeta"))
            doPostUnlockObiettivo("pianeta");
          else
            doPostLockObiettivo("pianeta");          
        }                  
        if(id=='pianificazione_studi'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("direzione_pianificazione"))
            doPostUnlockObiettivo("direzione_pianificazione");
          else
            doPostLockObiettivo("direzione_pianificazione");          
        }        
        if(id=='innovazione_impatto'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("direzione_innovazione_impatto"))
            doPostUnlockObiettivo("direzione_innovazione_impatto");
          else
            doPostLockObiettivo("direzione_innovazione_impatto");          
        }            
        if(id=='convenzioni_progetti_speciali'){            
          setLoading(true);
          setForthLevelButtons(false);
          if(isBloccatoObiettivo("convenzioni_progetti_speciali"))
            doPostUnlockObiettivo("convenzioni_progetti_speciali");
          else
            doPostLockObiettivo("convenzioni_progetti_speciali");          
        }     
        if(id=='tutto'){            
          setLoading(true);
          setForthLevelButtons(false);
          doPostLockObiettivo("all");
        }         
        if(id=='pratica'){            
            setSecondLevelButtons(false);
            setLoading(true);
            doPostAdd("Pratica");                        
        }
        if(id=='documento'){           
            setSecondLevelButtons(false);
            setLoading(true);
            doPostAdd("Documento");
        }
        if(id=='ambito'){           
            setSecondLevelButtons(false);
            setLoading(true);
            doPostAdd("Ambito");
        }
        if(id=='minigrant'){
          setSecondLevelButtons(false);
          if( properties.verboseLog==1)
            console.log("minigrant");
          setLoading(true);
          doPostSwitchMinigrant();
        }
        if(id=='presentazioneMissione'){
          setSecondLevelButtons(false);
          if( properties.verboseLog==1)
            console.log("presentazioneMissione");
          setLoading(true);
          doPostSwitchPresentazioneMissione();
        }
        if(id=='cambiaFase'){
          setSecondLevelButtons(false);
          if( properties.verboseLog==1)
            console.log("cambia Fase");
          setLoading(true);
          doPostCambiaFaseIndice();          
        }
        if(id!='excel'&& id!='excel_consiglieri'&& id!='excel_with_details'){            
          setSecondLevelButtons(false);    
          setForthLevelButtons(false);      
          doPostStatiMissioniETotaliObiettivi();
        }          
    };

    useEffect(() => {     
        //console.log("ID", idSeduta.replaceAll("-",""));
        /*if(idSeduta.replaceAll("-","")>20250000){
          console.log("ID successivo al 2025");
        }else{
          console.log("ID antecedente al 2025");                  
        }*/
        doPostStatiMissioniETotaliObiettivi();
        setLoading(true);
        if(!window.cordova){        
          //CHECK AUTHENTICATION
              var xhr = new XMLHttpRequest();                              
              xhr.open('POST', properties.productionUrl+properties.productionUrlSuffix +'/core/rest/ping.php',true);
              xhr.withCredentials = true;
              xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      
              xhr.onload = function (e) {
                  if (xhr.readyState === 4) {
                      if (xhr.status === 200) {     
                        if( properties.verboseLog==1)                    
                          console.log("OK",xhr);    
                          
                        if(localStorage.getItem("IndiceData")==dataSeduta && sector!=localStorage.getItem("Missione_Indice")){
                          console.log("PRESENTE MA DIVERSO", localStorage.getItem("Missione_Indice_Numero"));
                          if(localStorage.getItem("Missione_Indice_Numero")!=undefined && localStorage.getItem("Missione_Indice_Numero")!="undefined"){
                            console.log("PRESENTE MA DIVERSO DENTRO",localStorage.getItem("Missione_Indice_Numero"));
                            const value=localStorage.getItem("Missione_Indice");
                            handleMenuItemClick(e,localStorage.getItem("Missione_Indice"),localStorage.getItem("Missione_Indice_LabelText"),localStorage.getItem("Missione_Indice_Numero"));
                            /*doPostSedute(value);                            
                            setMenuItemSelected(localStorage.getItem("Missione_Indice_Numero"));
                                
                            if(value=='cultura'||value=='attrattivita'||value=='competenze'||value=='custodia'||value=='partecipazione')
                              setColorItemSelected("#E42568");
                            else if(value=='persone'||value=='abitare'||value=='lavoro'||value=='educazione'||value=='comunita'||value=='inclusione')
                              setColorItemSelected("#F8B902");
                            else if(value=='pianeta'||value=='ricerca'||value=='innovazione'||value=='benessere'||value=='internazionalizzazione'||value=='ambiente'||value=='sviluppoTerritorio')
                              setColorItemSelected("#338FD2");
                            else if(value=='convenzioni_progetti_speciali')
                              setColorItemSelected("#DDDDDD");
                            else if(value=='fuori_sacco')
                              setColorItemSelected("#30720F");
                            else
                              setColorItemSelected("#FAD480");
                            setPrintable(labelText);                                                        
                            doPostStatiMissioniETotaliObiettivi();
                           */ 
                          }
                        }
                        else
                          doPostSedute7();
                        if( properties.verboseLog==1)
                          console.log("Chiamaato", "7");                      
                  } else {
                      console.error("Error 1", xhr);   
                      localStorage.clear();
                      setLoading(false);                             
                      navigate("/indice/login");  
                  }
              }
              };      
              xhr.onerror = function (e) {
                  console.error("Error 2", xhr);
                  localStorage.clear();                
                  navigate("/indice/login");  
              };               
              let urlEncodedData = null; 
              xhr.send(urlEncodedData);
          //CHECK AUTHENTICATION
          }
          if( properties.verboseLog==1){
            console.log ("UE", cards);
            console.log(calculateTotalCost(cards));
          }          
    }, []);


    const calculateTotalCost = (data) => {
      let totalCost = 0;
  
      const traverse = (obj) => {  
          if (obj && typeof obj === 'object') {
              if (obj.hasOwnProperty('IpotesiIntervento')) {
                if( properties.verboseLog==1)
                  console.log("EE",obj['IpotesiIntervento']);
                if(obj['IpotesiIntervento']!='')                                    
                    totalCost += parseFloat(obj.IpotesiIntervento);
              }                
              for (let key in obj) {
                  if (obj.hasOwnProperty(key) && typeof obj[key] === 'object') {
                      traverse(obj[key]); // Recursive call
                  }
              }
          }
      };  
      traverse(data);     
      return totalCost;
    };

    const handleMenuItemClick  = function(e,value, labelText, menuItemNumber) {           
        //if( properties.verboseLog==1)
          console.log("HMIC",value,labelText);
        
        localStorage.removeItem("Indice");
        localStorage.removeItem("IndiceVersion");
        
        localStorage.setItem("IndiceData", idSeduta);
        localStorage.setItem("Missione_Indice", value);
        localStorage.setItem("Missione_Indice_LabelText", labelText);
        localStorage.setItem("Missione_Indice_Numero", menuItemNumber);        
        setSecondLevelButtons(false);
        
        setForthLevelButtons(false);
        setSector(value);
        setLoading(true);        
        doPostSedute(value);
        e.stopPropagation();  
        setMenuItemSelected(menuItemNumber);
            
        if(value=='cultura'||value=='attrattivita'||value=='competenze'||value=='custodia'||value=='partecipazione')
          setColorItemSelected("#E42568");
        else if(value=='persone'||value=='abitare'||value=='lavoro'||value=='educazione'||value=='comunita'||value=='inclusione')
          setColorItemSelected("#F8B902");
        else if(value=='pianeta'||value=='ricerca'||value=='innovazione'||value=='benessere'||value=='internazionalizzazione'||value=='ambiente'||value=='sviluppoTerritorio')
          setColorItemSelected("#338FD2");
        else if(value=='convenzioni_progetti_speciali')
          setColorItemSelected("#DDDDDD");
        else if(value=='fuori_sacco')
          setColorItemSelected("#30720F");
        else if(value=='in_evidenza')
          setColorItemSelected("#30720F");
        else
          setColorItemSelected("#FAD480");
        setPrintable(labelText);
        if( properties.verboseLog==1){
          console.log('handleMenuItemClick', value,e);
          console.log('handleMenuItemClick2', sector);
        }
        
        doPostStatiMissioniETotaliObiettivi();
        if( properties.verboseLog==1)
          console.log("INDEX:"+fromSectorToPosition(value));
    };

    const fromSectorToPosition  = function(value){
      let pos=0;
      if(value=='cultura')
        pos=0;
      if(value=='attrattivita')
      pos=1;
      if(value=='competenze')
      pos=2;
      if(value=='custodia')
      pos=3;
      if(value=='partecipazione')
      pos=4;
      
      if(value=='persone')
      pos=5;
      if(value=='abitare')
      pos=6;
      if(value=='lavoro')
      pos=7;
      if(value=='educazione')
      pos=8;
      if(value=='comunita')
      pos=9;
      if(value=='inclusione')
      pos=10;

      
      if(value=='pianeta')
      pos=11;
      if(value=='ricerca')
      pos=12;
      if(value=='innovazione')
      pos=13;
      if(value=='benessere')
      pos=14;
      if(value=='internazionalizzazione')
      pos=15;
      if(value=='ambiente')
      pos=16;
    
      if(value=='direzione_pianificazione')
      pos=17;

      if(value=='direzione_innovazione_impatto')
      pos=18;
      
      if(value=='convenzioni_progetti_speciali')
      pos=19;
      if(value=='fuori_sacco')
      pos=20;
      
      if(value=='sviluppoTerritorio')
      pos=21;

      if(value=='in_evidenza')
      pos=22;      

      return pos;

    }

    const isPossibleToMoveInto  = function(value){
       var pos=fromSectorToPosition(value);
       var ids=localStorage.getItem("indice");       
       if( properties.verboseLog==1)
          console.log("WW", pos, ids, value, menuLocked[pos]);
       if(menuLocked[pos]==2 || menuLocked[pos]==4)
          return false;

       if ((pos<5) && (ids.includes("1"))){      
          return true;       
       }
       if ((pos>4) && (pos<11) && (ids.includes("2"))){      
          return true;       
       }

       if ((pos>10) && (pos<17) && (ids.includes("3"))){      
          return true;       
       }
       if ((pos==17)  && (ids.includes("4"))){      
          return true;       
       }
       if ((pos==18)  && (ids.includes("5"))){      
          return true;       
       }
       if ((pos==19)  && (ids.includes("6"))){      
          return true;       
       }
       if (pos==21 && (ids.includes("3"))){      
        return true;       
     }
       return false;
    }

    const [scelteDPP, setScelteDPP] = useState({});
    const [errori, setErrori] = useState({}); 
    /*const scelteDisponibiliDPP = {
      "1. Allineamenti": ["Mondo", "Europa/Internazionale", "Italia","Nessuna delle precedenti"],
      "2. Concetti chiave": ["Fiducia", "Rischio","Flessibilità"],
      "3. Trasversalità metodologica": ["Mobilisation & partnership", "Learning", "Advocacy", "Internationalization"],
      "4. Priorità Tematiche": ["Riduzione delle disuguaglianze", "Sviluppo territoriale sostenibile", "Nessuna"],
      "5. Fattori Chiave": ["Supporto al sistema del Welfare", "Sviluppo, rafforzamento e attrazione di competenze", "Opportunità per bambini, giovani, famiglie e persone in condizioni di fragilità",
          "Attivazione dell'ascensore sociale: educazione, formazione e cultura", "Connessione e riequilibrio tra centri e periferie", "Costruzione di cittadinanza, democrazia e diritti",
          "Sostenibilità di luoghi e istituzioni nel post PNRR", "Valorizzazione degli asset dei territori", "Attrazione di investimenti e talenti", "Innovazione di prodotto, di servizio e di processo nelle organizzazioni",
          "Transizioni verde ed energetica", "Divario tecnologico e digitale", "Nessuno"],
      "6. Velocità d'intervento": ["Velocità 1 - Cambiamento sistemico","Velocità 2 - Progetti a impatto","Tenuta del sistema"],
      "7. Tipo di progetto": ["Operativo","Emergenza","Altro"],
    };*/
    const scelteDisponibiliDPP = {
      //"1. Allineamenti": ["Mondo (riferito ad almeno un SDGs)", "Europa/Internazionale (in connessione con la programmazione europea)", "Italia (se riguarda i cantieri PNRR)","Nessuna delle precedenti"],
      "1. Allineamenti": ["Mondo", "Europa", "Italia","Nessuna delle precedenti"],
      "2. Concetti chiave": ["Fiducia", "Rischio","Flessibilità","Nessuna delle precedenti"],
      "3. Trasversalità metodologica": ["Mobilisation & partnership", "Learning", "Advocacy", "Internationalization","Nessuna delle precedenti"],
      //"4. Priorità Tematiche prevalenti": ["Riduzione delle disuguaglianze", "Sviluppo territoriale sostenibile", "Nessuna"],
      "4. Priorità Tematica prevalente": ["Riduzione delle disuguaglianze", "Sviluppo territoriale sostenibile", "Nessuna"],
      "5. Fattori Chiave": ["Supporto al sistema del Welfare", "Sviluppo, rafforzamento e attrazione di competenze", "Opportunità per bambini, giovani, famiglie e persone in condizioni di fragilità",
          "Attivazione dell'ascensore sociale: educazione, formazione e cultura", "Connessione e riequilibrio tra centri e periferie", "Costruzione di cittadinanza, democrazia e diritti",
          "Sostenibilità di luoghi e istituzioni nel post PNRR", "Valorizzazione degli asset dei territori", "Attrazione di investimenti e talenti", "Innovazione di prodotto, di servizio e di processo nelle organizzazioni",
          "Transizioni verde ed energetica", "Divario tecnologico e digitale", "Nessuno"],
      //"6. Velocità d'intervento": ["Cambiamento sistemico","Progetti a impatto","Tenuta del sistema"],
      "6. Velocità d'intervento": ["Cambiamento sistemico","Progetti di sviluppo","Tenuta del sistema"],
      //"7. Tipo/Attributi di progetto": ["Operativo","Emergenza","Prevede attività di capacity building/organizational development","Altro"],
      "7. Tipo/Attributi di progetto": ["Emergenza","Prevede attività di capacity building/organizational development","Altro/Nessuno"],
      //"8. Trasversalità": ["Education","Innovation","Participation","Internationalization","Nessuna delle precedenti"],
      "8. Trasversalità tematica": ["Education","Innovation","Participation","Internationalization","Nessuna delle precedenti"],
    };
    
const validateBozza = (item) => {
  console.log("VAL BOZZA", item);
  if(data.Fase!=0 && data.Fase!='0'){
    if (item.IdRichiesta=="ID Pratica"||item.IdRichiesta.trim()==""){    
      return false;
    }
    if (item.Localizzazione=="Localizzazione"||item.Localizzazione.trim()==""){    
      return false;
    }
    if (item.Descrizione=="Descrizione"||item.Descrizione.trim()==""){    
      return false;			    
    }
    if (item.Descrizione=="Descrizione"||item.Descrizione.trim()==""){    
      return false;			    
    }
    if (item.Ente=="Ente"||item.Ente.trim()==""){
      return false;			    
    }  
  }
  return true;
};

const validateForm2 = (scelte) => {
  console.log("VALIDATE",scelte);
  const nuoviErrori = {};
  if(data.Fase!=0 && data.Fase!='0'){
      Object.keys(scelteDisponibiliDPP).forEach((opzione) => {
        //const isRadio = ["4. Priorità Tematiche prevalenti", "6. Velocità d'intervento"].includes(opzione);
        const isRadio = ["4. Priorità Tematica prevalente", "6. Velocità d'intervento"].includes(opzione);
        //const isRadio = ["4. Priorità Tematiche prevalenti"].includes(opzione);

        if (isRadio) {      
          if (!scelte[opzione]) {
            nuoviErrori[opzione] = "Seleziona un'opzione";
          }
        } else {
          
          if (!scelte[opzione] || !Object.values(scelte[opzione]).some((v) => v)) {
            nuoviErrori[opzione] = "Seleziona almeno una scelta";
          }
        }
      });
      setErrori(nuoviErrori);  
  }
  console.log("VALIDATE2",nuoviErrori);
  return Object.keys(nuoviErrori).length === 0;
};

const validateFormNoSetErrori = (scelte) => {
  const nuoviErrori = {};
  //console.log("validateFormNoSetErrori",scelte);
  if(data.Fase!=0 && data.Fase!='0'){
      Object.keys(scelteDisponibiliDPP).forEach((opzione) => {
        //const isRadio = ["4. Priorità Tematiche prevalenti", "6. Velocità d'intervento"].includes(opzione);
        const isRadio = ["4. Priorità Tematica prevalente", "6. Velocità d'intervento"].includes(opzione);
        //const isRadio = ["4. Priorità Tematiche prevalenti"].includes(opzione);

        if (isRadio) {      
          if (!scelte[opzione]) {
            nuoviErrori[opzione] = "Seleziona un'opzione";
          }
        } else {
          
          if (!scelte[opzione] || !Object.values(scelte[opzione]).some((v) => v)) {
            nuoviErrori[opzione] = "Seleziona almeno una scelta";
          }
        }
      });  
  }
  //console.log("validateFormNoSetErrori", nuoviErrori);
  return Object.keys(nuoviErrori).length === 0;
};

const validateForm = () => {  
  const nuoviErrori = {};
  if(data.Fase!=0 && data.Fase!='0'){
      Object.keys(scelteDisponibiliDPP).forEach((opzione) => {
        //const isRadio = ["4. Priorità Tematiche prevalenti", "6. Velocità d'intervento"].includes(opzione);
        const isRadio = ["4. Priorità Tematica prevalente", "6. Velocità d'intervento"].includes(opzione);
        //const isRadio = ["4. Priorità Tematiche prevalenti"].includes(opzione);

        if (isRadio) {      
          if (!scelteDPP[opzione]) {
            nuoviErrori[opzione] = "Seleziona un'opzione";
          }
        } else {
          
          if (!scelteDPP[opzione] || !Object.values(scelteDPP[opzione]).some((v) => v)) {
            nuoviErrori[opzione] = "Seleziona almeno una scelta";
          }
        }
      });

      setErrori(nuoviErrori);
  }
  //console.log("VAL",Object.keys(nuoviErrori).length === 0, scelteDPP, nuoviErrori, Object.keys(nuoviErrori), Object.keys(nuoviErrori).length, nuoviErrori.length);
  console.log("VAL FORM",nuoviErrori);
  return Object.keys(nuoviErrori).length === 0;
};

const normalizzaRischio = (valore) => {
  if (valore === true) return 1;
  if (valore === false) return 0;
  return valore;
};
/*
const inizializzaImpatto = (valore) => {
  if (valore === true) return 0;
  if (valore === false) return 0;
  return valore;
};
*/
const handleCheckboxChangeDPP = (opzione, sceltaDPP) => {
  setScelteDPP((prev) => {
    const prevValue = prev[opzione]?.[sceltaDPP] || false;
    const newValue = !prevValue; 
    
    if (prevValue !== newValue) {
      console.log(`Valore cambiato: ${sceltaDPP} è ora ${newValue ? "selezionato" : "deselezionato"}`);  
      //console.log("Rischio",sceltaDPP)
      //if(sceltaDPP=='Rischio' && newValue==true){
          //console.log(`RISCHIO`);
          //setDisabledAdditionalRadioButton(true);
      //}      
      setItemChanged(true);
    }
    if(sceltaDPP=='Rischio'){
      //const rischio = prev[opzione]["Rischio"];
      const rischio = prev[opzione]?.["Rischio"] ??0;
      const nuovoValore = rischio === 0 ? 1 : 0; 
      console.log("QWERTYQ", opzione, nuovoValore, newValue, rischio, sceltaDPP);
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: nuovoValore,
        },
      };
    }
    //07/11/25 TEST
    /*
    else if(sceltaDPP=='Progetti a impatto'){
      const imp = prev[opzione]?.["Progetti a impatto"] ??0;
      const nuovoValore = imp === 0 ? 1 : 0; 
      console.log("QWERTYQ", opzione, nuovoValore, imp, sceltaDPP);
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: nuovoValore,
        },
      };
    }*/
    //07/11/25
    else if(opzione=='1. Allineamenti'){
      //console.log("CAZ",opzione, sceltaDPP, scelteDPP, scelteDPP["1. Allineamenti"] );
      if(sceltaDPP!= "Nessuna delle precedenti"){
        delete scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"];
      }
      /*if(scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"] && sceltaDPP== "Nessuna delle precedenti"){
            if (scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"]==true){      
                console.log("DISATTIVO NESSUNA DELLE PRECEDENTI")
            }
      }*/
      if(scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"]!=undefined && sceltaDPP== "Nessuna delle precedenti"){
        //console.log("DEDE",scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"]);
        if (scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"]==false){      
            console.log("ATTIVO NESSUNA DELLE PRECEDENTI");
            //scelteDPP["1. Allineamenti"]["Nessuna delle precedenti"]=true;
            //delete scelteDPP["1. Allineamenti"]?.["Mondo (riferito ad almeno un SDGs)"];
            //delete scelteDPP["1. Allineamenti"]?.["Europa/Internazionale (in connessione con la programmazione europea)"];
            //delete scelteDPP["1. Allineamenti"]?.["Italia (se riguarda i cantieri PNRR)"];
            delete scelteDPP["1. Allineamenti"]?.["Mondo"];
            delete scelteDPP["1. Allineamenti"]?.["Europa"];
            delete scelteDPP["1. Allineamenti"]?.["Italia"];
        }
      }
      if(scelteDPP["1. Allineamenti"]?.["Nessuna delle precedenti"]==undefined && sceltaDPP== "Nessuna delle precedenti"){          
              console.log("ATTIVO NESSUNA DELLE PRECEDENTI");   
              //scelteDPP["1. Allineamenti"]["Nessuna delle precedenti"]=true;
              //delete scelteDPP["1. Allineamenti"]?.["Mondo (riferito ad almeno un SDGs)"];
              //delete scelteDPP["1. Allineamenti"]?.["Europa/Internazionale (in connessione con la programmazione europea)"];
              //delete scelteDPP["1. Allineamenti"]?.["Italia (se riguarda i cantieri PNRR)"];       
              delete scelteDPP["1. Allineamenti"]?.["Mondo"];
              delete scelteDPP["1. Allineamenti"]?.["Europa"];
              delete scelteDPP["1. Allineamenti"]?.["Italia"];
    }

      //console.log("CAZ",opzione, sceltaDPP, scelteDPP, scelteDPP["1. Allineamenti"],scelteDPP["1. Allineamenti"]["Nessuna delle precedenti"] );
      
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: newValue,
        },
      };
    }
    //11/11/25
    else if(opzione=='2. Concetti chiave'){      
      if(sceltaDPP!= "Nessuna delle precedenti"){
        delete scelteDPP["2. Concetti chiave"]?.["Nessuna delle precedenti"];
      }
      
      if(scelteDPP["2. Concetti chiave"]?.["Nessuna delle precedenti"]!=undefined && sceltaDPP== "Nessuna delle precedenti"){        
        if (scelteDPP["2. Concetti chiave"]?.["Nessuna delle precedenti"]==false){      
                        
            delete scelteDPP["2. Concetti chiave"]?.["Fiducia"];
            delete scelteDPP["2. Concetti chiave"]?.["Rischio"];
            delete scelteDPP["2. Concetti chiave"]?.["Flessibilità"];
        }
      }
      if(scelteDPP["2. Concetti chiave"]?.["Nessuna delle precedenti"]==undefined && sceltaDPP== "Nessuna delle precedenti"){                                      
            delete scelteDPP["2. Concetti chiave"]?.["Fiducia"];
            delete scelteDPP["2. Concetti chiave"]?.["Rischio"];
            delete scelteDPP["2. Concetti chiave"]?.["Flessibilità"];
      }
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: newValue,
        },
      };
    }
    else if(opzione=='3. Trasversalità metodologica'){      
      if(sceltaDPP!= "Nessuna delle precedenti"){
        delete scelteDPP["3. Trasversalità metodologica"]?.["Nessuna delle precedenti"];
      }
      
      if(scelteDPP["3. Trasversalità metodologica"]?.["Nessuna delle precedenti"]!=undefined && sceltaDPP== "Nessuna delle precedenti"){        
        if (scelteDPP["3. Trasversalità metodologica"]?.["Nessuna delle precedenti"]==false){      
                        
            delete scelteDPP["3. Trasversalità metodologica"]?.["Mobilisation & partnership"];
            delete scelteDPP["3. Trasversalità metodologica"]?.["Learning"];
            delete scelteDPP["3. Trasversalità metodologica"]?.["Advocacy"];
            delete scelteDPP["3. Trasversalità metodologica"]?.["Internationalization"];
        }
      }
      if(scelteDPP["3. Trasversalità metodologica"]?.["Nessuna delle precedenti"]==undefined && sceltaDPP== "Nessuna delle precedenti"){                                      
          delete scelteDPP["3. Trasversalità metodologica"]?.["Mobilisation & partnership"];
          delete scelteDPP["3. Trasversalità metodologica"]?.["Learning"];
          delete scelteDPP["3. Trasversalità metodologica"]?.["Advocacy"];
          delete scelteDPP["3. Trasversalità metodologica"]?.["Internationalization"];
      }
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: newValue,
        },
      };
    }
    else if(opzione=='8. Trasversalità tematica'){      
      if(sceltaDPP!= "Nessuna delle precedenti"){
        delete scelteDPP["8. Trasversalità tematica"]?.["Nessuna delle precedenti"];
      }
      
      if(scelteDPP["8. Trasversalità tematica"]?.["Nessuna delle precedenti"]!=undefined && sceltaDPP== "Nessuna delle precedenti"){        
        if (scelteDPP["8. Trasversalità tematica"]?.["Nessuna delle precedenti"]==false){                              
            delete scelteDPP["8. Trasversalità tematica"]?.["Education"];
            delete scelteDPP["8. Trasversalità tematica"]?.["Innovation"];
            delete scelteDPP["8. Trasversalità tematica"]?.["Participation"];            
            delete scelteDPP["8. Trasversalità tematica"]?.["Internationalization"];            
        }
      }
      if(scelteDPP["8. Trasversalità tematica"]?.["Nessuna delle precedenti"]==undefined && sceltaDPP== "Nessuna delle precedenti"){                                      
            delete scelteDPP["8. Trasversalità tematica"]?.["Education"];
            delete scelteDPP["8. Trasversalità tematica"]?.["Innovation"];
            delete scelteDPP["8. Trasversalità tematica"]?.["Participation"];
            delete scelteDPP["8. Trasversalità tematica"]?.["Internationalization"];            
      }
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: newValue,
        },
      };
    }
    //11/11/25


    else {
      //console.log("QWERTYW", opzione, newValue, sceltaDPP);
      return {
        ...prev,
        [opzione]: {
          ...prev[opzione],
          [sceltaDPP]: newValue,
        },
      };
    }
  });
};

const handleRadioChangeDPP = (opzione, sceltaDPP) => {

    setScelteDPP((prev) => {
      const prevValue = prev[opzione] || ""; 
            
      if (prevValue !== sceltaDPP) {
        console.log(`Valore cambiato: ${opzione} è ora ${sceltaDPP}`);
        if(opzione.startsWith('4. ') &&sceltaDPP=="Nessuna"){
            console.log("NASCONDO FATTORI CHIAVE");            
            //sceltaDPP=[];
            console.log("PRE",scelteDPP);
            let scelte=scelteDPP;

            for (const key in scelte["5. Fattori Chiave"]) {
              delete scelte["5. Fattori Chiave"][key];
            }
            
            if (!scelte["5. Fattori Chiave"]) {
              scelte["5. Fattori Chiave"] = {};
            }
            // Inserisci "Nessuno"
            scelte["5. Fattori Chiave"]["Nessuno"] = true;
            //scelte["5. Fattori Chiave"]=
            setScelteDPP(scelte);
            console.log("PRE-",scelteDPP["5. Fattori Chiave"]);

            handleCheckboxChangeDPP("5. Fattori Chiave",{});
            console.log("POST",scelteDPP, );
            setDisabledFattoriChiave(true);
        }
        if(opzione.startsWith('4. ') &&sceltaDPP!="Nessuna"){
          console.log("ABILITO FATTORI CHIAVE");
          let scelte=scelteDPP;
          if (scelte?.["5. Fattori Chiave"]) {
            delete scelte["5. Fattori Chiave"]["Nessuno"];
          }
          setScelteDPP(scelte);
          setDisabledFattoriChiave(false);
      }
      if((opzione.startsWith('6.')&&sceltaDPP!="Progetti a impatto")||(opzione.startsWith('6.')&&sceltaDPP!="Progetti di sviluppo")){
        //delete scelteDPP["100. Progetti a impatto"];
        let scelte=scelteDPP;        
        delete scelte["100. Progetti a impatto"];        
        setScelteDPP(scelte);
      }
      //04/07/2026
      if(opzione=="6. Velocità d'intervento"){      
        console.log("VELOCITA ...");
        if((sceltaDPP=="Progetti a impatto"||sceltaDPP=="Progetti di sviluppo")&&!scelteDPP["100. Progetti a impatto"]){
          console.log("Condizioni per aggiungere");
          let scelte=scelteDPP;          
          scelte["100. Progetti a impatto"]='Arcate MOI';          
          setScelteDPP(scelte);
        }
        else
          console.log("Non ci sono le condizioni per aggiungere");
      }

        setItemChanged(true);
      }
  
      return {
        ...prev,
        [opzione]: sceltaDPP, 
      };
    });
};
         
    return (
      <div>
         {dialogMovePratica ? (
           <Dialog open={dialogMovePratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Sposta Pratica</DialogTitle>
           <DialogContent>           
              <div style={{border: "1px solid #d3d3d3", display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%'}}>                   
                <div style={{width:"100%"}}>
                  <div style={{display:'flex', width:'100%'}}> <p className= "textBlackSedute" style={{paddingLeft:"10px",color:"black", marginTop:"10px",marginBottom:"10px" }}> (Pratica 
                    {item.IdRichiesta !='' && item.IdRichiesta !='idRichiesta'  ?(
                    <>, {item.IdRichiesta}</>  ):(<></>)}) <b style={{marginLeft:"10px"}}> {item.Ente} </b></p>              
                    {item.Localizzazione !='' && item.Localizzazione !='Localizzazione'  ? (
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px"}}>,  <b style={{marginLeft:"10px", textTransform:'capitalize'}}> {item.Localizzazione} </b></p> ):(<></>)} 
                  </div>
                  <div style={{display:'flex',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}> <b> {item.Descrizione} </b></p>              
                  </div>                
                  <div style={{display:'flex',marginLeft:"10px",width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}> <b>€ {Euro.format(item.IpotesiIntervento)} </b></p>
                  {item.Note !='' && item.Note !='Note'  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px"}}> * {item.Note}</p>  ):(<></>)}              
                  </div>
              </div>              
            </div>
            <Box> 
          <FormControl fullWidth>          
                <InputLabel id="simple-select-label">Sposta in</InputLabel>
                <Select labelId="simple-select-label"  style={{fontWeight:"bold"}} defaultValue={conversionSector(item.Settore)} label="Sposta in" onChange={handleChange}>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('cultura')} value={'cultura'}>Cultura</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('attrattivita')}value={'attrattivita'}>Attrattività</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('competenze')}value={'competenze'}>Competenze</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('custodia')}value={'custodia'}>Custodia</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('partecipazione')}value={'partecipazione'}>Partecipazione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('persone')}value={'persone'}>Persone</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('abitare')}value={'abitare'}>Abitare</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('lavoro')}value={'lavoro'}>Lavoro</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('educazione')}value={'educazione'}>Educazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('comunita')}value={'comunita'}>Comunità</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('inclusione')}value={'inclusione'}>Inclusione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('pianeta')}value={'pianeta'}>Pianeta</MenuItemMUI>  
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ricerca')}value={'ricerca'}>Ricerca</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('innovazione')}value={'innovazione'}>Innovazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('benessere')}value={'benessere'}>Benessere</MenuItemMUI>
                    {idSeduta.replaceAll("-","")>20250500 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('sviluppoTerritorio')}value={'sviluppoTerritorio'}>Sviluppo Territorio</MenuItemMUI>  
                    ):(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('internazionalizzazione')}value={'internazionalizzazione'}>Internazionalizzazione</MenuItemMUI>
                    )}
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ambiente')}value={'ambiente'}>Ambiente</MenuItemMUI>
      
             {/**        <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_pianificazione')}value={'direzione_pianificazione'}>DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE</MenuItemMUI>  */}
                    {idSeduta.replaceAll("-","")<20250401 ?(
                        <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE INNOVAZIONE DI IMPATTO</MenuItemMUI>                    
                      ):(
                        <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE LEARNING</MenuItemMUI>                    
                    )}    
                    {idSeduta.replaceAll("-","")<20251101 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI</MenuItemMUI>                    
                    ):idSeduta.replaceAll("-","")<20260513 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    ):(
                      console.log("VEDIAMO",idSeduta.replaceAll("-","")),
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    )}   
                    
                </Select>
          </FormControl>
          </Box> 
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogMoveItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogMoveDocumento ? (
          <Dialog open={dialogMoveDocumento} 
              onClose={closeDialogDocumento}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Sposta Documento</DialogTitle>
           <DialogContent>           
              <div className= "textBlackSedute" style={{border: "1px solid #d3d3d3", display:'flex', marginTop:'10px', marginBottom:'20px',  width:'100%'}}>                   
              <div style={{width:"100%"}}>
              <div style={{display:'flex', marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}>(Documento) <b style={{marginLeft:"10px"}}>{item.Descrizione} </b>  </p>           
              </div>
            {item.Note !='' && item.Note !='Note' && item.Note !='Note Documento' ?(
            <div style={{display:'flex', marginLeft:"10px",width:'100%'}}>
            <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}><i >{item.Note}</i>  </p>           
            </div>):(
                <div></div>)
            }
            </div>              
            </div>
            <Box> 
          <FormControl fullWidth>          
                <InputLabel id="simple-select-label">Sposta in</InputLabel>
                <Select labelId="simple-select-label"  style={{fontWeight:"bold"}} defaultValue={conversionSector(item.Settore)} label="Sposta in" onChange={handleChange}>
                    {localStorage.getItem("ruolo")=="5" &&
                        <MenuItemMUI value={'in_evidenza'}>INDICE E SITUAZIONE FONDI</MenuItemMUI>                    
                    }           
                    <MenuItemMUI disabled={!isPossibleToMoveInto('cultura')} value={'cultura'}>Cultura</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('attrattivita')}value={'attrattivita'}>Attrattività</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('competenze')}value={'competenze'}>Competenze</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('custodia')}value={'custodia'}>Custodia</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('partecipazione')}value={'partecipazione'}>Partecipazione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('persone')}value={'persone'}>Persone</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('abitare')}value={'abitare'}>Abitare</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('lavoro')}value={'lavoro'}>Lavoro</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('educazione')}value={'educazione'}>Educazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('comunita')}value={'comunita'}>Comunità</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('inclusione')}value={'inclusione'}>Inclusione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('pianeta')}value={'pianeta'}>Pianeta</MenuItemMUI>  
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ricerca')}value={'ricerca'}>Ricerca</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('innovazione')}value={'innovazione'}>Innovazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('benessere')}value={'benessere'}>Benessere</MenuItemMUI>
                    {idSeduta.replaceAll("-","")>20250500 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('sviluppoTerritorio')}value={'sviluppoTerritorio'}>Sviluppo Territorio</MenuItemMUI>  
                    ):(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('internazionalizzazione')}value={'internazionalizzazione'}>Internazionalizzazione</MenuItemMUI>
                    )}                   
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ambiente')}value={'ambiente'}>Ambiente</MenuItemMUI>
      
                {/**    <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_pianificazione')}value={'direzione_pianificazione'}>DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE</MenuItemMUI>  */} 
                    {idSeduta.replaceAll("-","")<20250401 ?(
                        <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE INNOVAZIONE DI IMPATTO</MenuItemMUI>                                       
                      ):(
                        <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE LEARNING</MenuItemMUI>                                       
                      )}    
                      
                    {idSeduta.replaceAll("-","")<20251101 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI</MenuItemMUI>                    
                    ):idSeduta.replaceAll("-","")<20260513 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    ):(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    )}

                    {/*  {idSeduta.replaceAll("-","")<20251101 ?(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI</MenuItemMUI>                    
                    ):(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    )}
                    */}
                 

                 </Select>
          </FormControl>
          </Box> 
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogMoveItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogDocumento} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
          </Dialog>
          ):(<></>)}

         {dialogMoveAmbito ? (
          <Dialog open={dialogMoveAmbito} 
              onClose={closeDialogAmbito}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute"sx={{fontWeight:'bold'}}>Sposta Ambito</DialogTitle>
           <DialogContent>           
              <div style={{border: "1px solid #d3d3d3", display:'flex', marginTop:'10px', marginBottom:'20px', fontSize:'large', width:'100%'}}>                   
                <div style={{width:"100%"}}>
                    <div style={{display:'flex',width:'100%'}}> <p className= "textBlackSedute" style={{paddingLeft:"10px",color:"black"}}>(Ambito) <b style={{marginLeft:"10px"}}> {item.Descrizione} </b></p>           
                    </div>              
                </div>              
              </div>
            <Box> 
          <FormControl fullWidth>          
                <InputLabel id="simple-select-label">Sposta in</InputLabel>
                <Select labelId="simple-select-label"  style={{fontWeight:"bold"}} defaultValue={conversionSector(item.Settore)} label="Sposta in" onChange={handleChange}>
                <MenuItemMUI disabled={!isPossibleToMoveInto('cultura')} value={'cultura'}>Cultura</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('attrattivita')}value={'attrattivita'}>Attrattività</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('competenze')}value={'competenze'}>Competenze</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('custodia')}value={'custodia'}>Custodia</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('partecipazione')}value={'partecipazione'}>Partecipazione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('persone')}value={'persone'}>Persone</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('abitare')}value={'abitare'}>Abitare</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('lavoro')}value={'lavoro'}>Lavoro</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('educazione')}value={'educazione'}>Educazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('comunita')}value={'comunita'}>Comunità</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('inclusione')}value={'inclusione'}>Inclusione</MenuItemMUI>

                    <MenuItemMUI disabled={!isPossibleToMoveInto('pianeta')}value={'pianeta'}>Pianeta</MenuItemMUI>  
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ricerca')}value={'ricerca'}>Ricerca</MenuItemMUI>                    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('innovazione')}value={'innovazione'}>Innovazione</MenuItemMUI>
                    <MenuItemMUI disabled={!isPossibleToMoveInto('benessere')}value={'benessere'}>Benessere</MenuItemMUI>
                    {idSeduta.replaceAll("-","")>20250500 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('sviluppoTerritorio')}value={'sviluppoTerritorio'}>Sviluppo Territorio</MenuItemMUI>  
                    ):(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('internazionalizzazione')}value={'internazionalizzazione'}>Internazionalizzazione</MenuItemMUI>
                    )}    
                    <MenuItemMUI disabled={!isPossibleToMoveInto('ambiente')}value={'ambiente'}>Ambiente</MenuItemMUI>
      
              {/**       <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_pianificazione')}value={'direzione_pianificazione'}>DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE</MenuItemMUI>  */}
              {idSeduta.replaceAll("-","")<20250401 ?(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE INNOVAZIONE DI IMPATTO</MenuItemMUI>                                        
                    ):(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('direzione_innovazione_impatto')}value={'direzione_innovazione_impatto'}>DIREZIONE LEARNING</MenuItemMUI>                                        
                      )}      
                    {idSeduta.replaceAll("-","")<20251101 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI</MenuItemMUI>                    
                    ):idSeduta.replaceAll("-","")<20260513 ?(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    ):(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    )}
                    {/** 
                    {idSeduta.replaceAll("-","")<20251101 ?(
                    <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI</MenuItemMUI>                    
                    ):(
                      <MenuItemMUI disabled={!isPossibleToMoveInto('convenzioni_progetti_speciali')}value={'convenzioni_progetti_speciali'}>PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</MenuItemMUI>                    
                    )}
                    */}
               </Select>
          </FormControl>
          </Box> 
          <div style={{display:'flex', marginLeft:"10px",width:'100%'}}>
                <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}><i >* insieme all'ambito verranno spostate anche eventuali pratiche e documenti presenti</i>  </p>           
              </div>  
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogMoveItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogAmbito} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
             
           </DialogActions>
          </Dialog>
          ):(<></>)}

         {dialogPratica && data.Fase!=0 && data.Fase != 3 && !isBloccataMissione() ? (       
          console.log("WERW",data, isBloccatoObiettivo(),isBloccataMissione()),
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField  label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}
                    disabled={isBloccataMissione()}
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    required
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      //item.IdRichiesta=e.target.value; 
                      let ad=e.target.value;
                      ad=ad.replaceAll(";",",");
                      ad=ad.replaceAll("-",",");
                      ad=ad.replaceAll("+",",");                      
                      ad=ad.replaceAll(", ",",");                      
                      ad=ad.replaceAll(","," ");                      
                      item.IdRichiesta=ad; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","idRichiesta", item.IdRichiesta) ? 'red' : 'black'} }} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 14}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"
                    //color="warning"
                    required
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);   
                      item.Ente=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","Ente", item.Ente) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"
                    //color="warning"
                    required
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Localizzazione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,  color: !checkAttributo("Pratica","Localizzazione", item.Localizzazione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    //color="warning"
                    required
                    size='large'
                    rows="4"
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Pratica","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                  
              
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"
                    //color="warning"
                    required
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                                            
                      //e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                     
                      item.IpotesiIntervento=e.target.value;
                      //setItemChanged(true); 
                    }}

                    onBlur={(e) => {                                            
                      e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                     
                      item.IpotesiIntervento=e.target.value;
                      setItemChanged(true); 
                    }}

                    inputProps={{style: {fontSize: 18}}} // font size of input text                    
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />           
               </div>
              {idSeduta.replaceAll("-","")<20260101 ? (
               <ProvenienzaRisorse
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  optionsMissioniBoth={optionsMissioniBoth}
                  optionsTesoretto={optionsTesoretto} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={false}
                />):(
                  <ProvenienzaRisorse2026
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  handleAutocompleteChange2={handleAutocompleteChange2}
                  optionsMissioniBoth={optionsMissioniBoth2026}
                  optionsTesoretto={optionsTesoretto2026} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={false}
                />
                )}
             
               {/**  DA QUI DPP*/}
               <MonitoraggioDPP
                  scelteDisponibiliDPP={scelteDisponibiliDPP}
                  scelteDPP={scelteDPP}
                  handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                  handleRadioChangeDPP={handleRadioChangeDPP}
                  handleRischioRadioChange={handleRischioRadioChange}
                  handleImpattoSelectChange={handleImpattoSelectChange}
                  disabledFattoriChiave={disabledFattoriChiave}
                  errori={errori}
                />
               {/** A QUI DPP*/}
             
             
               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   

               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    //color="warning"
                    //required
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    rows="4"
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Note=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogPratica && data.Fase!=0 && data.Fase != 3 && isBloccataMissione()? (       
          //console.log("WERW",data, isBloccatoObiettivo(),isBloccataMissione()),
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>                   
                <TextField  label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}                    
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    disabled                    
                    required
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","idRichiesta", item.IdRichiesta) ? 'red' : 'black'} }} 
                    FormHelperTextProps={{style: {fontSize: 14}}} 
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"
                    disabled
                    required
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","Ente", item.Ente) ? 'red' : 'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"
                    disabled
                    required
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,  color: !checkAttributo("Pratica","Localizzazione", item.Localizzazione) ? 'red' : 'black'}}}
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    disabled
                    required
                    size='large'
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Pratica","Descrizione", item.Descrizione) ? 'red' : 'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                                        
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                                
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"
                    disabled
                    required
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />           
               </div>
               {idSeduta.replaceAll("-","")<20260101 ? (
               <ProvenienzaRisorse
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  optionsMissioniBoth={optionsMissioniBoth}
                  optionsTesoretto={optionsTesoretto} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={true}
                />):(
                  <ProvenienzaRisorse2026
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  handleAutocompleteChange2={handleAutocompleteChange2}
                  optionsMissioniBoth={optionsMissioniBoth2026}
                  optionsTesoretto={optionsTesoretto2026} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={true}
                />
                )}
             
               {/**  DA QUI DPP*/}
               <MonitoraggioDPP
                  scelteDisponibiliDPP={scelteDisponibiliDPP}
                  scelteDPP={scelteDPP}
                  handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                  handleRadioChangeDPP={handleRadioChangeDPP}
                  handleRischioRadioChange={handleRischioRadioChange}
                  handleImpattoSelectChange={handleImpattoSelectChange}
                  disabledFattoriChiave={disabledFattoriChiave}
                  errori={errori}
                />
               {/** A QUI DPP*/}
             
             
               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   

               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    disabled
                    size='large'                    
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline                    
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogPratica && data.Fase == 3 && isFuoriSacco() ? (                    
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField  label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()}                     
                    size='large'
                    onChange={(e) => {                                            
                      let ad=e.target.value;
                      ad=ad.replaceAll(";",",");
                      ad=ad.replaceAll("-",",");
                      ad=ad.replaceAll("+",",");                      
                      ad=ad.replaceAll(", ",",");                      
                      ad=ad.replaceAll(","," ");                      
                      item.IdRichiesta=ad; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                                         
                    FormHelperTextProps={{style: {fontSize: 14}}} 
                    
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"                                        
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                                            
                      item.Ente=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"                                        
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                                            
                      item.Localizzazione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"                    
                    size='large'
                    rows="4"
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                                            
                      item.Descrizione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                    
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                  
              
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"                                        
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {       
                      e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                                                        
                      item.IpotesiIntervento=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />                         
                  <TextField label="Importo Deliberato €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiDeliberata!=''&&item.IpotesiDeliberata != undefined ? Euro.format(item.IpotesiDeliberata): "€ 0.00"}
                    variant="outlined"                                        
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {     
                      e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                     
                      if( properties.verboseLog==1) 
                        console.log("ON CHANGE", e.target.value);       
                      if(e.target.value =="€ 0.00")                                  
                        item.IpotesiDeliberata=0.00;
                      else
                        item.IpotesiDeliberata=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{ style: {fontSize: 18}}}
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}}
                />
               </div>
               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>
               <TextField label="Info Delibera"
                  style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}                  
                  defaultValue={item.InfoDelibera!=''&&item.InfoDelibera!=undefined ? item.InfoDelibera: "Eventuali decisioni quali: Rinviata, Rigettata, etc."}
                  variant="outlined"                    
                  size='large'
                  onFocus={(e) => e.target.select()} 
                  rows="4"
                  onChange={(e) => {                                            
                    item.InfoDelibera=e.target.value;
                    setItemChanged(true); }}
                  inputProps={{style: {fontSize: 18}}} 
                  InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                  FormHelperTextProps={{style: {fontSize: 16}}}                   
              />                                             
              </div> 
              {idSeduta.replaceAll("-","")<20260101 ? (
                  <ProvenienzaRisorse
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      optionsMissioniBoth={optionsMissioniBoth}
                      optionsTesoretto={optionsTesoretto} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />):(
                      <ProvenienzaRisorse2026
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      handleAutocompleteChange2={handleAutocompleteChange2}
                      optionsMissioniBoth={optionsMissioniBoth2026}
                      optionsTesoretto={optionsTesoretto2026} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />
                    )}

                   {/**  DA QUI DPP*/}
                   <MonitoraggioDPP
                      scelteDisponibiliDPP={scelteDisponibiliDPP}
                      scelteDPP={scelteDPP}
                      handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                      handleRadioChangeDPP={handleRadioChangeDPP}
                      handleRischioRadioChange={handleRischioRadioChange}
                      handleImpattoSelectChange={handleImpattoSelectChange}
                      disabledFattoriChiave={disabledFattoriChiave}
                      errori={errori}
                    />
                   {/** A QUI DPP*/}                            

               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>

               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"                    
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    rows="5"
                    onChange={(e) => {                                            
                      item.Note=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                    
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}
          
         {dialogPratica && data.Fase == 3 && !isFuoriSacco() && localStorage.getItem("ruolo")=="5"? (
         //console.log("ZZZZZ",data, isBloccatoObiettivo(),isBloccataMissione()),
         <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField  label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"                    
                    required
                    disabled
                    size='large'                  
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    //InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","idRichiesta", item.IdRichiesta) ? 'red' : 'black'} }} // font size of input label
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 14}}} // font size of input label                                        
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"                    
                    required
                    disabled
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    //InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","Ente", item.Ente) ? 'red' : 'black'}}} // font size of input label
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"                    
                    required
                    disabled
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    //InputLabelProps={ {style: {fontSize: 16,  color: !checkAttributo("Pratica","Localizzazione", item.Localizzazione) ? 'red' : 'black'}}} // font size of input label
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    disabled
                    required
                    size='large'
                    rows="4"                                        
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    //InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Pratica","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline                    
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                  
              
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00"}
                    variant="outlined"                    
                    required
                    disabled
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                />  
                 <TextField label="Importo Deliberato €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiDeliberata!='' ? Euro.format(item.IpotesiDeliberata): "€ 0.00"}
                    variant="outlined"                                        
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {    
                      //console.log("TTT");        
                      e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                    
                      item.IpotesiDeliberata=e.target.value;                      
                      setItemChanged(true); }}
                    inputProps={{  style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                />           
               </div>

               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>
                <TextField label="Info Delibera"
                  style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                  defaultValue={item.InfoDelibera!=''&&item.InfoDelibera!=undefined ? item.InfoDelibera: "Eventuali decisioni quali: Rinviata, Rigettata, etc."}
                  variant="outlined"                    
                  size='large'
                  onFocus={(e) => e.target.select()} 
                  rows="4"
                  onChange={(e) => {                                            
                    item.InfoDelibera=e.target.value;
                    setItemChanged(true); }}
                  inputProps={{style: {fontSize: 18}}} 
                  InputLabelProps={ {style: {fontSize: 16, color:'black'}}} // font size of input label
                  FormHelperTextProps={{style: {fontSize: 16}}}                   
               />                                             
               </div>   
               {idSeduta.replaceAll("-","")<20260101 ? ( 
                <ProvenienzaRisorse
                    checkboxState={checkboxState}
                    dynamicFields={dynamicFields}
                    handleCheckboxChange={handleCheckboxChange}
                    handleTextFieldChange={handleTextFieldChange}
                    handleTextFieldChange2={handleTextFieldChange2}
                    handleTextFieldChange3={handleTextFieldChange3}
                    handleAddRow={handleAddRow}
                    handleRemoveRow={handleRemoveRow}
                    handleAutocompleteChange={handleAutocompleteChange}
                    optionsMissioniBoth={optionsMissioniBoth}
                    optionsTesoretto={optionsTesoretto} 
                    optionsLasciti={optionsLasciti}
                    idSeduta={idSeduta}
                    isDisabled={false}
                  />):(
                    <ProvenienzaRisorse2026
                    checkboxState={checkboxState}
                    dynamicFields={dynamicFields}
                    handleCheckboxChange={handleCheckboxChange}
                    handleTextFieldChange={handleTextFieldChange}
                    handleTextFieldChange2={handleTextFieldChange2}
                    handleTextFieldChange3={handleTextFieldChange3}
                    handleAddRow={handleAddRow}
                    handleRemoveRow={handleRemoveRow}
                    handleAutocompleteChange={handleAutocompleteChange}
                    handleAutocompleteChange2={handleAutocompleteChange2}
                    optionsMissioniBoth={optionsMissioniBoth2026}
                    optionsTesoretto={optionsTesoretto2026} 
                    optionsLasciti={optionsLasciti}
                    idSeduta={idSeduta}
                    isDisabled={false}
                  />
                  )}
            
              
                  {/**  DA QUI DPP*/}
                  <MonitoraggioDPP
                      scelteDisponibiliDPP={scelteDisponibiliDPP}
                      scelteDPP={scelteDPP}
                      handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                      handleRadioChangeDPP={handleRadioChangeDPP}
                      handleRischioRadioChange={handleRischioRadioChange}
                      handleImpattoSelectChange={handleImpattoSelectChange}
                      disabledFattoriChiave={disabledFattoriChiave}
                      errori={errori} />
                  {/** A QUI DPP*/}


            
               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   

               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    //disabled
                    size='large'                    
                    rows="4"                                        
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Note=e.target.value;
                      setItemChanged(true); }}                    
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline    

                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogPratica && data.Fase == 3 && !isFuoriSacco() && localStorage.getItem("ruolo")=="4"? (

          console.log("WERW",data, isBloccatoObiettivo(),isBloccataMissione()),
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>                   
                <TextField  label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}                    
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    disabled              
                    required
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","idRichiesta", item.IdRichiesta) ? 'red' : 'black'} }} 
                    FormHelperTextProps={{style: {fontSize: 14}}} 
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"
                    disabled
                    required
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Pratica","Ente", item.Ente) ? 'red' : 'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"
                    disabled
                    required
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,  color: !checkAttributo("Pratica","Localizzazione", item.Localizzazione) ? 'red' : 'black'}}}
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    disabled
                    required
                    size='large'
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Pratica","Descrizione", item.Descrizione) ? 'red' : 'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                                        
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                                
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"
                    disabled
                    required
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />           
               </div>
               {idSeduta.replaceAll("-","")<20260101 ? ( 
               <ProvenienzaRisorse
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  optionsMissioniBoth={optionsMissioniBoth}
                  optionsTesoretto={optionsTesoretto} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={true}
                />):(
                  <ProvenienzaRisorse2026
                  checkboxState={checkboxState}
                  dynamicFields={dynamicFields}
                  handleCheckboxChange={handleCheckboxChange}
                  handleTextFieldChange={handleTextFieldChange}
                  handleTextFieldChange2={handleTextFieldChange2}
                  handleTextFieldChange3={handleTextFieldChange3}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  handleAutocompleteChange={handleAutocompleteChange}
                  handleAutocompleteChange2={handleAutocompleteChange2}
                  optionsMissioniBoth={optionsMissioniBoth2026}
                  optionsTesoretto={optionsTesoretto2026} 
                  optionsLasciti={optionsLasciti}
                  idSeduta={idSeduta}
                  isDisabled={true}
                />
                )}
             
               {/**  DA QUI DPP*/}
                <MonitoraggioDPP
                  scelteDisponibiliDPP={scelteDisponibiliDPP}
                  scelteDPP={scelteDPP}
                  handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                  handleRadioChangeDPP={handleRadioChangeDPP}
                  handleRischioRadioChange={handleRischioRadioChange}
                  handleImpattoSelectChange={handleImpattoSelectChange}
                  disabledFattoriChiave={disabledFattoriChiave}
                  errori={errori}
                />
               {/** A QUI DPP*/}
             
             
               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   

               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    disabled
                    size='large'                    
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color:'black'}}}                   
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline                    
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}
         
         {dialogPratica && (data.Fase==0 ) && !isBloccataMissione() ? (    
          console.log("ZERO"),      
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    //color="warning"
                    //required
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);   
                      let ad=e.target.value;
                      ad=ad.replaceAll(";",",");
                      ad=ad.replaceAll("-",",");
                      ad=ad.replaceAll("+",",");                      
                      ad=ad.replaceAll(", ",",");                      
                      ad=ad.replaceAll(","," ");
                      //item.IdRichiesta=e.target.value; 
                      item.IdRichiesta=ad; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    //color="warning"
                    //required
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);   
                      item.Ente=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    //color="warning"
                    //required
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Localizzazione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    //color="warning"
                    //required
                    size='large'
                    rows="4"
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                  
              
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    //color="warning"
                    required
                    size='large'
                    onChange={(e) => {         
                      e.target.value = e.target.value.replace(/[^0-9,]/g, "");                                                  
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.IpotesiIntervento=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />           
               </div>
               {idSeduta.replaceAll("-","")<20260101 ? ( 
                  <ProvenienzaRisorse
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      optionsMissioniBoth={optionsMissioniBoth}
                      optionsTesoretto={optionsTesoretto} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />):(
                      <ProvenienzaRisorse2026
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      handleAutocompleteChange2={handleAutocompleteChange2}
                      optionsMissioniBoth={optionsMissioniBoth2026}
                      optionsTesoretto={optionsTesoretto2026} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />
                    )}

                  {/**  DA QUI DPP*/}
                  <MonitoraggioDPP
                    scelteDisponibiliDPP={scelteDisponibiliDPP}
                    scelteDPP={scelteDPP}
                    handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                    handleRadioChangeDPP={handleRadioChangeDPP}
                    handleRischioRadioChange={handleRischioRadioChange}
                    handleImpattoSelectChange={handleImpattoSelectChange}
                    disabledFattoriChiave={disabledFattoriChiave}
                    errori={errori}
                  />
                  {/** A QUI DPP*/}

               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                 
               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    onFocus={(e) => e.target.select()} 
                    //color="warning"
                    //required
                    size='large'
                    rows="4"
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Note=e.target.value;
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    multiline
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogPratica && (data.Fase==0 ) && isBloccataMissione()? (    
          console.log("ZERO BLOCCATA"),      
           <Dialog open={dialogPratica} 
              onClose={closeDialogPratica}            
              maxWidth={"xl"} fullWidth={true} >
           <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Pratica</DialogTitle>
           <DialogContent>
           <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Numero Pratica o Id ROL"
                    style={{marginLeft:"10px", width:"25%"}}
                    defaultValue={item.IdRichiesta!='' ? item.IdRichiesta: "idRichiesta"}
                    variant="outlined"
                    disabled                    
                    size='large'                                        
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />

                <TextField label="Ente Richiedente"
                    style={{marginLeft:"20px", width:"75%"}}
                    defaultValue={item.Ente!='' ? item.Ente: "Ente"}
                    variant="outlined"
                    disabled                        
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    
                />
                </div>
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Localizzazione"
                    style={{marginLeft:"10px", width:"35%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Localizzazione!='' ? item.Localizzazione: "Localizzazione"}
                    variant="outlined"
                    disabled                        
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
                </div>
                
                <div style={{display:'flex', marginTop:'20px',width:'100%'}}>   
                <TextField label="Titolo Iniziativa"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Descrizione"}
                    variant="outlined"
                    disabled                                            
                    size='large'
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                    
                />                
              </div> 
              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                  
              
              <TextField label="Ipotesi Intervento €"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.IpotesiIntervento!='' ? Euro.format(item.IpotesiIntervento): "€ 0.00 "}
                    variant="outlined"
                    disabled                                            
                    required
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                />           
               </div>
               {idSeduta.replaceAll("-","")<20260101 ? ( 
                  <ProvenienzaRisorse
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      optionsMissioniBoth={optionsMissioniBoth}
                      optionsTesoretto={optionsTesoretto} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />):(
                      <ProvenienzaRisorse2026
                      checkboxState={checkboxState}
                      dynamicFields={dynamicFields}
                      handleCheckboxChange={handleCheckboxChange}
                      handleTextFieldChange={handleTextFieldChange}
                      handleTextFieldChange2={handleTextFieldChange2}
                      handleTextFieldChange3={handleTextFieldChange3}
                      handleAddRow={handleAddRow}
                      handleRemoveRow={handleRemoveRow}
                      handleAutocompleteChange={handleAutocompleteChange}
                      handleAutocompleteChange2={handleAutocompleteChange2}
                      optionsMissioniBoth={optionsMissioniBoth2026}
                      optionsTesoretto={optionsTesoretto2026} 
                      optionsLasciti={optionsLasciti}
                      idSeduta={idSeduta}
                      isDisabled={false}
                    />
                    )}

                  {/**  DA QUI DPP*/}
                  <MonitoraggioDPP
                    scelteDisponibiliDPP={scelteDisponibiliDPP}
                    scelteDPP={scelteDPP}
                    handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                    handleRadioChangeDPP={handleRadioChangeDPP}
                    handleRischioRadioChange={handleRischioRadioChange}
                    handleImpattoSelectChange={handleImpattoSelectChange}
                    disabledFattoriChiave={disabledFattoriChiave}
                    errori={errori}
                  />
                  {/** A QUI DPP*/}

               <div style={{display:'flex', marginTop:'20px',width:'100%'}}>                 
               <TextField label="Note"
                    style={{marginLeft:"10px", width:"100%", minWidth:"150px", width:"100%",textTransform:'capitalize'}}
                    defaultValue={item.Note!='' ? item.Note: "Note"}
                    variant="outlined"
                    disabled                        
                    size='large'
                    rows="4"                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16,color:'black'}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}} 
                    multiline                    
                />                                             
              </div>
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItem} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogPratica} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

        {dialogAmbito && data.Fase!=3 ? (
           <Dialog open={dialogAmbito} 
              onClose={closeDialogAmbito}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Ambito</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>                   
                <TextField label="Nome Ambito"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Ambito"}
                    variant="outlined"
                    //color="warning"
                    required
                    onFocus={(e) => e.target.select()} 
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Ambito","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                />               
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItemNoPratica} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogAmbito} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         {dialogAmbito && (data.Fase==3 && isFuoriSacco())? (
           <Dialog open={dialogAmbito} 
              onClose={closeDialogAmbito}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Ambito</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Nome Ambito"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Ambito"}
                    variant="outlined"
                    //color="warning"
                    required
                    onFocus={(e) => e.target.select()} 
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16,color: !checkAttributo("Ambito","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label
                    //focused
                    //helperText="Identifico ROL o ID Sime"
                />

               
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItemNoPratica} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogAmbito} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}
          
          {dialogAmbito && (data.Fase==3 && !isFuoriSacco())? (
           <Dialog open={dialogAmbito} 
              onClose={closeDialogAmbito}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Ambito</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>                   
                <TextField label="Nome Ambito"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Ambito"}
                    variant="outlined"                    
                    disabled                                        
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />

               
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>             
             <Button onClick={closeDialogAmbito} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

          {dialogDocumento && data.Fase!=3 && !isBloccataMissione() ? (
           <Dialog open={dialogDocumento} 
              onClose={closeDialogDocumento}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Documento</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Nome Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Documento"}
                    variant="outlined"
                    //color="warning"
                    required
                    onFocus={(e) => e.target.select()} 
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Documento","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                    //helperText="Identifico ROL o ID Sime"
                />
              </div>
                {/**  DA QUI DPP
                <MonitoraggioDPP
                  scelteDisponibiliDPP={scelteDisponibiliDPP}
                  scelteDPP={scelteDPP}
                  handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                  handleRadioChangeDPP={handleRadioChangeDPP}
                  handleRischioRadioChange={handleRischioRadioChange}
                  disabledFattoriChiave={disabledFattoriChiave}
                  errori={errori}
                />
                A QUI DPP*/}

              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>         
              <TextField label="Note Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Note!='' ? item.Note: "Note Documento"}
                    variant="outlined"
                    //color="warning"                    
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    rows="4"
                    multiline
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Note=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                    //helperText="Identifico ROL o ID Sime"
                />                       
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItemNoPratica} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogDocumento} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

          {dialogDocumento && data.Fase!=3 && isBloccataMissione() ? (
           <Dialog open={dialogDocumento} 
              onClose={closeDialogDocumento}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Documento</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Nome Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Documento"}
                    variant="outlined"
                    disabled
                    required                   
                    size='large'                   
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Documento","Descrizione", item.Descrizione) ? 'red' : 'black'}}}
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
              </div>
                {/**  DA QUI DPP
                <MonitoraggioDPP
                  scelteDisponibiliDPP={scelteDisponibiliDPP}
                  scelteDPP={scelteDPP}
                  handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                  handleRadioChangeDPP={handleRadioChangeDPP}
                  handleRischioRadioChange={handleRischioRadioChange}
                  disabledFattoriChiave={disabledFattoriChiave}
                  errori={errori}
                />
                A QUI DPP*/}

              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>         
              <TextField label="Note Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Note!='' ? item.Note: "Note Documento"}
                    variant="outlined"
                    disabled
                    size='large'                    
                    rows="4"
                    multiline                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16}}}
                    FormHelperTextProps={{style: {fontSize: 16}}}                    
                />                       
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItemNoPratica} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogDocumento} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

          {dialogDocumento && (data.Fase==3 && isFuoriSacco()) ? (
           <Dialog open={dialogDocumento} 
              onClose={closeDialogDocumento}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Documento</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Nome Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Documento"}
                    variant="outlined"
                    //color="warning"
                    required
                    onFocus={(e) => e.target.select()} 
                    size='large'
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Descrizione=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16, color: !checkAttributo("Documento","Descrizione", item.Descrizione) ? 'red' : 'black'}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                    //helperText="Identifico ROL o ID Sime"
                />
              </div>
                  {/**  DA QUI DPP
                  <MonitoraggioDPP
                    scelteDisponibiliDPP={scelteDisponibiliDPP}
                    scelteDPP={scelteDPP}
                    handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                    handleRadioChangeDPP={handleRadioChangeDPP}
                    handleRischioRadioChange={handleRischioRadioChange}
                    disabledFattoriChiave={disabledFattoriChiave}
                    errori={errori}
                  />
                  A QUI DPP*/}

              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>         
              <TextField label="Note Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Note!='' ? item.Note: "Note Documento"}
                    variant="outlined"
                    //color="warning"                    
                    size='large'
                    onFocus={(e) => e.target.select()} 
                    rows="4"
                    multiline
                    onChange={(e) => {                      
                      //console.log("AAAWWW",pratica.IdRichiesta,e.target.value);    
                      item.Note=e.target.value; 
                      setItemChanged(true); }}
                    inputProps={{style: {fontSize: 18}}} // font size of input text
                    InputLabelProps={ {style: {fontSize: 16}}} // font size of input label
                    FormHelperTextProps={{style: {fontSize: 16}}} // font size of input label                    
                    //helperText="Identifico ROL o ID Sime"
                />                       
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>
             <Button onClick={saveDialogItemNoPratica} style={{fontSize:18}}
             color="warning" size='large'>
               Salva
             </Button>
             <Button onClick={closeDialogDocumento} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

          {dialogDocumento && data.Fase==3 && !isFuoriSacco() ? (
           <Dialog open={dialogDocumento} 
              onClose={closeDialogDocumento}            
              maxWidth={"xl"} fullWidth={true} >
            <DialogTitle className= "textBlackSedute" sx={{fontWeight:'bold'}}>Modifica Documento</DialogTitle>
            <DialogContent>
            <div style={{width:"100%"}}>
              <div style={{display:'flex', marginTop:'10px',width:'100%'}}>          
         
                <TextField label="Nome Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Descrizione!='' ? item.Descrizione: "Nome Documento"}
                    variant="outlined"                                        
                    disabled                    
                    size='large'                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />
              </div>
                  {/**  DA QUI DPP
                  <MonitoraggioDPP
                    scelteDisponibiliDPP={scelteDisponibiliDPP}
                    scelteDPP={scelteDPP}
                    handleCheckboxChangeDPP={handleCheckboxChangeDPP}
                    handleRadioChangeDPP={handleRadioChangeDPP}
                    handleRischioRadioChange={handleRischioRadioChange}
                    disabledFattoriChiave={disabledFattoriChiave}
                    errori={errori}
                  />
                   A QUI DPP*/}

              <div style={{display:'flex', marginTop:'20px',width:'100%'}}>         
              <TextField label="Note Documento"
                    style={{marginLeft:"10px", width:"100%"}}
                    defaultValue={item.Note!='' ? item.Note: "Note Documento"}
                    variant="outlined"                    
                    size='large'
                    disabled
                    rows="4"
                    multiline                    
                    inputProps={{style: {fontSize: 18}}} 
                    InputLabelProps={ {style: {fontSize: 16}}} 
                    FormHelperTextProps={{style: {fontSize: 16}}}                     
                />                       
                </div>                                                                   
          </div>
           </DialogContent>
           <DialogActions>             
             <Button onClick={closeDialogDocumento} style={{fontSize:18}}
             color="primary" size='large'>
               Chiudi
             </Button>
           </DialogActions>
         </Dialog>
          ):(<></>)}

         
      {loading ? (
        <div style={{ width:"25%",   display: "flex",
        marginLeft: "auto", marginRight: "auto" }}>
         <ThreeDots color="#30720f" height='350' width='150'/>
         </div>
        ):(
        <div style={{ display: 'flex', textAlign:'left',height: '100%', backgroundColor:"white", width:'auto' , zIndex:100}}>
               {secondLevelButtons && showButtons ? (
                <div>                 
                  { !isInEvidenza() && 
                    <Tooltip title="Aggiungi Pratica" placement="left">
                    <div style={{ position: 'fixed', right: 120, bottom: 240, zIndex:100 }}>
                    <Fab aria-label="add2"                 
                        //variant="contained" 
                        size='medium'
                        disabled={isBloccataMissione()}
                        onClick={(event) => {onFabClick("pratica",event) }}                        
                        style={{
                            margin: 0,
                            background: "#A2EE7D",
                            top: 'auto',                     
                            //right: 20,
                            right: 75,
                            bottom: 220,                      
                            left: 'auto',
                            position: 'fixed'}} >                    
                            <AddBoxIcon />                                                                                                        
                    </Fab>    
                    </div>  
                    </Tooltip>   
                    }               
                  
                    <Tooltip title="Aggiungi Documento" placement="left">
                    <div style={{ position: 'fixed', right: 120, bottom: 130,zIndex:100 }}>
                    <Fab aria-label="add2"                 
                        //variant="contained" 
                        size='medium'
                        onClick={(event) => {onFabClick("documento",event) }}
                        disabled={isBloccataMissione()}
                        style={{
                            margin: 0,
                            background: "#A2EE7D",
                            top: 'auto',                     
                            //right: 20,
                            right: 75,
                            bottom: 110,                      
                            left: 'auto',
                            position: 'fixed'}} >                    
                            <NoteAddIcon />                        
                    </Fab>       
                    </div>
                </Tooltip>
                { !isInEvidenza() &&
                <Tooltip title="Aggiungi Ambito" placement="left">
                <div style={{ position: 'fixed', right: 120, bottom: 185, zIndex:100 }}>
                    <Fab aria-label="add3"                                   
                        size='medium'
                        onClick={(event) => {onFabClick("ambito",event) }}      
                        disabled={isBloccataMissione()}            
                        style={{
                            margin: 0,
                            background: "#A2EE7D",
                            top: 'auto',                     
                            //right: 20,
                            right: 75,
                            bottom: 165,
                            //color: '0xFF0000',
                            left: 'auto',
                            position: 'fixed',}}>                    
                            <LibraryAddIcon />
                    </Fab>
                  </div>
                </Tooltip>   
                }
                {!isFuoriSacco() && !isInEvidenza()?(
                <Tooltip title="Aggiungi/Rimuovi Minigrant"  disableHoverListener={isBloccataMissione()} placement="left">
                <div style={{ position: 'fixed', right: 120, bottom: 295,zIndex:100 }}>
                    <Fab aria-label="add3"                                   
                        size='medium'
                        disabled={isBloccataMissione()}
                        onClick={(event) => {onFabClick("minigrant",event) }}                  
                        style={{
                            margin: 0,
                            background: "#A2EE7D",
                            top: 'auto',                     
                            //right: 20,
                            right: 75,
                            bottom: 275,
                            //color: '0xFF0000',
                            left: 'auto',
                            position: 'fixed',}}>                    
                            <AccountBalanceIcon />
                    </Fab>
                    </div>
                </Tooltip>      
                ):(<></>)}
                  {!isFuoriSacco() && !isInEvidenza()?(
                <Tooltip title="Aggiungi/Rimuovi Presentazione di Missione"  disableHoverListener={isBloccataMissione()} placement="left">
                <div style={{ position: 'fixed', right: 120, bottom: 350,zIndex:100 }}>
                    <Fab aria-label="add3"                                   
                        size='medium'
                        disabled={isBloccataMissione()}
                        onClick={(event) => {onFabClick("presentazioneMissione",event) }}                  
                        style={{
                            margin: 0,
                            background: "#A2EE7D",
                            top: 'auto',                     
                            //right: 20,
                            right: 75,
                            bottom: 330,
                            //color: '0xFF0000',
                            left: 'auto',
                            position: 'fixed',}}>                    
                            <LocalParkingIcon />
                    </Fab>
                    </div>
                </Tooltip>      
                ):(<></>)}
                
                  
            </div> ):(  <div> </div>)}
      
            {forthLevelButtons && showButtons && localStorage.getItem("ruolo")=="5"? (
               <div >                                                 
                              <Tooltip title="Blocca/Sblocca Cultura" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 130,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("cultura",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#E42368",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          bottom: 110,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>       
                                          {isBloccatoObiettivo("cultura") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}
                                  </Fab>
                                  </div>
                              </Tooltip>  
                              <Tooltip title="Blocca/Sblocca Persone" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 185,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("persone",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#F7B900",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          bottom: 165,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>    
                                          {isBloccatoObiettivo("persone") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}                
                                          
                                  </Fab>
                                  </div>
                              </Tooltip>   
                              <Tooltip title="Blocca/Sblocca Pianeta" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 240,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("pianeta",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#028FD2",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          bottom: 220,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>                    
                                          {isBloccatoObiettivo("pianeta") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}
                                  </Fab>
                                  </div>
                              </Tooltip>  
                            {/**  <Tooltip title="Blocca/Sblocca Direzione Pianificazione Studi" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 295,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("pianificazione_studi",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#FFD480",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          bottom: 275,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>                    
                                          {isBloccatoObiettivo("direzione_pianificazione") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}                            
                                  </Fab>   
                                  </div>                 
                              </Tooltip>
                               */}
                              <Tooltip title="Blocca/Sblocca Direzione Learning" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 295,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("innovazione_impatto",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#FFD480",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          //bottom: 330,
                                          bottom: 275,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>                    
                                          {isBloccatoObiettivo("direzione_innovazione_impatto") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}                            
                                  </Fab>
                                  </div>
                              </Tooltip > 
                              <Tooltip title="Blocca/Sblocca Convenzione Progetti Speciali E Indice Situazione Fondi" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 350,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("convenzioni_progetti_speciali",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#DDDDDD",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          //bottom: 385,
                                          bottom: 330,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>                                                
                                          {isBloccatoObiettivo("convenzioni_progetti_speciali") ?(             
                                          <VpnKeyOffIcon />):(                              
                                            <VpnKeyIcon />
                                          )}   
                                  </Fab>
                                  </div>
                              </Tooltip>  
                              <Tooltip title="Blocca Tutto" placement="left">
                              <div style={{ position: 'fixed', right: 185, bottom: 405,zIndex:100 }}>
                                  <Fab aria-label="add3"                                   
                                      size='medium'
                                      onClick={(event) => {onFabClick("tutto",event) }}                  
                                      style={{
                                          margin: 0,
                                          background: "#30720f",
                                          top: 'auto',                     
                                          //right: 85,
                                          right: 140,
                                          //bottom: 440,
                                          bottom: 385,
                                          //color: '0xFF0000',
                                          left: 'auto',
                                          position: 'fixed',}}>                    
                                          <VpnLockIcon />
                                  </Fab>
                                  </div>
                              </Tooltip>  
                                
                          </div> ):(  <div> </div>)}

            {forthLevelButtons && showButtons && localStorage.getItem("ruolo")=="4"? (
                <div>                     
                {localStorage.getItem("indice").split(",").map((item, index) => {                  
                  let element;
                  if(item ==1){                    
                    element= (
                      <Tooltip title="Blocca Cultura" placement="left" key={index}>
                      <div style={{ position: 'fixed', right: 190, bottom: 130+(index*55),zIndex:100 }}>
                      <Fab aria-label="add3"                                   
                          size='medium'
                          disabled={isBloccatoObiettivo("cultura")}
                          onClick={(event) => {onFabClick("cultura",event) }}                  
                          style={{
                              margin: 0,
                              background: "#E42368",
                              top: 'auto',                     
                              //right: 85,
                              right: 140,
                              bottom: 110+(index*55),                              
                              left: 'auto',
                              position: 'fixed',}}>                                                                  
                              <VpnKeyIcon />
                      </Fab>
                      </div>
                  </Tooltip> 
                    );
                  }
                  else if (item==2){
                    
                      element= (
                        <Tooltip title="Blocca Persone" placement="left" key={index}>
                          <div style={{ position: 'fixed', right: 190, bottom: 130+(index*55),zIndex:100 }}>
                        <Fab aria-label="add3"                                   
                            size='medium'
                            disabled={isBloccatoObiettivo("persone")}
                            onClick={(event) => {onFabClick("persone",event) }}                  
                            style={{
                                margin: 0,
                                background: "#F7B900",
                                top: 'auto',                     
                                //right: 85,
                                right: 140,
                                bottom: 110+(index*55),
                                //color: '0xFF0000',
                                left: 'auto',
                                position: 'fixed',}}>                                    
                                <VpnKeyIcon />                                
                        </Fab>
                        </div>
                    </Tooltip> 
                      );
                    }
                    else if (item==3){
                      element= (
                      <Tooltip title="Blocca Pianeta" placement="left" key={index}>
                        <div style={{ position: 'fixed', right: 190, bottom: 130+(index*55),zIndex:100 }}>
                      <Fab aria-label="add3"                                   
                          size='medium'
                          disabled={isBloccatoObiettivo("pianeta")}
                          onClick={(event) => {onFabClick("pianeta",event) }}                  
                          style={{
                              margin: 0,
                              background: "#028FD2",
                              top: 'auto',                     
                              //right: 85,
                              right: 140,
                              bottom: 110+(index*55),
                              //color: '0xFF0000',
                              left: 'auto',
                              position: 'fixed',}}>                                  
                              <VpnKeyIcon />
                      </Fab>
                      </div>
                    </Tooltip>  
                     );
                    }
                    else if (item==4){
                      element= (
                      <Tooltip title="Blocca Direzione Pianificazione Studi" placement="left" key={index}>
                        <div style={{ position: 'fixed', right: 190, bottom: 130+(index*55),zIndex:100 }}>
                      <Fab aria-label="add3"                                   
                          size='medium'
                          disabled={isBloccatoObiettivo("direzione_pianificazione")}
                          onClick={(event) => {onFabClick("pianificazione_studi",event) }}                  
                          style={{
                              margin: 0,
                              background: "#FFD480",
                              top: 'auto',                     
                              //right: 85,
                              right: 140,
                              bottom: 110+(index*55),
                              //color: '0xFF0000',
                              left: 'auto',
                              position: 'fixed',}}>                                                  
                              <VpnKeyIcon />                        
                      </Fab>               
                      </div>     
                    </Tooltip>
                   );
                    }
                    else if (item==5){
                      element= (
                        <Tooltip title="Blocca Direzione Innovazione Impatto" placement="left" key={index}>
                          <div style={{ position: 'fixed', right: 190, bottom: 130+(index*55),zIndex:100 }}>
                        <Fab aria-label="add3"                                   
                            size='medium'
                            disabled={isBloccatoObiettivo("direzione_innovazione_impatto")}
                            onClick={(event) => {onFabClick("innovazione_impatto",event) }}                  
                            style={{
                                margin: 0,
                                background: "#FFD480",
                                top: 'auto',                     
                                //right: 85,
                                right: 140,
                                bottom: 110+(index*55),
                                //color: '0xFF0000',
                                left: 'auto',
                                position: 'fixed',}}>                                                    
                                <VpnKeyIcon />                                
                        </Fab>
                        </div>
                    </Tooltip >
                    );
                    }                    
                    return (element);
                      })}                                
            </div> ):(  <> </>)}
            {isFuoriSacco() && showButtons &&(localStorage.getItem("ruolo")=="5") ?(
            <Tooltip title="Modifica" placement="bottom">
            <div style={{ position: 'fixed', right: 110, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {setSecondLevelButtons(!secondLevelButtons);setForthLevelButtons(false) }}
                style={{                    
                    background: "#30720f",                    
                    //right: 20,
                    right: 75,
                    bottom: 45,
                    color: '0xFFFFFF',
                    
                    position: 'fixed',}}>                  
                    <MoreHorizIcon />                    
            </Fab>  
            </div>
            </Tooltip>
          ):
          isFuoriSacco() && showButtons &&(localStorage.getItem("ruolo")=="4" ) ?(
            <Tooltip title="Modifica" placement="bottom">
            <div style={{ position: 'fixed', right: 130, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                disabled={true}
                style={{                    
                    background: "#30720f",                    
                    //right: 20,
                    right: 75,
                    bottom: 45,
                    color: '0xFFFFFF',
                    
                    position: 'fixed',}}>                  
                    <MoreHorizIcon />                    
            </Fab>  
            </div>
            </Tooltip>
          ):
          !isFuoriSacco() &&getFase()==3 && showButtons && (localStorage.getItem("ruolo")=="4" ||localStorage.getItem("ruolo")=="5")? (
            <Tooltip title="Modifica" placement="bottom">
            <div style={{ position: 'fixed', right: 110, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                disabled
                style={{                    
                    background: "#30720f",                    
                    //right: 20,
                    right: 75,
                    bottom: 45,
                    color: '0xFFFFFF',                    
                    position: 'fixed',}}>                  
                    <MoreHorizIcon />                    
            </Fab>  
            </div>
            </Tooltip>
        ):
         ( showButtons &&(localStorage.getItem("ruolo")=="4" ||localStorage.getItem("ruolo")=="5"))?(
          <Tooltip title="Modifica" placement="bottom">
          <div style={{ position: 'fixed', right: 110, bottom:8,zIndex:100 }}>
          <Fab aria-label="add"                 
              //variant="contained" 
              size="large" 
              onClick={(event) => {setSecondLevelButtons(!secondLevelButtons);setForthLevelButtons(false) }}
              style={{                  
                  background: "#30720f",                  
                  //right: 20,
                  right: 75,
                  bottom: 45,
                  color: '0xFFFFFF',
                  
                  position: 'fixed',}}>                  
                  <MoreHorizIcon />                    
          </Fab>  
          </div>
          </Tooltip>
         ):
          (
            <></> 
          )}

          {localStorage.getItem("ruolo")=="5"&& showButtons? (
          <Tooltip title="Porta alla Fase successiva" placement="bottom">
            <div style={{ position: 'fixed', right: 255, bottom: 8, zIndex:100  }}>
            <Fab aria-label="add"                                
                size="large" 
                disabled={!isPossibleNextFase(data.Fase)}
                onClick={(event) => {onFabClick("cambiaFase",event) }}
                style={{                    
                    background: "#30720f",                    
                    //right: 150,
                    right: 205,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    {data.Fase=="0"?(
                        <Filter2Icon />
                        ):
                        data.Fase=="1"?(
                          <Filter3Icon />
                                ):
                                data.Fase=="2"?(
                                  <FilterIcon />
                                        ):
                                <FilterIcon />
                                }            
            </Fab>  
            </div>
          </Tooltip>):(<></>)}

          {localStorage.getItem("ruolo")=="5" && showButtons? (
          <Tooltip title="Genera Excel" placement="bottom">
            <div style={{ position: 'fixed', right: 315, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                  
                size="large" 
                onClick={(event) => {onFabClick("excel",event) }}
                style={{                    
                    background: "#30720f",                    
                    //right: 215,
                    right: 270,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <PrintIcon />                    
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

          {localStorage.getItem("ruolo")=="5" && getFase()==3 && showButtons? (
          <Tooltip title="Genera Excel per Consiglieri" placement="bottom">
            <div style={{ position: 'fixed', right: 385, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("excel_consiglieri",event) }}
                style={{
                    background: "#BF360C",                    
                    //right: 280,
                    right: 335,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <PrintIcon />                    
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

          {localStorage.getItem("ruolo")=="5"  && getFase()==3 && showButtons? (
          <Tooltip title="Genera Excel con dettagli" placement="bottom">
            <div style={{ position: 'fixed', right: 450, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("excel_with_details",event) }}
                style={{
                    background: "#30720f",                    
                    //right: 345,
                    right: 400,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <Box sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                      }}>   
                      <PrintIcon/>   
                      <AbcIcon sx={{ fontSize: 17,
                        position: "absolute",
                        top: 0,
                        right: 0, }}/>
      
                    
                    </Box>                  
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

          {localStorage.getItem("ruolo")=="5"  && getFase()!=3 && showButtons? (
          <Tooltip title="Genera Excel con dettagli" placement="bottom">
            <div style={{ position: 'fixed', right: 385, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("excel_with_details",event) }}
                style={{
                    background: "#30720f",                    
                    //right: 280,
                    right: 335,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <Box sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                      }}>   
                      <PrintIcon/>   
                      <AbcIcon sx={{ fontSize: 17,
                        position: "absolute",
                        top: 0,
                        right: 0, }}/>
      
                    
                    </Box>                  
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}
          {(localStorage.getItem("ruolo")=="5"|| (localStorage.getItem("ruolo")=="4" && localStorage.getItem("name")=="Fulvio")||(localStorage.getItem("ruolo")=="4" && localStorage.getItem("name")=="Hilel"))  && getFase()>=1 && showButtons? (
          <Tooltip title="Genera Archivio JSON" placement="bottom">
            <div style={{ position: 'fixed', right: 385, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("zip",event) }}
                style={{
                    background: "#30720f",                    
                    //right: 280,
                    right: 465,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <Box sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                      }}>   
                      <ArchiveIcon/>                                             
                    </Box>                  
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

          {localStorage.getItem("ruolo")=="5"  && getFase()>=1 && showButtons? (
          <Tooltip title="Genera Fascicolo Comitato" placement="bottom">
            <div style={{ position: 'fixed', right: 530, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("fascicolo",event) }}
                style={{
                    background: "#30720f",                    
                    //right: 280,
                    right: 530,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <Box sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                      }}>   
                      <ConstructionIcon/>                                             
                    </Box>                  
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

      {/*
          {localStorage.getItem("ruolo")=="12" && showButtons? (
          <Tooltip title="Genera Excel" placement="bottom">
            <div style={{ position: 'fixed', right: 255, bottom:-5,zIndex:100 }}>
            <Fab aria-label="add"                 
                //variant="contained" 
                size="large" 
                onClick={(event) => {onFabClick("excel",event) }}
                style={{                    
                    background: "#30720f",                    
                    //right: 20,
                    right: 75,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <PrintIcon />                    
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}
                */}

          {(localStorage.getItem("ruolo")=="12"||localStorage.getItem("ruolo")=="10") && showButtons? (
          <Tooltip title="Genera Excel con dettagli" placement="bottom">
            <div style={{ position: 'fixed', right: 105, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("excel_with_details",event) }}
                style={{
                    background: "#30720f",                    
                    right: 75,
                    //right: 140,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <Box sx={{
                        position: "relative",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 40,
                        height: 40,
                      }}>   
                      <PrintIcon/>   
                      <AbcIcon sx={{ fontSize: 17,
                        position: "absolute",
                        top: 0,
                        right: 0, }}/>
      
                    
                    </Box>                  
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

          {(localStorage.getItem("ruolo")=="12"||localStorage.getItem("ruolo")=="10") && getFase()==3 && showButtons? (
          <Tooltip title="Genera Excel per Consiglieri" placement="bottom">
            <div style={{ position: 'fixed', right: 155, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                onClick={(event) => {onFabClick("excel_consiglieri",event) }}
                style={{
                    background: "#BF360C",                    
                    right: 140,
                    //right: 205,
                    bottom: 45,
                    color: '0xFFFFFF',
                    zIndex: 10000000,                    
                    position: 'fixed',}}>                  
                    <PrintIcon />                    
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}

      {/** 
          {localStorage.getItem("ruolo")=="4" && showButtons? (
            
          <Tooltip title="Genera Excel" placement="bottom">
            <div style={{ position: 'fixed', right: 250, bottom:-5,zIndex:100 }}>
            <Fab aria-label="add"                 
                //variant="contained" 
                size="large" 
                onClick={(event) => {onFabClick("excel",event) }}
                style={{                    
                    background: "#30720f",                                                            
                    //right: 205,
                    right: 205,
                    bottom: 45,
                    zIndex: 10000000,
                    color: '0xFFFFFF',                    
                    position: 'fixed',}}>                  
                    <PrintIcon />                    
            </Fab>  
            </div>
          </Tooltip> ):(<></>)}
*/}
          {localStorage.getItem("ruolo")=="4" && showButtons?(
              <Tooltip title="Genera Excel con dettagli" placement="bottom">
              <div style={{ position: 'fixed', right: 250, bottom:8,zIndex:100 }}>
              <Fab aria-label="add"                                 
                  size="large" 
                  onClick={(event) => {onFabClick("excel_with_details",event) }}
                  style={{
                      background: "#30720f",                    
                      right: 205,
                      //right: 270,
                      bottom: 45,
                      color: '0xFFFFFF',
                      zIndex: 10000000,                    
                      position: 'fixed',}}>                  
                      <Box sx={{
                          position: "relative",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 40,
                          height: 40,
                        }}>   
                        <PrintIcon/>   
                        <AbcIcon sx={{ fontSize: 17,
                          position: "absolute",
                          top: 0,
                          right: 0, }}/>
        
                      
                      </Box>                  
              </Fab>  
              </div>
            </Tooltip> ):(<></>)
          }
          
          {showButtons &&(localStorage.getItem("ruolo")=="4" ||localStorage.getItem("ruolo")=="5")? (
          <Tooltip title="Blocca" placement="bottom">
          <div style={{ position: 'fixed', right: 165, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                 
                //variant="contained" 
                size="large" 
                disabled={!isPossibleNextFase(data.Fase)}
                onClick={(event) => {setForthLevelButtons(!forthLevelButtons);setSecondLevelButtons(false) }}
                style={{                    
                    background: "#30720f",                    
                    zIndex: 10000000,
                    //right: 85,
                    right: 140,
                    bottom: 45,
                    color: '0xFFFFFF',                    
                    position: 'fixed',}}>                  
                        <LockPersonIcon />                      
            </Fab>  
            </div>
          </Tooltip>
         ):(<></>)}

        
      <Tooltip title="Riduci/Espandi" placement="bottom">
          <div style={{ position: 'fixed', right: 55, bottom:8,zIndex:100 }}>
            <Fab aria-label="add"                                 
                size="large" 
                disabled={false}
                onClick={(event) => {setShowButtons(!showButtons);setSecondLevelButtons(false) }}
                //onClick={handleClickOpenMenu}
                style={{                    
                    background: "#30720f",                    
                    zIndex: 10000000,
                    right: 10,
                    bottom: 45,
                    color: '0xFFFFFF',                    
                    position: 'fixed',}}>                  
                    {showButtons ?(
                    <ArrowForwardIosIcon />                    
                  ):(
                    <ArrowBackIosNewIcon />                   
                  )}
            </Fab>  
            </div>
      </Tooltip>

      <MenuMUI
        /*anchorEl={anchorEl}
        id="account-menu"
        open={openMenu}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        */
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        TransitionComponent={Grow}
        transitionDuration={200}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        slotProps={{
          paper: {
            elevation: 4,
            sx: {
              overflow: 'visible',
              transformOrigin: 'right bottom',
              minWidth: 220,
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
      > 
        <MenuItemMUI onClick={handleCloseMenu}>
          <PrintIcon style={{paddingRight:"20px"}}/> Profile
        </MenuItemMUI>
      </MenuMUI>
        
    <Sidebar width='400px' style={{ height: '100%' }}
     rootStyles={{
      [`.ps-submenu-expand-icon span`]: {
        fontSize: "26px",
      },
      [`.ps-submenu-expand-icon`]: {
        transform: "scale(1.5)",
      },
    }}>
      <Menu
        menuItemStyles={{
          button: ({ level, active, disabled }) => {
            // only apply styles on first level elements of the tree
            
            if (level === 0){
              return {
                //color: disabled ? '#f5d9ff' : '#d359ff',
                color: disabled ? '#f5d9ff' : '#000000',
                backgroundColor: active ? '#eecef9' : undefined,
                fontWeight:'bold',
                //fontSize:"18px"
              };
            }
          },
        }}
      >
{/** IN EVIDENZA - 17012026 - START*/}
{localStorage.getItem("ruolo")==5 &&
              <div style={{ width:"100%",   display: "flex"}} >            
              {menuItemSelected==999 ? (            
                <MenuItem icon={<img style={{width:"30px"}} src={sacco}   /> }onClick={(event)=>handleMenuItemClick(event,"in_evidenza","INDICE E SITUAZIONE FONDI",999)} rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}}>
                    INDICE E SITUAZIONE FONDI
                </MenuItem>
                ):(
                  <MenuItem icon={<img style={{width:"30px"}} src={sacco} /> } onClick={(event)=>handleMenuItemClick(event,"in_evidenza","INDICE E SITUAZIONE FONDI",999)} rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} >
                    INDICE E SITUAZIONE FONDI</MenuItem>
                )}
                {menuLocked[22]==3 ?(
                <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                ):
                menuLocked[22]==2 ?(
                  <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                ):
                menuLocked[22]==1 &&getFase()!=3 ?(
                  <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                ):
                menuLocked[22]==1 &&getFase()==3 ?(
                  <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                ):
                menuLocked[22]==4 ?(
                  <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                )                  
                :(<></>)}       
              </div> 
      }
{/** IN EVIDENZA - 17012026 - FINE*/}

        <SubMenu defaultOpen={canBeSeen(1)} label="CULTURA" icon={<img style={{width:"30px"}} src={cultura}  /> }>
          <div style={{ width:"100%",   display: "flex"}} >  
          {menuItemSelected==74 ? (          
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"cultura","Cultura",74)}> Cultura              
          </MenuItem>  
          ):(          
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"cultura","Cultura",74)}> Cultura </MenuItem>          
          )}
          {menuLocked[0]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[0]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[0]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[0]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[0]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )          
          :(<></>)}
          </div>  
          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==70 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"attrattivita","Attrattività",70)}> Attrattività</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"attrattivita","Attrattività",70)}> Attrattività</MenuItem>  
          )}
           {menuLocked[1]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[1]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[1]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[1]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[1]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  
          
          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==71 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"competenze","Competenze",71)}> Competenze</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"competenze","Competenze",71)}> Competenze</MenuItem>  
          )}
          {menuLocked[2]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[2]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[2]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[2]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[2]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==72 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"custodia","Custodia",72)}> Custodia</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"custodia","Custodia",72)}> Custodia</MenuItem>  
          )}
         {menuLocked[3]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[3]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[3]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[3]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[3]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==73 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"partecipazione","Partecipazione",73)}> Partecipazione</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"partecipazione","Partecipazione",73)}> Partecipazione</MenuItem>  
          )}          
          {menuLocked[4]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[4]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[4]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[4]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[4]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

        </SubMenu>
        <SubMenu defaultOpen={canBeSeen(2)} label="PERSONE" icon={<img style={{width:"30px"}} src={persone}  /> }>          
          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==67 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"persone","Persone",67)}> Persone</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"persone","Persone",67)}> Persone</MenuItem>  
          )}  
           {menuLocked[5]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[5]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[5]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[5]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[5]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  
          
          <div style={{ width:"100%",   display: "flex"}} >
           {menuItemSelected==62 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"abitare","Abitare",62)}> Abitare</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"abitare","Abitare",62)}> Abitare</MenuItem>  
          )}  
          {menuLocked[6]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[6]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[6]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[6]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[6]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==63 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"lavoro","Lavoro",63)}> Lavoro</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"lavoro","Lavoro",63)}> Lavoro</MenuItem>  
          )}  
         {menuLocked[7]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[7]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[7]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[7]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[7]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
           {menuItemSelected==64 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"educazione","Educazione",64)}> Educazione</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"educazione","Educazione",64)}> Educazione</MenuItem>  
          )}                   
          {menuLocked[8]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[8]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[8]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[8]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[8]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==65 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"comunita","Comunità",65)}> Comunità</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"comunita","Comunità",65)}> Comunità</MenuItem>  
          )}  

          {menuLocked[9]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[9]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[9]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[9]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[9]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}
          </div>  

          <div style={{ width:"100%",   display: "flex"}} >
          {menuItemSelected==66 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"inclusione","Inclusione",66)}> Inclusione</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"inclusione","Inclusione",66)}> Inclusione</MenuItem>  
          )}
          {menuLocked[10]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[10]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[10]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[10]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[10]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          </div>              
        </SubMenu>
        <SubMenu defaultOpen={canBeSeen(3)} label="PIANETA" icon={<img style={{width:"30px"}} src={pianeta}  /> }>
        <div style={{ width:"100%",   display: "flex"}} >
        {menuItemSelected==85 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"pianeta","Pianeta",85)}> Pianeta</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"pianeta","Pianeta",85)}> Pianeta</MenuItem>  
        )}  
          {menuLocked[11]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[11]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[11]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[11]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[11]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}          </div> 

        <div style={{ width:"100%",   display: "flex"}} >
        {menuItemSelected==80 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"ricerca","Ricerca",80)}> Ricerca</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"ricerca","Ricerca",80)}> Ricerca</MenuItem>  
        )}  
          {menuLocked[12]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[12]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[12]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[12]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[12]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          </div> 

        <div style={{ width:"100%",   display: "flex"}} >
        {menuItemSelected==81 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"innovazione","Innovazione",81)}> Innovazione</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"innovazione","Innovazione",81)}> Innovazione</MenuItem>  
        )}  
          {menuLocked[13]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[13]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[13]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[13]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[13]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          </div> 
        <div style={{ width:"100%",   display: "flex"}} >
        {menuItemSelected==82 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"benessere","Benessere",82)}> Benessere</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"benessere","Benessere",82)}> Benessere</MenuItem>  
        )}  
          {menuLocked[14]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[14]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[14]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[14]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[14]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          </div> 
        {/*{idSeduta.replaceAll("-","")< 20250500 ?(  */}
            <div style={{ width:"100%",   display: "flex"}} >
            {menuItemSelected==83 ? (
              <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"internazionalizzazione","Internazionalizzazione",83)}> Internazionalizzazione</MenuItem>  
              ):(
              <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"internazionalizzazione","Internazionalizzazione",83)}> Internazionalizzazione</MenuItem>  
            )}  
            {menuLocked[15]==3 ?(
              <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
              ):
              menuLocked[15]==2 ?(
                <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
              ):
              menuLocked[15]==1 &&getFase()!=3 ?(
                <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
              ):
              menuLocked[15]==1 &&getFase()==3 ?(
                <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
              ):
              menuLocked[15]==4 ?(
                <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
              )        
              :(<></>)}
              </div> {/* ):( */}
            {idSeduta.replaceAll("-","")> 20250600 ?(  
               <div style={{ width:"100%",   display: "flex"}} >
               {menuItemSelected==88 ? (
                 <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"sviluppoTerritorio","Sviluppo Territorio",88)}> Sviluppo Territorio</MenuItem>  
                 ):(
                 <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"sviluppoTerritorio","Sviluppo Territorio",88)}> Sviluppo Territorio</MenuItem>  
               )}  
               {menuLocked[21]==3 ?(
                 <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                 ):
                 menuLocked[21]==2 ?(
                   <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                 ):
                 menuLocked[21]==1 &&getFase()!=3 ?(
                   <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                 ):
                 menuLocked[21]==1 &&getFase()==3 ?(
                   <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                 ):
                 menuLocked[21]==4 ?(
                   <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
                 )        
                 :(<></>)}
                 </div>  
              )   :(<></>)}
             {/* )} */}
        <div style={{ width:"100%",   display: "flex"}} >
        {menuItemSelected==84 ? (
          <MenuItem  rootStyles={{backgroundColor:'#F3F3F3', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"ambiente","Ambiente",84)}> Ambiente</MenuItem>  
          ):(
          <MenuItem   rootStyles={{backgroundColor:'#FFFFFF', width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"ambiente","Ambiente",84)}> Ambiente</MenuItem>  
        )}            
         {menuLocked[16]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[16]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[16]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[16]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[16]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          </div> 
        </SubMenu>              
        {/**         <div style={{ width:"100%",   display: "flex"}} >         
        {menuItemSelected==90 ? (
          <MenuItem icon={<img style={{width:"30px"}} src={direzioni}  /> } rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"direzione_pianificazione","DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE",90)}> DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE</MenuItem>  
          ):(
          <MenuItem icon={<img style={{width:"30px"}} src={direzioni}  /> }  rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"direzione_pianificazione","DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE",90)}> DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE</MenuItem>  
        )}            
           {menuLocked[17]==3 ?(
          <WarningIcon fontSize='small' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[17]==2 ?(
            <LockIcon fontSize='small' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[17]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='small' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[17]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='small' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[17]==4 ?(
            <LockClockIcon fontSize='small' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
        
        </div>  
        */}

        <div style={{ width:"100%",   display: "flex"}} > 
          {menuItemSelected==95 ? (
          <MenuItem icon={<img style={{width:"30px"}} src={direzioni}  /> } rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"direzione_innovazione_impatto","DIREZIONE INNOVAZIONE DI IMPATTO",95)}> 
            {idSeduta.replaceAll("-","")<20250401 ? "DIREZIONE INNOVAZIONE DI IMPATTO" : "DIREZIONE LEARNING"}
          </MenuItem>  
          ):(
          <MenuItem icon={<img style={{width:"30px"}} src={direzioni}  /> }  rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} onClick={(event)=>handleMenuItemClick(event,"direzione_innovazione_impatto","DIREZIONE INNOVAZIONE DI IMPATTO",95)}>
            {idSeduta.replaceAll("-","")<20250401 ? "DIREZIONE INNOVAZIONE DI IMPATTO" : "DIREZIONE LEARNING"}
          </MenuItem>  
        )}            
           {menuLocked[18]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[18]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[18]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[18]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[18]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )        
          :(<></>)}
          
        </div>  
        

        <div style={{ width:"100%",   display: "flex"}} >            
        {menuItemSelected==100 ? (            
          <MenuItem icon={<img style={{width:"30px"}} src={altro}   /> }onClick={(event)=>handleMenuItemClick(event,"convenzioni_progetti_speciali","CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI",100)} rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}}>
              {idSeduta.replaceAll("-","")<20251101 ? "CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI" : idSeduta.replaceAll("-","")<20260513 ?
              "PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO":"PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO" }
          </MenuItem>
          ):(
            <MenuItem icon={<img style={{width:"30px"}} src={altro} /> } onClick={(event)=>handleMenuItemClick(event,"convenzioni_progetti_speciali","CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI",100)} rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} >
                  {idSeduta.replaceAll("-","")<20251101 ? "CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI" : idSeduta.replaceAll("-","")<20260513 ?
              "PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO":"PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO" }
              </MenuItem>
          )}
           {menuLocked[19]==3 ?(
          <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[19]==2 ?(
            <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[19]==1 &&getFase()!=3 ?(
            <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[19]==1 &&getFase()==3 ?(
            <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          ):
          menuLocked[19]==4 ?(
            <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
          )                  
          :(<></>)}       
        </div> 


        {/**29/12/2024 */} 
        {data.Fase==3 ?(
          <div style={{ width:"100%",   display: "flex"}} >            
          {menuItemSelected==110 ? (            
              <MenuItem icon={<img style={{width:"30px"}} src={sacco} /> } onClick={(event)=>handleMenuItemClick(event,"fuori_sacco","FUORI SACCO",110)} rootStyles={{backgroundColor:'#F3F3F3',width:'90%'}}>
                FUORI SACCO</MenuItem>
            ):(
              <MenuItem icon={<img style={{width:"30px"}} src={sacco} /> } onClick={(event)=>handleMenuItemClick(event,"fuori_sacco","FUORI SACCO",110)} rootStyles={{backgroundColor:'#FFFFFF',width:'90%'}} >
                FUORI SACCO</MenuItem>
          )}
            {menuLocked[20]==3 ?(
            <WarningIcon fontSize='large' style={{ background: "#ffffff", color: "BF2B0C" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
            ):
            menuLocked[20]==2 ?(
              <LockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
            ):
            menuLocked[20]==1 &&getFase()!=3 ?(
              <EngineeringIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
            ):
            menuLocked[20]==1 &&getFase()==3 ?(
              <EuroSymbolIcon fontSize='large' sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
            ):
            menuLocked[20]==4 ?(
              <LockClockIcon fontSize='large' style={{ background: "#ffffff", color: "30720f" }} sx={{paddingTop:'13px', paddingRight:'10px', paddingLeft:'5px',textAlign:'center', alignItems: 'center'}} />   
            )                  
          :(<></>)}       
          </div> 
        ):(<></>)}
        {/**29/12/2024 */} 
      </Menu>
    </Sidebar>
    {/*<div style={{ display: 'flex', width:"100%",textAlign:'left',height: '100%', backgroundColor:"red" }}> */}
    <div style={{ display: 'flex', textAlign:'left',height: '100%', width:'100%', backgroundColor:"white" }}>
    {loading ? (        
          <div key={uuidv4()} style={{ width:"25%",   display: "flex", 
          marginLeft: "auto", marginRight: "auto" }}> 
           <ThreeDots color="#30720f" height='350' width='150'/>
          </div>    
    ):(
        <div  style={{ paddingRight:"50px",paddingLeft:"50px", marginTop:"5px", textAlign:'left',width:'100%', height: '100%', zIndex:0}}>
                
                <div style={{ display:'flex', paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>
                { menuLocked[fromSectorToPosition(sector)]=="1" &&getFase()!=3?(                 
                  <EngineeringIcon fontSize='large' sx={{ position:"absolute", top:"95px",right:"65px"}} />                 
                ):
                menuLocked[fromSectorToPosition(sector)]=="1" &&getFase()==3?(                 
                  <EuroSymbolIcon fontSize='large' sx={{ position:"absolute", top:"95px",right:"65px"}} />                 
                ):
                menuLocked[fromSectorToPosition(sector)]=="2" ?(
                  <LockIcon fontSize='large' sx={{ position:"absolute", top:"95px",right:"65px"}} />
                ):
                menuLocked[fromSectorToPosition(sector)]=="3" ?(
                  <WarningIcon fontSize='large' sx={{ position:"absolute", top:"95px",right:"65px"}} />
                ):
                menuLocked[fromSectorToPosition(sector)]=="4" ?(
                  <LockClockIcon fontSize='large' sx={{ position:"absolute", top:"95px",right:"65px"}} />
                ):(
                  //console.log("DD",getFase()),
                  <></>
                )
                }  
                {idSeduta.replaceAll("-","")>20260513 && printable =='CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI'?(  
                  <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"65%",  fontWeight: 'bold'}}> {conversionFase(data.Fase)} Indice della Seduta del {data.Seduta} - PROGETTI DI SVILUPPO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</p>                                
                ): idSeduta.replaceAll("-","")>20251101 && printable =='CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI'?(  
                  <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"65%",  fontWeight: 'bold'}}> {conversionFase(data.Fase)} Indice della Seduta del {data.Seduta} - PROGETTI A IMPATTO, TRASVERSALITA', PROTOCOLLI QUADRO E ALTRO</p>                                
                ):
                idSeduta.replaceAll("-","")>20250401 && printable =='DIREZIONE INNOVAZIONE DI IMPATTO'?(  
                  <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"65%",  fontWeight: 'bold'}}> {conversionFase(data.Fase)} Indice della Seduta del {data.Seduta} - DIREZIONE LEARNING</p>                
                ):
                (
                  <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"65%",  fontWeight: 'bold'}}> {conversionFase(data.Fase)} Indice della Seduta del {data.Seduta} - {printable}</p>                  
                )
                } 
                {mingrantAvailable ? (<p className= "textBlackSedute" style={{textAlign:'right', paddingRight:'100px', paddingLeft:"30px",width:"45%", fontWeight: 'bold'}}> Presenti minigrant</p>):(<></>)}                
              
                </div>

                { printable=='DIREZIONE PIANIFICAZIONE, STUDI E VALUTAZIONE' || printable=='DIREZIONE INNOVAZIONE DI IMPATTO' ?(
                  <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>                  
                  <p className= "textBlackSedute" style={{paddingLeft:"30px",  fontWeight: 'bold'}}> Totale direzione: € {Euro.format(calculateTotalCost(cards))}</p>                  
                </div>): 
                printable == 'CONVENZIONI, PROGETTI SPECIALI, ULTERIORI PRATICHE E DOCUMENTI' ?(
                  <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>    
                  {idSeduta.replaceAll("-","")<20251101 ?(              
                      <p className= "textBlackSedute" style={{paddingLeft:"30px", fontWeight: 'bold'}}> Totale Convenzioni, progetti speciali, ulteriori pratiche e documenti: € {Euro.format(calculateTotalCost(cards))}</p>                  
                  ): idSeduta.replaceAll("-","")<20260513 ?(              
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", fontWeight: 'bold'}}> Totale Progetti a impatto, trasversalità, protocolli quadro e altro: € {Euro.format(calculateTotalCost(cards))}</p>                  
                  ):
                  (
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", fontWeight: 'bold'}}> Totale Progetti di sviluppo, trasversalità, protocolli quadro e altro: € {Euro.format(calculateTotalCost(cards))}</p>                  
                  )
                  }
                </div>
                ):
                printable == 'FUORI SACCO' ?(
                  <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>                  
                  <p className= "textBlackSedute" style={{paddingLeft:"30px", fontWeight: 'bold'}}> Totale Fuori Sacco: € {Euro.format(calculateTotalCost(cards))}</p>                  
                </div>
                ):
                sector=='cultura' ||sector=='attrattivita' ||sector=='competenze'||sector=='custodia'||sector=='partecipazione' ? (
                  <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>                  
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%", fontWeight: 'bold'}}> Totale obiettivo: € {totaleObiettivi[0]}</p>
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%", fontWeight: 'bold'}}> Totale missione: € {Euro.format(calculateTotalCost(cards))}</p>                  
                  </div>
                  ):
                  sector=='persone'||sector=='abitare'||sector=='lavoro'||sector=='educazione'||sector=='comunita'||sector=='inclusione' ? (
                    <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>                  
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%",  fontWeight: 'bold'}}> Totale obiettivo: € {totaleObiettivi[1]}</p>
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%",  fontWeight: 'bold'}}> Totale missione: € {Euro.format(calculateTotalCost(cards))}</p>                  
                  </div>
                  ):                    
                  sector=='pianeta'||sector=='ricerca'||sector=='ambiente' ||sector=='benessere'||sector=='innovazione'||sector=='internazionalizzazione'||sector=='sviluppoTerritorio' ?(
                    <div style={{ display:'flex', marginBottom:"50px",paddingBottom:"20px", width:'100%',  backgroundColor:colorItemSelected, height:'50px'}}>                  
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%", fontWeight: 'bold'}}> Totale obiettivo: € {totaleObiettivi[2]}</p>
                    <p className= "textBlackSedute" style={{paddingLeft:"30px", width:"45%", fontWeight: 'bold'}}> Totale missione: € {Euro.format(calculateTotalCost(cards))}</p>                  
                    </div>):
                  (<></>)
                }

                {/* <img src={logo} className="App-logo" alt="logo" />  */}
                <IndexProvider>        
                <SortableContext.Provider value={{ openDialog, openMoveDialog, setItem, deleteItem,isBloccataMissione,isInteragibileMissione, isItemCoerente,isFuoriSacco,getFase,getVirtualNote,getDataSeduta, doPostRetrieveIdCard,doPostChangeSwitch,onFileChange2,handleUploadPremessaGSFClick,hiddenFileUploads,handleOpenClick,setAlert1 }}>          
                    <SortableTree
                        items={cards}                                                                      
                        //onItemsChanged={onChanged}
                        onItemsChanged={(newItems) => {
                          //console.log("EVAL", (isBloccataMissione()|| (getFase()==3 && !isFuoriSacco())||(getFase()==3 && (localStorage.getItem("ruolo")==4||localStorage.getItem("ruolo")=="10"||localStorage.getItem("ruolo")==12))));
                          if ((isBloccataMissione()|| (getFase()==3 && !isFuoriSacco())||(getFase()==3 && (localStorage.getItem("ruolo")==4||localStorage.getItem("ruolo")=="10"||localStorage.getItem("ruolo")==12)))==false ) {
                            onChanged(newItems);
                          }
                        }}
                        TreeItemComponent={TreeItem}                                 
                        indentationWidth="50"      
                        disableSorting={isBloccataMissione()|| (getFase()==3 && !isFuoriSacco())||(getFase()==3 && (localStorage.getItem("ruolo")==4||localStorage.getItem("ruolo")=="10"||localStorage.getItem("ruolo")==12))}
                    />                    
                    </SortableContext.Provider>
                </IndexProvider>
        </div>
    )}
    </div>
        </div>   
        )}
          <div>
        {alert1}        
        </div>
        </div>                
    );
  
    
};
export const useSortable = () => useContext(SortableContext);



const TreeItem = React.forwardRef((props, ref) => {    
    const [enabledWidget, setEnabledWidget] = useState(true);   
    const { openDialog, openMoveDialog, setItem, deleteItem,isBloccataMissione, doPostChangeSwitch, isInteragibileMissione, isItemCoerente, isFuoriSacco,getFase,getVirtualNote,getDataSeduta, doPostRetrieveIdCard,onFileChange2,handleUploadPremessaGSFClick,hiddenFileUploads,handleOpenClick,setAlert1 } = useSortable(); 
    const navigate = useNavigate();

    const formatDate = (dateStr) => {
      if (!dateStr) return "";
    
      const [year, month, day] = dateStr.split("-");
      return `${day}${month}${year}`;
    };
    
    //console.log("TEST");
    const handleChildClick = function(e,props) {     
      //if( properties.verboseLog==1)                  
        console.log("HCC",props.item);
      e.preventDefault();      
      setItem(props.item);      
      e.stopPropagation();    
      if( properties.verboseLog==1)
        console.log("HCC2",props.item);
      //openDialog(props.item.Tipo);                
      openDialog(props.item);                
      //console.log('handleChildClick', e,props.item, props.item.Tipo); //,selectedIndex);
      //console.log("BLOCCO?",isBloccataMissione());
    };

    function isValidNumberString(value) {
      return /^\d+(\.\d+)?$/.test(value);
    }

    const handleGenerateGSFClick = function(e,props) {  
      //props.item.Info="Perbacco";
      //console.log("VER",props.item);
      
      e.preventDefault();      
      //console.log("QUIZ1",e);
      console.log("QUIZ2", props.item.IdRichiesta);
      let dataSeduta=getDataSeduta();
      console.log("QUIZ3", dataSeduta);
      let faseSeduta=getFase();
      console.log("QUIZ4", faseSeduta);            
      let tbv=props.item.IdRichiesta;
      if(isValidNumberString(tbv)){
        console.log("PRIMA DI doPostRetrieveIdCard");
        doPostRetrieveIdCard(props.item, formatDateForPosting(dataSeduta), faseSeduta);
      }
      else{
        setAlert1(
          <SweetAlert
          warning
          closeOnClickOutside ={true}
          showCancel ={false}
          showConfirm={false}
          style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}
          
          title={"Il numero di pratica inserito non è corretto. Controllalo prima di riprovare!"}
          onConfirm={() => {             
            setAlert1(null);
          }}           
          onCancel={() => {
              setAlert1(null);                              
          }}                            
          confirmBtnCssClass="custom-btn custom-btn-success" 
          cancelBtnCssClass="custom-btn custom-btn-cancel"                                  
        >
        </SweetAlert>
        );     
      }
      
    };
    function formatDateForPosting(date) {
      const [year, month, day] = date.split("-");
      return `${day}${month}${year}`;
    }
    
    const handleMoveClick = function(e,props) {                 
      e.preventDefault();      
      setItem(props.item);      
      e.stopPropagation();    
      openMoveDialog(props.item.Tipo);                
      //console.log('handleMoveClick', e, props.item, props.item.Tipo); 
    };

    const handleDeleteClick = function(e,props) {                 
      e.preventDefault();      
      //console.log("QUI",props.item.id,props.item);
      setItem(props.item);      
      e.stopPropagation();    
      deleteItem(props.item.id);             
      //doPostTotaleObiettivi(sector);   
      //console.log('handleChildClick', e, props.item, props.item.Tipo); //,selectedIndex);
    };
  
    /*
    //let Euro = new Intl.NumberFormat('it-IT', {
      let Euro = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
    */
    let Euro = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return (
                 
      <SimpleTreeItemWrapper {...props} ref={ref} style={{ display: 'inherit', minWidth:window.innerWidth-500,width: '100%',textAlign:'left' }} >     
        {
        props.item.Tipo =='Pratica' ?(     
          //console.log(props.item.IpotesiDeliberata),
            <div style={{width:"100%"}}>
                <div style={{display:'flex', width:'100%', }}> <p className= "textBlackSedute" style={{paddingLeft:"10px",color:"black", marginTop:"10px",marginBottom:"10px", color: isItemCoerente(props.item) ? 'red' : 'black' }}> (Pratica 
                  {props.item.IdRichiesta !='' && props.item.IdRichiesta !='idRichiesta'  ?(
                  <>, {props.item.IdRichiesta}</>  ):(<></>)}) <b style={{marginLeft:"10px"}}> {props.item.Ente} </b></p>              
                  {props.item.Localizzazione !='' && props.item.Localizzazione !='Localizzazione'  ? (
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px", color: isItemCoerente(props.item) ? 'red' : 'black'}}>,  <b style={{marginLeft:"10px", textTransform:'capitalize', color: isItemCoerente(props.item) ? 'red' : 'black'}}> {props.item.Localizzazione} </b></p> ):(<></>)} 
                </div>
                <div style={{display:'flex',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px", whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> <b> {props.item.Descrizione} </b></p>              
                </div>           
                {
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)==parseFloat(props.item.IpotesiIntervento) && props.item.InfoDelibera!= undefined && props.item.InfoDelibera!= "" && props.item.InfoDelibera!= "Eventuali decisioni quali: Rinviata, Rigettata, etc." && props.item.IpotesiDeliberata!= 0?(
                //  console.log("TEST", "OK"),
                  <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px",color: 'black'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)} -&#62; € {Euro.format(props.item.IpotesiDeliberata)} - {props.item.InfoDelibera}</b></p>
                    {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                    {props.item.Note !='' && props.item.Note !='Note'  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'black'}}> * {props.item.Note}</p>  ):(<></>)}
                  </div>
                ):
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)==parseFloat(props.item.IpotesiIntervento) && props.item.InfoDelibera!= undefined && props.item.InfoDelibera!= "" && props.item.InfoDelibera!= "Eventuali decisioni quali: Rinviata, Rigettata, etc." && props.item.IpotesiDeliberata== 0?(
                //  console.log("TEST2", "OK"),
                  <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px",color: 'black'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)} -&#62; {props.item.InfoDelibera}</b></p>
                    {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                    {props.item.Note !='' && props.item.Note !='Note'  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'black'}}> * {props.item.Note}</p>  ):(<></>)}
                  </div>
                ):
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)!=parseFloat(props.item.IpotesiIntervento)&& props.item.InfoDelibera!= undefined && props.item.InfoDelibera!= "" && props.item.InfoDelibera!= "Eventuali decisioni quali: Rinviata, Rigettata, etc." && props.item.IpotesiDeliberata== 0 ? (
                 // console.log("TEST3", "OK"),
                  <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> 
                  <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}>
                    <span style={{color: 'red'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)}</b></span> 
                    <span style={{color: 'black'}}> <b>-&#62; </b></span> 
                    <span style={{color: 'green'}}> <b>{props.item.InfoDelibera}</b></span>
                  </p>
                  {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                  {props.item.Note !='' && props.item.Note !='Note'  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'red' }}> * {props.item.Note}</p>  ):(<></>)}
                </div>
                ):
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)!=parseFloat(props.item.IpotesiIntervento)&& props.item.InfoDelibera!= undefined && props.item.InfoDelibera!= "" && props.item.InfoDelibera!= "Eventuali decisioni quali: Rinviata, Rigettata, etc." && props.item.IpotesiDeliberata!= 0 ? (
                 // console.log("TEST4", "OK"),
                 <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> 
                  <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}>
                    <span style={{color: 'red'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)}</b></span> 
                    <span style={{color: 'black'}}> <b>-&#62; </b></span> 
                    <span style={{color: 'green'}}> <b>€ {Euro.format(props.item.IpotesiDeliberata)}</b></span>
                    <span style={{color: 'green'}}> <b>- {props.item.InfoDelibera}</b></span>
                  </p>
                  {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                  {props.item.Note !='' && props.item.Note !='Note'  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'red' }}> * {props.item.Note}</p>  ):(<></>)}
                </div>
                ):                
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)==parseFloat(props.item.IpotesiIntervento) && (props.item.InfoDelibera== undefined || props.item.InfoDelibera== "" || props.item.InfoDelibera== "Eventuali decisioni quali: Rinviata, Rigettata, etc.")?(
                //  console.log("TEST5", "OK"),
                  <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px",color: 'black'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)} -&#62; € {Euro.format(props.item.IpotesiDeliberata)}</b></p>
                    {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                    {props.item.Note !='' && props.item.Note !='Note'  ?(
                    <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'black'}}> * {props.item.Note}</p>  ):(<></>)}
                  </div>
                ): 
                getFase()==3 &&parseFloat(props.item.IpotesiDeliberata)!=parseFloat(props.item.IpotesiIntervento) && (props.item.InfoDelibera== undefined || props.item.InfoDelibera== "" || props.item.InfoDelibera== "Eventuali decisioni quali: Rinviata, Rigettata, etc.")? (
                 // console.log("TEST6", "OK",props.item.IpotesiDeliberata),
                  <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> 
                  <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px"}}>
                    <span style={{color: 'red'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)}</b></span> 
                    <span style={{color: 'black'}}> <b>-&#62; </b></span> 
                    <span style={{color: 'green'}}> <b>€ {Euro.format(props.item.IpotesiDeliberata)}</b></span>
                  </p>
                  {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                  {props.item.Note !='' && props.item.Note !='Note'  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: 'red' }}> * {props.item.Note}</p>  ):(<></>)}
                </div>
                ):
                (                  
                <div style={{display:'inline-block',marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px",color: isItemCoerente(props.item) ? 'red' : 'black'}}> <b>€ {Euro.format(props.item.IpotesiIntervento)} </b></p>                         
                {/**TODO: GESTIRE NOTE CALCOLATE...
                 * */}
                {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento) !=''  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {getVirtualNote(props.item.DynamicFields,props.item.IpotesiIntervento)}</p>  ):(<></>)}              
                
                {props.item.Note !='' && props.item.Note !='Note'  ?(
                  <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px",whiteSpace: 'pre-line', color: isItemCoerente(props.item) ? 'red' : 'black'}}> * {props.item.Note}</p>  ):(<></>)}              
                
                {props.item.ImportoProposto === undefined ? (
                  console.log("EHI",props.item),
                  <></>
                ):                
                props.item.ImportoProposto != undefined && Number(props.item.ImportoProposto) !== Number(props.item.IpotesiIntervento) ? (
                  <div style={{ display: "flex"}}>
                  <PriorityHighIcon  style={{ paddingTop:"10px", background: "#ffffff", color: "#F57C01" }}/>
                  <p style={{color:"#F57C01"}}>IMPORTO DIVERSO RISPETTO A QUANTO PRESENTE SU EROWEB</p>
                  </div>
                ): (
                  console.log("EHI2",props.item, Number(props.item.ImportoProposto),Number(props.item.IpotesiIntervento) ),
                  //console.log("DDD",props.item.ImportoProposto,props.item.IpotesiIntervento),
                  <></>
                )
                }
                </div>
                
                ) }     
            </div>
        ):
        props.item.Tipo =='Ambito'  ?(
            <div style={{display:'flex', width:'100%'}}> <p className= "textBlackSedute" style={{paddingLeft:"10px",color:"black", color: isItemCoerente(props.item) ? 'red' : 'black'}}>(Ambito) <b style={{marginLeft:"10px",color: isItemCoerente(props.item) ? 'red' : 'black'}}> {props.item.Descrizione} </b></p>           
            </div>
        ):
        props.item.Tipo =='Documento'  ?(
            <div style={{width:"100%"}}>
            <div style={{display:'flex', marginLeft:"10px", width:'100%'}}> <p className= "textBlackSedute" style={{marginTop:"10px",marginBottom:"10px", color: isItemCoerente(props.item) ? 'red' : 'black'}}>(Documento) <b style={{marginLeft:"10px",color: isItemCoerente(props.item) ? 'red' : 'black'}}>{props.item.Descrizione} </b>  </p>           
            </div>
            {props.item.Note !='' && props.item.Note !='Note' && props.item.Note !='Note Documento' ?(
            <div style={{display:'flex', marginLeft:"10px",width:'100%'}}>
            <p className= "textBlackSedute" style={{color:"black",marginTop:"10px",marginBottom:"10px",color: isItemCoerente(props.item) ? 'red' : 'black'}}><i >{props.item.Note}</i>  </p>           
            </div>):(
                <div></div>
            )
            }
            </div>
            
        ):      
        (<></>)
        }
        <div>
          <div style={{display:'flex',border: "0px solid #d3d3d3",}}>
            { (localStorage.getItem("ruolo")=="5" ||localStorage.getItem("ruolo")=="4") && isFuoriSacco()  ?(            
              //console.log("ORA"),
              <Tooltip title="Modifica" placement="top">                
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleChildClick(event,props)} >                    
                      <EditIcon  style={{ background: "#ffffff", color: "000000" }}/>                                                          
                  </IconButton>
                </span>
              </Tooltip>
            ):
              localStorage.getItem("ruolo")=="5" && !isFuoriSacco()?(          
                console.log("rr",isBloccataMissione(), getFase(), props.item.Tipo),  
                <Tooltip title="Modifica" placement="top">
                  <span>                    
                      {(isBloccataMissione() ||getFase()==3) && props.item.Tipo =='Ambito' ?(
                        //console.log("rr1", props.item.Tipo,getFase(), isBloccataMissione() ),  
                        <IconButton aria-label="delete" disabled={isInteragibileMissione() ||(getFase()==3 &&  (props.item.Tipo =='Ambito')) }>
                        <EditIcon  style={{ background: "#ffffff", color: "#dddddd" }}/>
                        </IconButton>
                      )
                      :
                      isInteragibileMissione() &&  props.item.Tipo =='Documento' ?(
                        //console.log("rr", props.item), 
                        //console.log("rr2", props.item),   
                        <IconButton aria-label="delete" onClick={(event)=>handleChildClick(event,props)}  disabled={isInteragibileMissione() }>
                        <EditIcon  style={{ background: "#ffffff", color: "#000000" }}/>
                        </IconButton>
                      ):
                      ( 
                        //console.log("rr3", props.item),  
                        <IconButton aria-label="delete" onClick={(event)=>handleChildClick(event,props)} disabled={isInteragibileMissione() }>
                        <EditIcon  style={{ background: "#ffffff", color: "#000000" }}/>
                        </IconButton>
                      )
                    }                      
                  </span>
                </Tooltip>
            ):
              localStorage.getItem("ruolo")=="12"||localStorage.getItem("ruolo")=="10" ?(
                <Tooltip title="Modifica" placement="top">
                <span>
                  <IconButton aria-label="delete" disabled={true}>                    
                      <EditIcon  style={{ background: "#ffffff", color: "dddddd" }}/>                                        
                  </IconButton>
                </span>
              </Tooltip>
              ):
              localStorage.getItem("ruolo")=="4" && (props.item.Tipo =='Documento' || props.item.Tipo =='Pratica' )?
              (        
              <Tooltip title="Modifica" placement="top">
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleChildClick(event,props)} disabled={isInteragibileMissione()} >                    
                  {isInteragibileMissione() ?(
                      <EditIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                    ):( 
                      <EditIcon  style={{ background: "#ffffff", color: "000000" }}/>
                     )}                    
                  </IconButton>
                </span>
              </Tooltip>
              )
              : (
                <Tooltip title="Modifica" placement="top">
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleChildClick(event,props)} disabled={isBloccataMissione()||getFase()==3} >
                    {isBloccataMissione()||getFase()==3 ?(
                      <EditIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                    ):( 
                      <EditIcon  style={{ background: "#ffffff", color: "000000" }}/>
                     )}                    
                  </IconButton>
                </span>
                </Tooltip> )
              }
               {localStorage.getItem("ruolo")=="5"||localStorage.getItem("ruolo")=="4" ?(
                <Tooltip title="Sposta" placement="top">
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleMoveClick(event,props)} disabled={isBloccataMissione()||getFase()==3}>
                    {isBloccataMissione() || getFase()==3 ?(
                      <SendIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                    ):(
                      <SendIcon  style={{ background: "#ffffff", color: "30720f" }}/>
                    )
                    }
                    
                  </IconButton>
                </span>
              </Tooltip>
               ):
               (
                <Tooltip title="Sposta" placement="top">
                  <span>
                    <IconButton aria-label="delete" disabled={true}>                    
                        <SendIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                    </IconButton>
                  </span>
                </Tooltip>
               )}
              {isFuoriSacco() && localStorage.getItem("ruolo")=="5"?(
               <Tooltip title="Elimina" placement="top">
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleDeleteClick(event,props)}>                                    
                    <DeleteIcon  style={{ background: "#ffffff", color: "BF2B0C" }}/>                  
                  </IconButton>        
                </span>
               </Tooltip>
               ):
               localStorage.getItem("ruolo")=="12"||localStorage.getItem("ruolo")=="10"?(
                <Tooltip title="Elimina" placement="top">
                 <span>
                   <IconButton aria-label="delete" disabled={true}>                                    
                     <DeleteIcon  style={{ background: "#ffffff", color: "dddddd" }}/>                  
                   </IconButton>        
                 </span>
                </Tooltip>
                ):
               isFuoriSacco() && localStorage.getItem("ruolo")=="4"?(
                <Tooltip title="Elimina" placement="top">
                 <span>
                   <IconButton aria-label="delete" disabled>                                    
                    <DeleteIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                   </IconButton>        
                 </span>
                </Tooltip>
                ):
               (
                <Tooltip title="Elimina" placement="top">
                <span>
                  <IconButton aria-label="delete" onClick={(event)=>handleDeleteClick(event,props)} disabled={isBloccataMissione() ||getFase()==3 }>
                  {isBloccataMissione() ||getFase()==3?(
                    <DeleteIcon  style={{ background: "#ffffff", color: "dddddd" }}/>
                  ):(
                    <DeleteIcon  style={{ background: "#ffffff", color: "BF2B0C" }}/>
                  )}
                  </IconButton>        
                </span>
              </Tooltip>
                )
              }
               
          </div>
          <div style={{width:"80px", }}>
          
          {/** 
          <Tooltip title="Prepara per Fascicolo di Comitato" placement="top">                   
          <Button variant="contained" color="success" startIcon={<OpenInNewIcon style={{color:"white"}} />} onClick={(event)=>handleGenerateGSFClick(event,props)} >
            COMITATO 
          </Button>
          </Tooltip>
          */}
         {/*
          <Box sx={{ display: "inline-flex", alignItems: "center", height: 36, border: enabledWidget ? "1px solid #30720F":"1px solid #9E9E9E",
            borderRadius: "18px", px: 0.75, gap: 0.2 }}>
            <Switch checked={enabledWidget} size="small" onChange={(e) => setEnabledWidget(e.target.checked)}
                color="#30720F" sx={{p: 0, width: 34, height: 20,
                    "& .MuiSwitch-switchBase": { p: 0.25 },
                    "& .MuiSwitch-thumb": { width: 14, height: 14 },
                    "& .MuiSwitch-switchBase.Mui-checked": { color: "#30720F" },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#30720F"},
        
                }}/>
            <Box sx={{fontSize: 11, fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap",
                color: enabledWidget ? "text.primary" : "text.disabled"}}>
                COMITATO
            </Box>
            <Tooltip title="Prepara per Fascicolo di Comitato" placement="top">          
              <IconButton size="small" onClick={(event) => handleGenerateGSFClick(event, props)}
                  disabled={!enabledWidget} sx={{ p: 0.2, color: "#30720F" }} >
                  <OpenInNewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
          */}
          {   props.item.Tipo =='Pratica' && (getFase()==2||getFase()==1)? (
        <Box sx={{ display: "inline-flex", flexDirection: "column", border: props.item.StatoPraticaBloccata ? "1px solid #30720F":"1px solid #9E9E9E",
            borderRadius: "18px", px: 0.75, py:0.4, gap: 0.2 }}>
            <Box sx={{ display: "flex", alignItems: "center", height: 36, gap: 0.2 }}>
                <Switch checked={props.item?.DaInserireInFascicolo !== false} size="small" onChange={(e) => doPostChangeSwitch(props.item)}
                    disabled={props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true }
                    color="#30720F" sx={{p: 0, width: 34, height: 20,
                        "& .MuiSwitch-switchBase": { p: 0.25 },
                        "& .MuiSwitch-thumb": { width: 14, height: 14 },
                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#30720F" },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#30720F"},
            
                    }}/>
                <Box sx={{fontSize: 11, fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap",
                    color: props.item?.DaInserireInFascicolo ? "text.primary" : "text.disabled"
                    //color: props.item?.DaInserireInFascicolo == false ?  "text.disabled" : 
                    //props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true ?  "#000000": "#F57C00"
                    }}>
                    COMITATO
                </Box>
                <Tooltip title="Prepara per Fascicolo di Comitato" placement="top">          
                  <IconButton size="small" onClick={(event) => handleGenerateGSFClick(event, props)}
                      disabled={isBloccataMissione()||props.item?.DaInserireInFascicolo == false}
                       sx={{ p: 0.2, color: "#30720F" }} >
                      <OpenInNewIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, pl: 0.5}}>
              {props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true ? (
                   <LockIcon sx={{ fontSize:"18" , color: props.item?.DaInserireInFascicolo !== false ? "#30720F": "text.disabled" }} />                
              ) : (
                  <DriveFileRenameOutlineIcon sx={{ fontSize: "18", color: props.item?.DaInserireInFascicolo !== false ? "#F57C00": "text.disabled" }} />
              )}
                <Box sx={{ fontSize: 11, fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap", 
                //color: props.item?.DaInserireInFascicolo !== false ? "#000000" : "text.disabled"
                color: props.item?.DaInserireInFascicolo == false ?  "text.disabled" : 
                  props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true ?  "#000000": "#F57C00"
                }}>
                  {props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true ? "PRONTA": "IN MODIFICA"}
                </Box>
            </Box>
        </Box> ):
         props.item.Tipo =='Documento' && (getFase()==2||getFase()==1) ? (
          <Box sx={{ display: "inline-flex", flexDirection: "column", border: props.item.StatoPraticaBloccata ? "1px solid #30720F":"1px solid #9E9E9E",
            borderRadius: "18px", px: 0.75, py:0.4, gap: 0.2 }}>
            <Box sx={{ display: "flex", alignItems: "center", height: 36, gap: 0.2 }}>
                <Switch checked={props.item?.DaInserireInFascicolo !== false} size="small" onChange={(e) => doPostChangeSwitch(props.item)}
                    disabled={props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true }
                    color="#30720F" sx={{p: 0, width: 34, height: 20,
                        "& .MuiSwitch-switchBase": { p: 0.25 },
                        "& .MuiSwitch-thumb": { width: 14, height: 14 },
                        "& .MuiSwitch-switchBase.Mui-checked": { color: "#30720F" },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#30720F"},
                    }}/>
                <Box sx={{fontSize: 11, fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap",
                    color: props.item?.DaInserireInFascicolo ? "text.primary" : "text.disabled"
                    //color: props.item?.DaInserireInFascicolo == false ?  "text.disabled" : 
                    //props.item?.StatoPraticaBloccata=='true' || props.item?.StatoPraticaBloccata==true ?  "#000000": "#F57C00"
                    }}>
                    COMITATO
                </Box>
                <input type="file" name="file" //ref={hiddenFileUpload}
                      ref={(el) => (hiddenFileUploads.current[props.item.id] = el)}
                      onChange={(event) =>onFileChange2(event,props)} style={{ display: "none" }} />                         
                <Tooltip title="Carica/Aggiorna documento per Fascicolo di Comitato" placement="top">          
                  <IconButton size="small" onClick={(event) => handleUploadPremessaGSFClick(event, props)}
                      //disabled={props.item?.DaInserireInFascicolo == false}
                      disabled={isBloccataMissione()||props.item?.DaInserireInFascicolo == false}
                       sx={{ p: 0.2, color: "#30720F" }} >
                      <FileUploadIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
            </Box>
            
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, pl: 0.5}}>
              {props.item?.filePath!='' && props.item?.filePath!=undefined ? (                   
                   <Tooltip title="Apri il file caricato" placement="top">  
                      <IconButton size="small" onClick={(event) => handleOpenClick(event, props)}
                          disabled={props.item?.DaInserireInFascicolo == false}
                          sx={{ p: 0.2, color: "#30720F" }} >
                        <OpenInNewIcon fontSize="small" />                
                       </IconButton>                                      
                   </Tooltip>                            
                   ) : (
                  <WarningAmberIcon sx={{ fontSize: "18", color: props.item?.DaInserireInFascicolo !== false ? "#F57C00": "text.disabled" }} />
              )}
                <Box sx={{ fontSize: 11, fontWeight: 600, lineHeight: 1, whiteSpace: "nowrap",                 
                color: props.item?.DaInserireInFascicolo == false ?  "text.disabled" : 
                  props.item?.filePath!='' && props.item?.filePath!=undefined  ?  "#000000": "#F57C00"
                }}>
                  {props.item?.filePath!='' && props.item?.filePath!=undefined  ? "PRONTO": "DA CARICARE"}
                </Box>
            </Box>


            </Box>

          ):
          (
          <></>
        )}

          </div>
      </div>
      </SimpleTreeItemWrapper>
      
    );
  });